/**
 * Generated by orval 🍺
 * Do not edit manually.
 * @ijoin/hooks
 * react-query hooks for interacting with @ijoin/server
 */ import { queryOptions as queryOptionsBuilder, useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { client } from "./client";
export const AdvisoryOrganizationsPaymentMethod = {
    ACH_DIRECT_DEPOSIT: 'ACH_DIRECT_DEPOSIT',
    CHECK_NON_PARTICIPANT: 'CHECK_NON_PARTICIPANT'
};
export const RecordKeepingOrganizationsBillingFrequency = {
    monthly: 'monthly',
    quarterly: 'quarterly'
};
export const ApiKeysEntityType = {
    advisoryOrganization: 'advisoryOrganization',
    annuityCarrier: 'annuityCarrier',
    thirdParty: 'thirdParty',
    recordKeeper: 'recordKeeper',
    rolloverProvider: 'rolloverProvider'
};
export const FidelityCarrierContractsCarrier = {
    NYL: 'NYL',
    NW: 'NW'
};
export const ApiKeysStatus = {
    active: 'active',
    expired: 'expired',
    revoked: 'revoked'
};
export const ParticipantRKTransactionsDataSourceType = {
    file: 'file',
    soap: 'soap'
};
export const ParticipantAppsStatus = {
    incomplete: 'incomplete',
    pendingExchange: 'pendingExchange',
    available: 'available',
    acknowledged: 'acknowledged',
    submitted: 'submitted',
    failed: 'failed'
};
export const AppType = {
    income_activation: 'income_activation',
    ira_account_opening: 'ira_account_opening',
    manifest: 'manifest'
};
export const BatchUpdateDtoField = {
    canIraProspect: 'canIraProspect',
    exploreHsaCalculator: 'exploreHsaCalculator',
    exploreRothConversionCalculator: 'exploreRothConversionCalculator',
    hasManifest: 'hasManifest'
};
export const BatchUpdateDtoType = {
    plan: 'plan',
    user: 'user'
};
export const BulkUpsertAdvisorResultResStatus = {
    created: 'created',
    failed: 'failed',
    partial: 'partial',
    updated: 'updated'
};
export const CampaignDetailMessageResStatus = {
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Pending: 'Pending',
    Queued: 'Queued',
    Scheduled: 'Scheduled',
    SentLate: 'SentLate',
    SentOnTime: 'SentOnTime'
};
export const CampaignMessageRowResStatus = {
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Pending: 'Pending',
    Queued: 'Queued',
    Scheduled: 'Scheduled',
    SentLate: 'SentLate',
    SentOnTime: 'SentOnTime'
};
export const CampaignRowResStatus = {
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Pending: 'Pending',
    Queued: 'Queued',
    Scheduled: 'Scheduled',
    SentLate: 'SentLate',
    SentOnTime: 'SentOnTime'
};
export const CreateAdminBodyUserType = {
    CONTROL_PANEL: 'CONTROL_PANEL',
    METRICS_DASHBOARD: 'METRICS_DASHBOARD'
};
export const CronJobScheduleType = {
    cron: 'cron',
    interval: 'interval'
};
export const DbInsightsTableType = {
    BASE_TABLE: 'BASE TABLE',
    VIEW: 'VIEW'
};
export const DriftFindingSeverity = {
    critical: 'critical',
    high: 'high',
    low: 'low',
    medium: 'medium'
};
export const EmbedType = {
    'goal-projection': 'goal-projection',
    'managed-account': 'managed-account',
    'post-enrollment-managed': 'post-enrollment-managed',
    'social-security-calculator': 'social-security-calculator'
};
export const FidelityAnnuityApplicationsAnnuityType = {
    single: 'single',
    joint: 'joint'
};
export const FidelityCarrierContractsTaxType = {
    preTax: 'preTax',
    roth: 'roth'
};
export const LoginHealthRowResIssueCode = {
    accountLinkWithoutLogin: 'accountLinkWithoutLogin',
    accountWithoutLogin: 'accountWithoutLogin',
    loginWithoutAccount: 'loginWithoutAccount',
    refWithoutAccount: 'refWithoutAccount'
};
export const PlanValidationIssueResIssueCode = {
    enrollmentMissingParticipant: 'enrollmentMissingParticipant',
    iveMissingEnrollment: 'iveMissingEnrollment',
    iveMissingVehicle: 'iveMissingVehicle',
    missingMatchTier: 'missingMatchTier',
    noFunds: 'noFunds',
    noInvestmentVehicle: 'noInvestmentVehicle',
    orphanedInvestmentVehicle: 'orphanedInvestmentVehicle',
    pathMissingFund: 'pathMissingFund',
    pathMissingVehicle: 'pathMissingVehicle',
    planMissingMetadata: 'planMissingMetadata'
};
export const GetEnvResEnv = {
    dev: 'dev',
    local: 'local',
    prod: 'prod',
    qa: 'qa',
    test: 'test',
    uat: 'uat'
};
export const GetFidelityAnnuityApplicationResStatus = {
    incomplete: 'incomplete',
    submitted: 'submitted',
    failed: 'failed',
    expired: 'expired',
    draft: 'draft',
    exchangeSubmitted: 'exchangeSubmitted',
    exchangeConfirmed: 'exchangeConfirmed',
    distributionSubmitted: 'distributionSubmitted',
    distributionConfirmed: 'distributionConfirmed',
    carrierProcessing: 'carrierProcessing',
    complete: 'complete',
    cancelled: 'cancelled'
};
export const GetFullPlanEnrollmentResMode = {
    annexus: 'annexus',
    annexusManaged: 'annexusManaged',
    annexusVoluntary: 'annexusVoluntary',
    annuity: 'annuity',
    annuitySelfDirected: 'annuitySelfDirected',
    default: 'default'
};
export const GetIraApplicationStatusRespDataItemApplicationStatus = {
    Complete: 'Complete',
    Failed_KYC: 'Failed KYC',
    Incomplete: 'Incomplete',
    KYC_In_Review: 'KYC In Review'
};
export const IraProspectsProspectType = {
    Analysis_Completed: 'Analysis_Completed',
    Archived: 'Archived',
    Awaiting_Analysis: 'Awaiting_Analysis',
    Contacted: 'Contacted',
    Converted: 'Converted',
    Identified: 'Identified',
    In_Review: 'In_Review',
    Pending_Rollover: 'Pending_Rollover'
};
export const OutsideAccountCategory = {
    ESOP: 'ESOP',
    ESPP: 'ESPP',
    FSA: 'FSA',
    GOVT_BONDS: 'GOVT_BONDS',
    HSA: 'HSA',
    IRA: 'IRA',
    KEOGH_PLAN: 'KEOGH_PLAN',
    MONEY_MARKET: 'MONEY_MARKET',
    MONTHLY_PENSION: 'MONTHLY_PENSION',
    NON_QUALIFIED_BROKERAGE: 'NON_QUALIFIED_BROKERAGE',
    PLAN_401A: 'PLAN_401A',
    PLAN_401K: 'PLAN_401K',
    PLAN_403B: 'PLAN_403B',
    PLAN_457: 'PLAN_457',
    PROFIT_SHARING: 'PROFIT_SHARING'
};
export const ParticipantAppsAppType = {
    manifest: 'manifest',
    ira_account_opening: 'ira_account_opening',
    income_activation: 'income_activation'
};
export const GetPlanEnrollmentIveResAccountType = {
    Combo: 'Combo',
    Roth: 'Roth',
    Traditional: 'Traditional'
};
export const PlansAnnuityTransDataSourceType = {
    file: 'file',
    soap: 'soap'
};
export const SSOErrorsErrorType = {
    ACCOUNT_ID_MISMATCH: 'ACCOUNT_ID_MISMATCH',
    MISSING_TOKEN: 'MISSING_TOKEN',
    NO_SSO_CONFIG: 'NO_SSO_CONFIG',
    NOT_ENROLLED_IN_PLAN: 'NOT_ENROLLED_IN_PLAN',
    OIDC_HANDSHAKE_FAILED: 'OIDC_HANDSHAKE_FAILED',
    PARTICIPANT_INFO_MISMATCH: 'PARTICIPANT_INFO_MISMATCH',
    PARTICIPANT_NOT_FOUND: 'PARTICIPANT_NOT_FOUND',
    PLAN_NOT_IN_SYSTEM: 'PLAN_NOT_IN_SYSTEM',
    RECORDKEEPER_ERROR: 'RECORDKEEPER_ERROR',
    RECORDKEEPER_TIMEOUT: 'RECORDKEEPER_TIMEOUT',
    SAML_VALIDATION_FAILED: 'SAML_VALIDATION_FAILED',
    UNKNOWN: 'UNKNOWN',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    WRONG_INTEGRATION_TYPE: 'WRONG_INTEGRATION_TYPE'
};
export const GoalProjectionDataGender = {
    F: 'F',
    M: 'M'
};
export const GoalProjectionDataMaritalStatus = {
    M: 'M',
    S: 'S'
};
export const GoalProjectionDataPlanType = {
    '401k': '401k',
    '401k_plan': '401k plan',
    '401k_plan_with_roth': '401k plan with roth',
    '401k-roth': '401k-roth',
    '403b': '403b',
    '403(b)': '403(b)',
    '403(b)_plan': '403(b) plan',
    '403(b)_plan_with_roth': '403(b) plan with roth',
    '403(b)-roth': '403(b)-roth',
    '403b-roth': '403b-roth',
    NUMBER_457: '457',
    '457_non_governmental_plan_defined_contribution': '457 non governmental plan defined contribution',
    '457_non_governmental_plan_defined_contribution_with_roth': '457 non governmental plan defined contribution with roth',
    '457_plan': '457 plan',
    '457_plan_with_roth': '457 plan with roth',
    '457-roth': '457-roth',
    other_defined_contribution: 'other defined contribution',
    other_defined_contribution_with_roth: 'other defined contribution with roth'
};
export const GoalProjectionDataStateOfResidency = {
    AK: 'AK',
    AL: 'AL',
    AR: 'AR',
    AZ: 'AZ',
    CA: 'CA',
    CO: 'CO',
    CT: 'CT',
    DC: 'DC',
    DE: 'DE',
    FL: 'FL',
    GA: 'GA',
    HI: 'HI',
    IA: 'IA',
    ID: 'ID',
    IL: 'IL',
    IN: 'IN',
    KS: 'KS',
    KY: 'KY',
    LA: 'LA',
    MA: 'MA',
    MD: 'MD',
    ME: 'ME',
    MI: 'MI',
    MN: 'MN',
    MO: 'MO',
    MS: 'MS',
    MT: 'MT',
    NC: 'NC',
    ND: 'ND',
    NE: 'NE',
    NH: 'NH',
    NJ: 'NJ',
    NM: 'NM',
    NV: 'NV',
    NY: 'NY',
    OH: 'OH',
    OK: 'OK',
    OR: 'OR',
    PA: 'PA',
    RI: 'RI',
    SC: 'SC',
    SD: 'SD',
    TN: 'TN',
    TX: 'TX',
    UT: 'UT',
    VA: 'VA',
    VT: 'VT',
    WA: 'WA',
    WI: 'WI',
    WV: 'WV',
    WY: 'WY'
};
export const GoalProjectionDataStateOfRetirement = {
    AK: 'AK',
    AL: 'AL',
    AR: 'AR',
    AZ: 'AZ',
    CA: 'CA',
    CO: 'CO',
    CT: 'CT',
    DC: 'DC',
    DE: 'DE',
    FL: 'FL',
    GA: 'GA',
    HI: 'HI',
    IA: 'IA',
    ID: 'ID',
    IL: 'IL',
    IN: 'IN',
    KS: 'KS',
    KY: 'KY',
    LA: 'LA',
    MA: 'MA',
    MD: 'MD',
    ME: 'ME',
    MI: 'MI',
    MN: 'MN',
    MO: 'MO',
    MS: 'MS',
    MT: 'MT',
    NC: 'NC',
    ND: 'ND',
    NE: 'NE',
    NH: 'NH',
    NJ: 'NJ',
    NM: 'NM',
    NV: 'NV',
    NY: 'NY',
    OH: 'OH',
    OK: 'OK',
    OR: 'OR',
    PA: 'PA',
    RI: 'RI',
    SC: 'SC',
    SD: 'SD',
    TN: 'TN',
    TX: 'TX',
    UT: 'UT',
    VA: 'VA',
    VT: 'VT',
    WA: 'WA',
    WI: 'WI',
    WV: 'WV',
    WY: 'WY'
};
export const IncomeActivationBankAccountBodyAccountType = {
    checking: 'checking',
    savings: 'savings'
};
export const LeafHouseCategoryEnum = {
    Commodities: 'Commodities',
    Commodities_Broad_Basket: 'Commodities Broad Basket',
    Diversified_Emerging_Markets: 'Diversified Emerging Markets',
    Emerging_Markets_Bond: 'Emerging Markets Bond',
    Emerging_Markets_Equity: 'Emerging Markets Equity',
    Foreign_Large_Blend: 'Foreign Large Blend',
    Foreign_Large_Growth: 'Foreign Large Growth',
    Foreign_Large_Value: 'Foreign Large Value',
    Global_Real_Estate: 'Global Real Estate',
    Guaranteed: 'Guaranteed',
    High_Yield_Bond: 'High Yield Bond',
    Inflation_Protected_Bond: 'Inflation Protected Bond',
    Intermediate_Core_Bond: 'Intermediate Core Bond',
    Intermediate_Core_Plus_Bond: 'Intermediate Core Plus Bond',
    'Intermediate_Core-Plus_Bond': 'Intermediate Core-Plus Bond',
    Large_Blend: 'Large Blend',
    Large_Cap_Blend: 'Large Cap Blend',
    Large_Cap_Growth: 'Large Cap Growth',
    Large_Cap_Value: 'Large Cap Value',
    Large_Growth: 'Large Growth',
    Large_Value: 'Large Value',
    Long_Term_Bond: 'Long Term Bond',
    Mid_Blend: 'Mid Blend',
    Mid_Cap_Blend: 'Mid Cap Blend',
    Mid_Cap_Growth: 'Mid Cap Growth',
    Mid_Cap_Value: 'Mid Cap Value',
    Mid_Growth: 'Mid Growth',
    Mid_Value: 'Mid Value',
    Money_Market: 'Money Market',
    Money_Market_Taxable: 'Money Market Taxable',
    Private_Debt: 'Private Debt',
    Real_Estate: 'Real Estate',
    Short_Duration_Bond: 'Short Duration Bond',
    Short_Term_Bond: 'Short Term Bond',
    Small_Blend: 'Small Blend',
    Small_Cap_Blend: 'Small Cap Blend',
    Small_Cap_Growth: 'Small Cap Growth',
    Small_Cap_Value: 'Small Cap Value',
    Small_Growth: 'Small Growth',
    Small_Value: 'Small Value',
    Stable_Value: 'Stable Value',
    Stable_Value_Fund: 'Stable Value Fund',
    US_REIT: 'US REIT'
};
export const LeafHouseModelKeyEnum = {
    BLKRK1: 'BLKRK1',
    CPGTD1: 'CPGTD1',
    FKGOE1: 'FKGOE1',
    IJN001: 'IJN001'
};
export const LeafHouseRiskEnum = {
    Agg: 'Agg',
    Con: 'Con',
    Mod: 'Mod',
    ModAgg: 'ModAgg',
    ModCon: 'ModCon'
};
export const ParticipantHealthRequestDtoAssetAllocation = {
    Aggressive: 'Aggressive',
    Balanced: 'Balanced',
    Conservative: 'Conservative',
    Managed_Account: 'Managed Account',
    Target_Date: 'Target Date'
};
export const PatchAnnuitizationResultResOutcome = {
    updated: 'updated',
    notFound: 'notFound',
    rejected: 'rejected'
};
export const PatchAnnuitizationsBodyStatus = {
    acknowledged: 'acknowledged',
    submitted: 'submitted'
};
export const PatchManagedAccountParticipantBodyEntryExitTypeCode = {
    A: 'A',
    D: 'D',
    O: 'O',
    P: 'P',
    V: 'V'
};
export const PatchPlanEnrollmentBodyIveRecalculationReason = {
    CONFIRM_FINANCIALS: 'CONFIRM_FINANCIALS',
    OUTSIDE_ACCOUNTS: 'OUTSIDE_ACCOUNTS'
};
export const PatchTcgParticipantBankingFundingBodyFrequency = {
    M: 'M',
    O: 'O'
};
export const PatchTcgPaticipantBankingBodyBankAccountHolder = {
    O: 'O',
    P: 'P'
};
export const PatchTcgPaticipantBankingBodyBankAccountType = {
    C: 'C',
    S: 'S'
};
export const PimcoIgpsReqDtoPercentOrDollar = {
    Dollar: 'Dollar',
    Percent: 'Percent'
};
export const PimcoIgpsReqDtoPreTaxDeferralDollarsFrequency = {
    NUMBER_52: 52,
    NUMBER_26: 26,
    NUMBER_24: 24,
    NUMBER_12: 12
};
export const PimcoIgpsReqDtoRothDeferralDollarsFrequency = {
    NUMBER_52: 52,
    NUMBER_26: 26,
    NUMBER_24: 24,
    NUMBER_12: 12
};
export const PostAdminReliusConsoleBodyMethod = {
    GetEEData: 'GetEEData',
    GetEEList: 'GetEEList',
    GetPlanData: 'GetPlanData',
    GetLoanData: 'GetLoanData',
    GetContributionData: 'GetContributionData',
    GetVersion: 'GetVersion',
    GetTableData: 'GetTableData',
    GetPlanStatistics: 'GetPlanStatistics',
    GetLoanAvailAmt: 'GetLoanAvailAmt',
    GetDistrAvailAmt: 'GetDistrAvailAmt'
};
export const PostAdminReliusConsoleBodyService = {
    basic: 'basic',
    reporting: 'reporting',
    trans: 'trans'
};
export const PostEmbedNonMapCoreCalcBodyRorScenario = {
    Choose_Myself: 'Choose Myself',
    Default: 'Default',
    Help_Me_Choose: 'Help Me Choose'
};
export const PostEmbedTokenBodyEmbedType = {
    'goal-projection': 'goal-projection',
    'managed-account': 'managed-account',
    'post-enrollment-managed': 'post-enrollment-managed',
    'social-security-calculator': 'social-security-calculator'
};
export const PostExternalMetricsMigrationSelectionField = {
    total: 'total',
    withBalance: 'withBalance'
};
export const PostExternalMetricsMigrationSelectionSource = {
    PLANSTATISTICS: 'PLANSTATISTICS',
    WEBRPTPLAN: 'WEBRPTPLAN'
};
export const PostTcgParticipantBankingBodyBankAccountHolder = {
    O: 'O',
    P: 'P'
};
export const PostTcgParticipantBankingBodyBankAccountType = {
    C: 'C',
    S: 'S'
};
export const PostTcgParticipantBankingFundingBodyFrequency = {
    M: 'M',
    O: 'O'
};
export const QueueResWorstHealth = {
    success: 'success',
    error: 'error',
    idle: 'idle',
    warning: 'warning'
};
export const TuningHintCode = {
    backlogGrowing: 'backlogGrowing',
    fairnessActive: 'fairnessActive',
    idleNoHits: 'idleNoHits',
    lowThroughput: 'lowThroughput',
    saturatedNoBacklog: 'saturatedNoBacklog'
};
export const TuningHintSeverity = {
    info: 'info',
    warning: 'warning'
};
export const ReliusConsoleFunctionResService = {
    basic: 'basic',
    reporting: 'reporting',
    trans: 'trans'
};
export const ResetPasswordBodyMode = {
    direct: 'direct',
    email: 'email',
    link: 'link'
};
export const RkTransactionType = {
    NUMBER_14: '14',
    NUMBER_17: '17',
    NUMBER_01: '01',
    NUMBER_07: '07',
    NUMBER_02: '02',
    NUMBER_03: '03',
    NUMBER_05: '05',
    NUMBER_09: '09',
    NUMBER_10: '10',
    NUMBER_11: '11',
    NUMBER_12: '12'
};
export const SsoErrorSortDir = {
    asc: 'asc',
    desc: 'desc'
};
export const SsoErrorSortField = {
    clearedByDate: 'clearedByDate',
    clearedByName: 'clearedByName',
    createdAt: 'createdAt',
    errorType: 'errorType',
    firstName: 'firstName',
    lastName: 'lastName'
};
export const StaticOptionType = {
    'auto-increase-frequency-types': 'auto-increase-frequency-types',
    'beneficiary-relationship-types': 'beneficiary-relationship-types',
    'beneficiary-types': 'beneficiary-types',
    'employment-status-types': 'employment-status-types',
    'enrollment-origin-types': 'enrollment-origin-types',
    'enrollment-strategies-types': 'enrollment-strategies-types',
    'finicity-account-types': 'finicity-account-types',
    'integration-types': 'integration-types',
    'investment-vehicle-contribution-unit-types': 'investment-vehicle-contribution-unit-types',
    'marital-status': 'marital-status',
    'outside-account-categories': 'outside-account-categories',
    'outside-account-types': 'outside-account-types',
    'plan-participation-status-types': 'plan-participation-status-types',
    'presentation-types': 'presentation-types'
};
export const TcgBankingDetailsListItemResBankAccountHolder = {
    O: 'O',
    P: 'P'
};
export const TcgBankingDetailsListItemResBankAccountType = {
    C: 'C',
    S: 'S'
};
export const TcgBankingDetailsResBankAccountHolder = {
    O: 'O',
    P: 'P'
};
export const TcgBankingDetailsResBankAccountType = {
    C: 'C',
    S: 'S'
};
export const TcgParticipantBankingFundingResFrequency = {
    M: 'M',
    O: 'O'
};
export const UpdateIraProspectsBodyProspectType = {
    Archived: 'Archived',
    Awaiting_Analysis: 'Awaiting Analysis'
};
export const UploadAssetBodyContentType = {
    'image/gif': 'image/gif',
    'image/jpeg': 'image/jpeg',
    'image/png': 'image/png',
    'image/webp': 'image/webp'
};
export const GetAdminActivityDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminActivitySort = {
    firstName: 'firstName',
    jobEndDateTime: 'jobEndDateTime',
    jobStartDateTime: 'jobStartDateTime',
    jobStatusCode: 'jobStatusCode',
    lastName: 'lastName',
    planName: 'planName',
    queueDateTime: 'queueDateTime',
    taskTypeId: 'taskTypeId'
};
export const GetAdminAdvisoryOrganizationsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminAdvisoryOrganizationsSort = {
    city: 'city',
    createdAt: 'createdAt',
    name: 'name',
    state: 'state',
    updatedAt: 'updatedAt'
};
export const GetAdminAdvisoryOrgActivityDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminAdvisoryOrgActivitySort = {
    firstName: 'firstName',
    jobEndDateTime: 'jobEndDateTime',
    jobStartDateTime: 'jobStartDateTime',
    jobStatusCode: 'jobStatusCode',
    lastName: 'lastName',
    planName: 'planName',
    queueDateTime: 'queueDateTime',
    taskTypeId: 'taskTypeId'
};
export const GetAdminAdvisoryOrgAdvisorsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminAdvisoryOrgAdvisorsSort = {
    email: 'email',
    firstName: 'firstName',
    hasAllPlans: 'hasAllPlans',
    lastName: 'lastName'
};
export const GetAdminPlansDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminPlansSort = {
    activatedAt: 'activatedAt',
    createdAt: 'createdAt',
    description: 'description',
    updatedAt: 'updatedAt'
};
export const GetAdminAdvisoryOrgRecordKeeperExportQueuesDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminAdvisoryOrgRecordKeeperExportQueuesSort = {
    firstName: 'firstName',
    jobStatus: 'jobStatus',
    lastName: 'lastName',
    processedDateTime: 'processedDateTime',
    queueDateTime: 'queueDateTime',
    scheduledReleaseDateTime: 'scheduledReleaseDateTime',
    systemTask: 'systemTask'
};
export const GetAnnuityCarrierExportsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAnnuityCarrierExportsFileIdentifierStatus = {
    missing: 'missing',
    present: 'present'
};
export const GetAnnuityCarrierExportsIsProcessed = {
    true: 'true',
    false: 'false'
};
export const GetAnnuityCarrierExportsIsRoth = {
    true: 'true',
    false: 'false'
};
export const GetAnnuityCarrierExportsSentToCarrierStatus = {
    missing: 'missing',
    present: 'present'
};
export const GetAnnuityCarrierExportsSort = {
    createdAt: 'createdAt',
    id: 'id',
    postDate: 'postDate',
    sentToCarrierDate: 'sentToCarrierDate',
    totalTransAmt: 'totalTransAmt'
};
export const GetAnnuityCarrierTransactionsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAnnuityCarrierTransactionsSort = {
    id: 'id',
    postDate: 'postDate',
    reversalIndicator: 'reversalIndicator',
    totalDollarAmt: 'totalDollarAmt',
    transTypeCode: 'transTypeCode'
};
export const GetAdminApiKeysDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminApiKeysSort = {
    createdAt: 'createdAt',
    entityType: 'entityType',
    expiresAt: 'expiresAt',
    lastUsedAt: 'lastUsedAt',
    name: 'name',
    status: 'status'
};
export const GetAdminAutoForceOutsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminAutoForceOutsSort = {
    createdAt: 'createdAt',
    distributionStatus: 'distributionStatus',
    firstName: 'firstName',
    lastName: 'lastName',
    liquidationDate: 'liquidationDate',
    plan: 'plan',
    responseDeadline: 'responseDeadline',
    updatedAt: 'updatedAt'
};
export const GetAdminCampaignMessagesStatusItem = {
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Pending: 'Pending',
    Queued: 'Queued',
    Scheduled: 'Scheduled',
    SentLate: 'SentLate',
    SentOnTime: 'SentOnTime'
};
export const GetAdminCampaignMessagesDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminCampaignMessagesSort = {
    campaignName: 'campaignName',
    processedAt: 'processedAt',
    sendAt: 'sendAt',
    status: 'status',
    subject: 'subject'
};
export const GetAdminCampaignsStatusItem = {
    Cancelled: 'Cancelled',
    Failed: 'Failed',
    Pending: 'Pending',
    Queued: 'Queued',
    Scheduled: 'Scheduled',
    SentLate: 'SentLate',
    SentOnTime: 'SentOnTime'
};
export const GetAdminCampaignsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminCampaignsSort = {
    lastSendAt: 'lastSendAt',
    messagesCount: 'messagesCount',
    name: 'name',
    nextSendAt: 'nextSendAt',
    status: 'status'
};
export const GetAdminCampaignParticipantsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminCampaignParticipantsSort = {
    email: 'email',
    fullName: 'fullName',
    planDescription: 'planDescription'
};
export const GetAdminFlywayMigrationsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminFlywayMigrationsSort = {
    description: 'description',
    execution_time: 'execution_time',
    installed_by: 'installed_by',
    installed_on: 'installed_on',
    installed_rank: 'installed_rank',
    script: 'script',
    success: 'success',
    version: 'version'
};
export const GetAdminFlywayMigrationsStatus = {
    failed: 'failed',
    success: 'success'
};
export const GetAdminIntegrationsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminIntegrationsSort = {
    createdAt: 'createdAt',
    description: 'description',
    updatedAt: 'updatedAt'
};
export const GetAdminLoginsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminLoginsSort = {
    createdAt: 'createdAt',
    firstName: 'firstName',
    lastName: 'lastName',
    updatedAt: 'updatedAt',
    username: 'username'
};
export const GetAdminParticipantsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminParticipantsSort = {
    advisoryOrganizationName: 'advisoryOrganizationName',
    age: 'age',
    annualSalary: 'annualSalary',
    cellPhone: 'cellPhone',
    currentPostTaxContributionDollars: 'currentPostTaxContributionDollars',
    currentPostTaxContributionPercent: 'currentPostTaxContributionPercent',
    currentPreTaxContributionDollars: 'currentPreTaxContributionDollars',
    currentPreTaxContributionPercent: 'currentPreTaxContributionPercent',
    currentTotalContributionPercent: 'currentTotalContributionPercent',
    eligibleOn: 'eligibleOn',
    employmentStatusId: 'employmentStatusId',
    entryExitTypeCode: 'entryExitTypeCode',
    externalTotalPlanBalance: 'externalTotalPlanBalance',
    firstName: 'firstName',
    fundElections: 'fundElections',
    gender: 'gender',
    isMaximizingERMatch: 'isMaximizingERMatch',
    lastEnrollmentDate: 'lastEnrollmentDate',
    lastLogin: 'lastLogin',
    lastName: 'lastName',
    lastUpdated: 'lastUpdated',
    ldiReturnRate: 'ldiReturnRate',
    onTrackRate: 'onTrackRate',
    outsideAssets: 'outsideAssets',
    personalEmail: 'personalEmail',
    planDescription: 'planDescription',
    planParticipationStatusId: 'planParticipationStatusId',
    wealthMidpoint: 'wealthMidpoint',
    wealthPersona: 'wealthPersona',
    wealthScore: 'wealthScore',
    workEmail: 'workEmail',
    workPhone: 'workPhone'
};
export const GetAdminPlanValidationsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminPlanValidationsIssueCode = {
    enrollmentMissingParticipant: 'enrollmentMissingParticipant',
    iveMissingEnrollment: 'iveMissingEnrollment',
    iveMissingVehicle: 'iveMissingVehicle',
    missingMatchTier: 'missingMatchTier',
    noFunds: 'noFunds',
    noInvestmentVehicle: 'noInvestmentVehicle',
    orphanedInvestmentVehicle: 'orphanedInvestmentVehicle',
    pathMissingFund: 'pathMissingFund',
    pathMissingVehicle: 'pathMissingVehicle',
    planMissingMetadata: 'planMissingMetadata'
};
export const GetAdminPlanValidationsIssueCodesItem = {
    enrollmentMissingParticipant: 'enrollmentMissingParticipant',
    iveMissingEnrollment: 'iveMissingEnrollment',
    iveMissingVehicle: 'iveMissingVehicle',
    missingMatchTier: 'missingMatchTier',
    noFunds: 'noFunds',
    noInvestmentVehicle: 'noInvestmentVehicle',
    orphanedInvestmentVehicle: 'orphanedInvestmentVehicle',
    pathMissingFund: 'pathMissingFund',
    pathMissingVehicle: 'pathMissingVehicle',
    planMissingMetadata: 'planMissingMetadata'
};
export const GetAdminPlanValidationsSort = {
    advisoryOrgName: 'advisoryOrgName',
    externalPlanId: 'externalPlanId',
    issue: 'issue',
    planName: 'planName'
};
export const GetEnrollmentSubmissionLogDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetEnrollmentSubmissionLogSort = {
    jobStatus: 'jobStatus',
    processedDateTime: 'processedDateTime',
    queueDateTime: 'queueDateTime',
    scheduledReleaseDateTime: 'scheduledReleaseDateTime',
    systemTask: 'systemTask'
};
export const GetAdminRecordKeeperExportQueuesDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminRecordKeeperExportQueuesSort = {
    firstName: 'firstName',
    jobStatus: 'jobStatus',
    lastName: 'lastName',
    processedDateTime: 'processedDateTime',
    queueDateTime: 'queueDateTime',
    scheduledReleaseDateTime: 'scheduledReleaseDateTime',
    systemTask: 'systemTask'
};
export const GetAdminRecordKeepingOrganizationsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminRecordKeepingOrganizationsSort = {
    createdAt: 'createdAt',
    name: 'name',
    updatedAt: 'updatedAt'
};
export const GetAdminLoginHealthAccountType = {
    admins: 'admins',
    advisors: 'advisors',
    participants: 'participants'
};
export const GetAdminLoginHealthDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminLoginHealthIssueCode = {
    accountLinkWithoutLogin: 'accountLinkWithoutLogin',
    accountWithoutLogin: 'accountWithoutLogin',
    loginWithoutAccount: 'loginWithoutAccount',
    refWithoutAccount: 'refWithoutAccount'
};
export const GetAdminLoginHealthSort = {
    firstName: 'firstName',
    lastName: 'lastName',
    username: 'username'
};
export const GetAdminRkTransactionExportsSort = {
    createdAt: 'createdAt',
    postDate: 'postDate',
    sentToCarrierDate: 'sentToCarrierDate'
};
export const GetAdminRkTransactionExportsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdminRkTransactionsSort = {
    createdAt: 'createdAt',
    postDate: 'postDate'
};
export const GetAdminRkTransactionsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetActParticipantsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetActParticipantsSort = {
    age: 'age',
    employmentStatusId: 'employmentStatusId',
    externalTotalPlanBalance: 'externalTotalPlanBalance',
    firstName: 'firstName',
    lastName: 'lastName',
    onTrackRate: 'onTrackRate',
    outsideAssets: 'outsideAssets',
    planName: 'planName',
    planParticipationStatusDesc: 'planParticipationStatusDesc',
    prospectStatus: 'prospectStatus',
    socialSecurityNumber: 'socialSecurityNumber',
    terminationDate: 'terminationDate',
    wealthMidpoint: 'wealthMidpoint',
    wealthPersona: 'wealthPersona',
    wealthScore: 'wealthScore'
};
export const GetExportActParticipantsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportActParticipantsSort = {
    age: 'age',
    employmentStatusId: 'employmentStatusId',
    externalTotalPlanBalance: 'externalTotalPlanBalance',
    firstName: 'firstName',
    lastName: 'lastName',
    onTrackRate: 'onTrackRate',
    outsideAssets: 'outsideAssets',
    planName: 'planName',
    planParticipationStatusDesc: 'planParticipationStatusDesc',
    prospectStatus: 'prospectStatus',
    socialSecurityNumber: 'socialSecurityNumber',
    terminationDate: 'terminationDate',
    wealthMidpoint: 'wealthMidpoint',
    wealthPersona: 'wealthPersona',
    wealthScore: 'wealthScore'
};
export const GetAdvisorActivityDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdvisorActivitySort = {
    firstName: 'firstName',
    jobEndDateTime: 'jobEndDateTime',
    jobStartDateTime: 'jobStartDateTime',
    jobStatusCode: 'jobStatusCode',
    lastName: 'lastName',
    planName: 'planName',
    queueDateTime: 'queueDateTime',
    taskTypeId: 'taskTypeId'
};
export const GetExportAdvisorActivityDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportAdvisorActivitySort = {
    firstName: 'firstName',
    jobEndDateTime: 'jobEndDateTime',
    jobStartDateTime: 'jobStartDateTime',
    jobStatusCode: 'jobStatusCode',
    lastName: 'lastName',
    planName: 'planName',
    queueDateTime: 'queueDateTime',
    taskTypeId: 'taskTypeId'
};
export const GetAutoForceOutsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAutoForceOutsSort = {
    createdAt: 'createdAt',
    distributionStatus: 'distributionStatus',
    firstName: 'firstName',
    lastName: 'lastName',
    liquidationDate: 'liquidationDate',
    plan: 'plan',
    responseDeadline: 'responseDeadline',
    updatedAt: 'updatedAt'
};
export const GetExportAutoForceOutsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportAutoForceOutsSort = {
    createdAt: 'createdAt',
    distributionStatus: 'distributionStatus',
    firstName: 'firstName',
    lastName: 'lastName',
    liquidationDate: 'liquidationDate',
    plan: 'plan',
    responseDeadline: 'responseDeadline',
    updatedAt: 'updatedAt'
};
export const GetCampaignSummaryDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetCampaignSummarySort = {
    active: 'active',
    clickedEventsCnt: 'clickedEventsCnt',
    createdAt: 'createdAt',
    creatorName: 'creatorName',
    deliveredEventsCnt: 'deliveredEventsCnt',
    lastSendDate: 'lastSendDate',
    name: 'name',
    nextSendDate: 'nextSendDate',
    openedEventsCnt: 'openedEventsCnt',
    planName: 'planName',
    replyTo: 'replyTo',
    undeliveredEventsCnt: 'undeliveredEventsCnt'
};
export const GetExportCampaignSummaryDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportCampaignSummarySort = {
    active: 'active',
    clickedEventsCnt: 'clickedEventsCnt',
    createdAt: 'createdAt',
    creatorName: 'creatorName',
    deliveredEventsCnt: 'deliveredEventsCnt',
    lastSendDate: 'lastSendDate',
    name: 'name',
    nextSendDate: 'nextSendDate',
    openedEventsCnt: 'openedEventsCnt',
    planName: 'planName',
    replyTo: 'replyTo',
    undeliveredEventsCnt: 'undeliveredEventsCnt'
};
export const GetInvestmentsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetInvestmentsSort = {
    cusip: 'cusip',
    description: 'description',
    tickerSymbol: 'tickerSymbol'
};
export const GetExportInvestmentsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportInvestmentsSort = {
    cusip: 'cusip',
    description: 'description',
    tickerSymbol: 'tickerSymbol'
};
export const GetIraProspectsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetIraProspectsSort = {
    dateLocked: 'dateLocked',
    externalReportId: 'externalReportId',
    externalTotalPlanBalance: 'externalTotalPlanBalance',
    firstName: 'firstName',
    isCompleted: 'isCompleted',
    lastName: 'lastName',
    outsideAssets: 'outsideAssets',
    overallRecommendation: 'overallRecommendation',
    planName: 'planName',
    prospectType: 'prospectType',
    reportName: 'reportName',
    wealthMidpoint: 'wealthMidpoint',
    wealthPersona: 'wealthPersona',
    wealthScore: 'wealthScore'
};
export const GetExportIraProspectsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportIraProspectsSort = {
    dateLocked: 'dateLocked',
    externalReportId: 'externalReportId',
    externalTotalPlanBalance: 'externalTotalPlanBalance',
    firstName: 'firstName',
    isCompleted: 'isCompleted',
    lastName: 'lastName',
    outsideAssets: 'outsideAssets',
    overallRecommendation: 'overallRecommendation',
    planName: 'planName',
    prospectType: 'prospectType',
    reportName: 'reportName',
    wealthMidpoint: 'wealthMidpoint',
    wealthPersona: 'wealthPersona',
    wealthScore: 'wealthScore'
};
export const GetManagedAccountsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetManagedAccountsSort = {
    balance: 'balance',
    createdAt: 'createdAt',
    entryDate: 'entryDate',
    externalPlanId: 'externalPlanId',
    firstName: 'firstName',
    lastName: 'lastName',
    managedAccountOptOutDate: 'managedAccountOptOutDate',
    managedAccountOptOutDeadline: 'managedAccountOptOutDeadline',
    managedAccountProviderId: 'managedAccountProviderId',
    mapProviderName: 'mapProviderName',
    participantLastUpdatedAt: 'participantLastUpdatedAt',
    planName: 'planName',
    reallocationDate: 'reallocationDate',
    ssn: 'ssn',
    status: 'status',
    updatedAt: 'updatedAt'
};
export const GetExportManagedAccountsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportManagedAccountsSort = {
    balance: 'balance',
    createdAt: 'createdAt',
    entryDate: 'entryDate',
    externalPlanId: 'externalPlanId',
    firstName: 'firstName',
    lastName: 'lastName',
    managedAccountOptOutDate: 'managedAccountOptOutDate',
    managedAccountOptOutDeadline: 'managedAccountOptOutDeadline',
    managedAccountProviderId: 'managedAccountProviderId',
    mapProviderName: 'mapProviderName',
    participantLastUpdatedAt: 'participantLastUpdatedAt',
    planName: 'planName',
    reallocationDate: 'reallocationDate',
    ssn: 'ssn',
    status: 'status',
    updatedAt: 'updatedAt'
};
export const GetMapFeeReportsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetMapFeeReportsSort = {
    createdAt: 'createdAt',
    name: 'name',
    reportFormatId: 'reportFormatId'
};
export const GetExportMapFeeReportsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportMapFeeReportsSort = {
    createdAt: 'createdAt',
    name: 'name',
    reportFormatId: 'reportFormatId'
};
export const GetOptOutLogDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetOptOutLogSort = {
    employmentStatus: 'employmentStatus',
    optOutBackInDatetime: 'optOutBackInDatetime',
    optOutDatetime: 'optOutDatetime',
    optOutStatus: 'optOutStatus',
    participantName: 'participantName',
    totalBalance: 'totalBalance'
};
export const GetMapSetupDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetMapSetupSort = {
    allowPartialAllocation: 'allowPartialAllocation',
    enrollmentStrategyDesc: 'enrollmentStrategyDesc',
    externalPlanId: 'externalPlanId',
    managedAccountMethodologyName: 'managedAccountMethodologyName',
    mapProviderName: 'mapProviderName',
    optOutDeadline: 'optOutDeadline',
    permitsDynamicQDIA: 'permitsDynamicQDIA',
    planName: 'planName',
    useMAPAsPlanDefault: 'useMAPAsPlanDefault'
};
export const GetExportMapSetupDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportMapSetupSort = {
    allowPartialAllocation: 'allowPartialAllocation',
    enrollmentStrategyDesc: 'enrollmentStrategyDesc',
    externalPlanId: 'externalPlanId',
    managedAccountMethodologyName: 'managedAccountMethodologyName',
    mapProviderName: 'mapProviderName',
    optOutDeadline: 'optOutDeadline',
    permitsDynamicQDIA: 'permitsDynamicQDIA',
    planName: 'planName',
    useMAPAsPlanDefault: 'useMAPAsPlanDefault'
};
export const GetPlanMetricsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetPlanMetricsSort = {
    activePercent: 'activePercent',
    averageContribution: 'averageContribution',
    employerName: 'employerName',
    externalPlanId: 'externalPlanId',
    goalPercent: 'goalPercent',
    isAnalyticPortalAct: 'isAnalyticPortalAct',
    lastParticipantSync: 'lastParticipantSync',
    lastSync: 'lastSync',
    matchPercent: 'matchPercent',
    planName: 'planName',
    sourceRecordKeeperName: 'sourceRecordKeeperName',
    totalAssets: 'totalAssets'
};
export const GetExportPlanMetricsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportPlanMetricsSort = {
    activePercent: 'activePercent',
    averageContribution: 'averageContribution',
    employerName: 'employerName',
    externalPlanId: 'externalPlanId',
    goalPercent: 'goalPercent',
    isAnalyticPortalAct: 'isAnalyticPortalAct',
    lastParticipantSync: 'lastParticipantSync',
    lastSync: 'lastSync',
    matchPercent: 'matchPercent',
    planName: 'planName',
    sourceRecordKeeperName: 'sourceRecordKeeperName',
    totalAssets: 'totalAssets'
};
export const GetPlanParticipantsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetPlanParticipantsSort = {
    advisoryOrganizationName: 'advisoryOrganizationName',
    age: 'age',
    annualSalary: 'annualSalary',
    cellPhone: 'cellPhone',
    currentPostTaxContributionDollars: 'currentPostTaxContributionDollars',
    currentPostTaxContributionPercent: 'currentPostTaxContributionPercent',
    currentPreTaxContributionDollars: 'currentPreTaxContributionDollars',
    currentPreTaxContributionPercent: 'currentPreTaxContributionPercent',
    currentTotalContributionPercent: 'currentTotalContributionPercent',
    eligibleOn: 'eligibleOn',
    employmentStatusId: 'employmentStatusId',
    entryExitTypeCode: 'entryExitTypeCode',
    externalTotalPlanBalance: 'externalTotalPlanBalance',
    firstName: 'firstName',
    fundElections: 'fundElections',
    gender: 'gender',
    isMaximizingERMatch: 'isMaximizingERMatch',
    lastEnrollmentDate: 'lastEnrollmentDate',
    lastLogin: 'lastLogin',
    lastName: 'lastName',
    lastUpdated: 'lastUpdated',
    ldiReturnRate: 'ldiReturnRate',
    onTrackRate: 'onTrackRate',
    outsideAssets: 'outsideAssets',
    personalEmail: 'personalEmail',
    planDescription: 'planDescription',
    planParticipationStatusId: 'planParticipationStatusId',
    wealthMidpoint: 'wealthMidpoint',
    wealthPersona: 'wealthPersona',
    wealthScore: 'wealthScore',
    workEmail: 'workEmail',
    workPhone: 'workPhone'
};
export const GetExportPlanParticipantsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportPlanParticipantsSort = {
    advisoryOrganizationName: 'advisoryOrganizationName',
    age: 'age',
    annualSalary: 'annualSalary',
    cellPhone: 'cellPhone',
    currentPostTaxContributionDollars: 'currentPostTaxContributionDollars',
    currentPostTaxContributionPercent: 'currentPostTaxContributionPercent',
    currentPreTaxContributionDollars: 'currentPreTaxContributionDollars',
    currentPreTaxContributionPercent: 'currentPreTaxContributionPercent',
    currentTotalContributionPercent: 'currentTotalContributionPercent',
    eligibleOn: 'eligibleOn',
    employmentStatusId: 'employmentStatusId',
    entryExitTypeCode: 'entryExitTypeCode',
    externalTotalPlanBalance: 'externalTotalPlanBalance',
    firstName: 'firstName',
    fundElections: 'fundElections',
    gender: 'gender',
    isMaximizingERMatch: 'isMaximizingERMatch',
    lastEnrollmentDate: 'lastEnrollmentDate',
    lastLogin: 'lastLogin',
    lastName: 'lastName',
    lastUpdated: 'lastUpdated',
    ldiReturnRate: 'ldiReturnRate',
    onTrackRate: 'onTrackRate',
    outsideAssets: 'outsideAssets',
    personalEmail: 'personalEmail',
    planDescription: 'planDescription',
    planParticipationStatusId: 'planParticipationStatusId',
    wealthMidpoint: 'wealthMidpoint',
    wealthPersona: 'wealthPersona',
    wealthScore: 'wealthScore',
    workEmail: 'workEmail',
    workPhone: 'workPhone'
};
export const GetAdvisorRecordKeeperExportQueuesDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdvisorRecordKeeperExportQueuesSort = {
    confirmationId: 'confirmationId',
    contributionType: 'contributionType',
    exportQueueJobStatus: 'exportQueueJobStatus',
    externalPlanId: 'externalPlanId',
    firstName: 'firstName',
    fundElections: 'fundElections',
    isContributionUpdated: 'isContributionUpdated',
    isModeledContribution: 'isModeledContribution',
    isTransferBalances: 'isTransferBalances',
    lastName: 'lastName',
    planName: 'planName',
    pretaxContribution: 'pretaxContribution',
    reprocessedOn: 'reprocessedOn',
    rothContribution: 'rothContribution',
    ssn: 'ssn',
    submissionType: 'submissionType',
    submittedOn: 'submittedOn',
    systemTask: 'systemTask'
};
export const GetAdvisorRecordKeeperExportQueuesExportQueueJobStatus = {
    Export_Completed: 'Export Completed',
    Export_Started: 'Export Started',
    Exported_with_Errors: 'Exported with Errors',
    Pending_Export: 'Pending Export'
};
export const GetAdvisorRecordKeeperExportQueuesSubmissionType = {
    Change: 'Change',
    Enrollment: 'Enrollment',
    'N/A': 'N/A'
};
export const GetAdvisorRecordKeeperExportQueuesSystemTask = {
    Default_Enrollment: 'Default Enrollment',
    MAP_Rebalance: 'MAP Rebalance',
    Unknown: 'Unknown'
};
export const GetExportAdvisorRecordKeeperExportQueuesDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportAdvisorRecordKeeperExportQueuesSort = {
    confirmationId: 'confirmationId',
    contributionType: 'contributionType',
    exportQueueJobStatus: 'exportQueueJobStatus',
    externalPlanId: 'externalPlanId',
    firstName: 'firstName',
    fundElections: 'fundElections',
    isContributionUpdated: 'isContributionUpdated',
    isModeledContribution: 'isModeledContribution',
    isTransferBalances: 'isTransferBalances',
    lastName: 'lastName',
    planName: 'planName',
    pretaxContribution: 'pretaxContribution',
    reprocessedOn: 'reprocessedOn',
    rothContribution: 'rothContribution',
    ssn: 'ssn',
    submissionType: 'submissionType',
    submittedOn: 'submittedOn',
    systemTask: 'systemTask'
};
export const GetExportAdvisorRecordKeeperExportQueuesExportQueueJobStatus = {
    Export_Completed: 'Export Completed',
    Export_Started: 'Export Started',
    Exported_with_Errors: 'Exported with Errors',
    Pending_Export: 'Pending Export'
};
export const GetExportAdvisorRecordKeeperExportQueuesSubmissionType = {
    Change: 'Change',
    Enrollment: 'Enrollment',
    'N/A': 'N/A'
};
export const GetExportAdvisorRecordKeeperExportQueuesSystemTask = {
    Default_Enrollment: 'Default Enrollment',
    MAP_Rebalance: 'MAP Rebalance',
    Unknown: 'Unknown'
};
export const GetReportsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetReportsSort = {
    createdAt: 'createdAt',
    name: 'name',
    planName: 'planName',
    reportFormatId: 'reportFormatId',
    reportVisibilityTypeId: 'reportVisibilityTypeId'
};
export const GetExportReportsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportReportsSort = {
    createdAt: 'createdAt',
    name: 'name',
    planName: 'planName',
    reportFormatId: 'reportFormatId',
    reportVisibilityTypeId: 'reportVisibilityTypeId'
};
export const GetSummaryPlansDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetSummaryPlansSort = {
    employerName: 'employerName',
    enrollmentStrategyDesc: 'enrollmentStrategyDesc',
    externalPlanId: 'externalPlanId',
    isAnalyticPortalAct: 'isAnalyticPortalAct',
    isIdentifyNewMAPEntrants: 'isIdentifyNewMAPEntrants',
    lastParticipantSync: 'lastParticipantSync',
    lastSync: 'lastSync',
    planName: 'planName',
    planStatusDesc: 'planStatusDesc',
    sourceRecordKeeperName: 'sourceRecordKeeperName'
};
export const GetExportSummaryPlansDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetExportSummaryPlansSort = {
    employerName: 'employerName',
    enrollmentStrategyDesc: 'enrollmentStrategyDesc',
    externalPlanId: 'externalPlanId',
    isAnalyticPortalAct: 'isAnalyticPortalAct',
    isIdentifyNewMAPEntrants: 'isIdentifyNewMAPEntrants',
    lastParticipantSync: 'lastParticipantSync',
    lastSync: 'lastSync',
    planName: 'planName',
    planStatusDesc: 'planStatusDesc',
    sourceRecordKeeperName: 'sourceRecordKeeperName'
};
export const GetAdvisorTaskSchedulesDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdvisorTaskSchedulesSort = {
    isActive: 'isActive',
    name: 'name',
    nextScheduledDate: 'nextScheduledDate',
    taskType: 'taskType'
};
export const GetAdvisorNotificationsDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetAdvisorNotificationsSort = {
    notificationName: 'notificationName',
    notificationTriggerDescription: 'notificationTriggerDescription',
    planAssociations: 'planAssociations'
};
export const GetAnnuitizationsStatus = {
    available: 'available',
    acknowledged: 'acknowledged',
    submitted: 'submitted'
};
export const GetPacLifeQuoteAnnuityType = {
    joint: 'joint',
    single: 'single'
};
export const GetPacLifeQuoteCashRefund = {
    N: 'N',
    Y: 'Y'
};
export const GetGoalProjectionGender = {
    M: 'M',
    F: 'F'
};
export const GetGoalProjectionPercentOrDollar = {
    Dollar: 'Dollar',
    Percent: 'Percent'
};
export const GetGoalProjectionPreTaxDeferralDollarsFrequency = {
    NUMBER_52: 52,
    NUMBER_26: 26,
    NUMBER_24: 24,
    NUMBER_12: 12
};
export const GetGoalProjectionRothDeferralDollarsFrequency = {
    NUMBER_52: 52,
    NUMBER_26: 26,
    NUMBER_24: 24,
    NUMBER_12: 12
};
export const GetNonMapCoreGender = {
    M: 'M',
    F: 'F'
};
export const GetNonMapCorePercentOrDollar = {
    Dollar: 'Dollar',
    Percent: 'Percent'
};
export const GetNonMapCorePreTaxDeferralDollarsFrequency = {
    NUMBER_52: 52,
    NUMBER_26: 26,
    NUMBER_24: 24,
    NUMBER_12: 12
};
export const GetNonMapCoreRorScenario = {
    Choose_Myself: 'Choose Myself',
    Default: 'Default',
    Help_Me_Choose: 'Help Me Choose'
};
export const GetNonMapCoreRothDeferralDollarsFrequency = {
    NUMBER_52: 52,
    NUMBER_26: 26,
    NUMBER_24: 24,
    NUMBER_12: 12
};
export const GetFrpLoginDestination = {
    'confirm-financials': 'confirm-financials',
    'e-notice-opt-out': 'e-notice-opt-out',
    explore: 'explore',
    'help-me-choose': 'help-me-choose',
    'lifetime-income-account': 'lifetime-income-account',
    'retirement-snapshot': 'retirement-snapshot'
};
export const SearchManagedAccountFeesSort = {
    amount: 'amount',
    feeType: 'feeType',
    payee: 'payee',
    title: 'title'
};
export const GetManagedAccountMethodologiesDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetManagedAccountMethodologiesSort = {
    createdAt: 'createdAt',
    managedAccountMethodologyName: 'managedAccountMethodologyName',
    updatedAt: 'updatedAt'
};
export const GetManagedAccountMethodologyProvidersDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetManagedAccountMethodologyProvidersSort = {
    description: 'description',
    setupComplete: 'setupComplete'
};
export const GetMapProvidersDir = {
    asc: 'asc',
    desc: 'desc'
};
export const GetMapProvidersSort = {
    createdAt: 'createdAt',
    description: 'description',
    updatedAt: 'updatedAt'
};
export const GetAdvisorsOfPlanLicence = {
    act: 'act',
    explore: 'explore',
    map: 'map',
    standard: 'standard'
};
const withQueryKey = (query, queryKey)=>{
    const result = {
        queryKey
    };
    for (const key of Object.keys(query)){
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: ()=>query[key]
        });
    }
    return result;
};
export const getAdminAccountTypes = (signal)=>{
    return client({
        url: `/api/v3/admin/account-types`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAccountTypesQueryKey = ()=>{
    return [
        `/api/v3/admin/account-types`
    ];
};
export const getGetAdminAccountTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAccountTypesQueryKey();
    const queryFn = ({ signal })=>getAdminAccountTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminAccountTypes(options, queryClient) {
    const queryOptions = getGetAdminAccountTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAccountTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAccountTypesQueryKey();
    const queryFn = ({ signal })=>getAdminAccountTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAccountTypesSuspense(options, queryClient) {
    const queryOptions = getGetAdminAccountTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminAccountsRefLogins = (params, signal)=>{
    return client({
        url: `/api/v3/admin/accounts-ref-logins`,
        method: 'DELETE',
        params,
        signal
    });
};
export const getDeleteAdminAccountsRefLoginsMutationKey = ()=>[
        'deleteAdminAccountsRefLogins'
    ];
export const getDeleteAdminAccountsRefLoginsMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAccountsRefLoginsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { params } = props ?? {};
        return deleteAdminAccountsRefLogins(params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAccountsRefLogins = (options, queryClient)=>{
    return useMutation(getDeleteAdminAccountsRefLoginsMutationOptions(options), queryClient);
};
export const getAdminAccountsRefLogins = (params, signal)=>{
    return client({
        url: `/api/v3/admin/accounts-ref-logins`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminAccountsRefLoginsQueryKey = (params)=>{
    return [
        `/api/v3/admin/accounts-ref-logins`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminAccountsRefLoginsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAccountsRefLoginsQueryKey(params);
    const queryFn = ({ signal })=>getAdminAccountsRefLogins(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminAccountsRefLogins(params, options, queryClient) {
    const queryOptions = getGetAdminAccountsRefLoginsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAccountsRefLoginsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAccountsRefLoginsQueryKey(params);
    const queryFn = ({ signal })=>getAdminAccountsRefLogins(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAccountsRefLoginsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminAccountsRefLoginsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAccountsRefLogin = (postAdminAccountsRefLoginBody, signal)=>{
    return client({
        url: `/api/v3/admin/accounts-ref-logins`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdminAccountsRefLoginBody,
        signal
    });
};
export const getPostAdminAccountsRefLoginMutationKey = ()=>[
        'postAdminAccountsRefLogin'
    ];
export const getPostAdminAccountsRefLoginMutationOptions = (options)=>{
    const mutationKey = getPostAdminAccountsRefLoginMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminAccountsRefLogin(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAccountsRefLogin = (options, queryClient)=>{
    return useMutation(getPostAdminAccountsRefLoginMutationOptions(options), queryClient);
};
export const deleteAdminAccountsRefLogin = (accountsRefLoginsId, signal)=>{
    return client({
        url: `/api/v3/admin/accounts-ref-logins/${accountsRefLoginsId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminAccountsRefLoginMutationKey = ()=>[
        'deleteAdminAccountsRefLogin'
    ];
export const getDeleteAdminAccountsRefLoginMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAccountsRefLoginMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { accountsRefLoginsId } = props ?? {};
        return deleteAdminAccountsRefLogin(accountsRefLoginsId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAccountsRefLogin = (options, queryClient)=>{
    return useMutation(getDeleteAdminAccountsRefLoginMutationOptions(options), queryClient);
};
export const patchAdminAccountsRefLogin = (accountsRefLoginsId, patchAdminAccountsRefLoginBody, signal)=>{
    return client({
        url: `/api/v3/admin/accounts-ref-logins/${accountsRefLoginsId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAdminAccountsRefLoginBody,
        signal
    });
};
export const getPatchAdminAccountsRefLoginMutationKey = ()=>[
        'patchAdminAccountsRefLogin'
    ];
export const getPatchAdminAccountsRefLoginMutationOptions = (options)=>{
    const mutationKey = getPatchAdminAccountsRefLoginMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { accountsRefLoginsId, data } = props ?? {};
        return patchAdminAccountsRefLogin(accountsRefLoginsId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminAccountsRefLogin = (options, queryClient)=>{
    return useMutation(getPatchAdminAccountsRefLoginMutationOptions(options), queryClient);
};
export const getAdminActivity = (params, signal)=>{
    return client({
        url: `/api/v3/admin/activity`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminActivityQueryKey = (params)=>{
    return [
        `/api/v3/admin/activity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminActivityQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminActivityQueryKey(params);
    const queryFn = ({ signal })=>getAdminActivity(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminActivity(params, options, queryClient) {
    const queryOptions = getGetAdminActivityQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminActivitySuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminActivityQueryKey(params);
    const queryFn = ({ signal })=>getAdminActivity(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminActivitySuspense(params, options, queryClient) {
    const queryOptions = getGetAdminActivitySuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizations = (params, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminAdvisoryOrganizationsQueryKey = (params)=>{
    return [
        `/api/v3/admin/advisory-organizations`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminAdvisoryOrganizationsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizations(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizations(params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizations(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAdvisoryOrganization = (createAdvisoryOrganizationBody, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createAdvisoryOrganizationBody,
        signal
    });
};
export const getPostAdminAdvisoryOrganizationMutationKey = ()=>[
        'postAdminAdvisoryOrganization'
    ];
export const getPostAdminAdvisoryOrganizationMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminAdvisoryOrganization(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrganization = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrganizationMutationOptions(options), queryClient);
};
export const deleteAdminAdvisoryOrganization = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminAdvisoryOrganizationMutationKey = ()=>[
        'deleteAdminAdvisoryOrganization'
    ];
export const getDeleteAdminAdvisoryOrganizationMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAdvisoryOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId } = props ?? {};
        return deleteAdminAdvisoryOrganization(advisoryOrganizationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAdvisoryOrganization = (options, queryClient)=>{
    return useMutation(getDeleteAdminAdvisoryOrganizationMutationOptions(options), queryClient);
};
export const getAdminAdvisoryOrganization = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}`
    ];
};
export const getGetAdminAdvisoryOrganizationQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganization(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganization(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganization(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminAdvisoryOrganization = (advisoryOrganizationId, updateAdvisoryOrganizationBody, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateAdvisoryOrganizationBody,
        signal
    });
};
export const getPatchAdminAdvisoryOrganizationMutationKey = ()=>[
        'patchAdminAdvisoryOrganization'
    ];
export const getPatchAdminAdvisoryOrganizationMutationOptions = (options)=>{
    const mutationKey = getPatchAdminAdvisoryOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, data } = props ?? {};
        return patchAdminAdvisoryOrganization(advisoryOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminAdvisoryOrganization = (options, queryClient)=>{
    return useMutation(getPatchAdminAdvisoryOrganizationMutationOptions(options), queryClient);
};
export const patchAdminAdvisoryOrganizationActLicense = (advisoryOrganizationId, patchAdminAdvisoryOrgActLicenseBody, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/act-license`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAdminAdvisoryOrgActLicenseBody,
        signal
    });
};
export const getPatchAdminAdvisoryOrganizationActLicenseMutationKey = ()=>[
        'patchAdminAdvisoryOrganizationActLicense'
    ];
export const getPatchAdminAdvisoryOrganizationActLicenseMutationOptions = (options)=>{
    const mutationKey = getPatchAdminAdvisoryOrganizationActLicenseMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, data } = props ?? {};
        return patchAdminAdvisoryOrganizationActLicense(advisoryOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminAdvisoryOrganizationActLicense = (options, queryClient)=>{
    return useMutation(getPatchAdminAdvisoryOrganizationActLicenseMutationOptions(options), queryClient);
};
export const getAdminAdvisoryOrgActivity = (advisoryOrganizationId, params, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/activity`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminAdvisoryOrgActivityQueryKey = (advisoryOrganizationId, params)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/activity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminAdvisoryOrgActivityQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrgActivityQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrgActivity(advisoryOrganizationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrgActivity(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrgActivityQueryOptions(advisoryOrganizationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrgActivitySuspenseQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrgActivityQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrgActivity(advisoryOrganizationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrgActivitySuspense(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrgActivitySuspenseQueryOptions(advisoryOrganizationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrgAdvisors = (advisoryOrganizationId, params, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminAdvisoryOrgAdvisorsQueryKey = (advisoryOrganizationId, params)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminAdvisoryOrgAdvisorsQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrgAdvisorsQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrgAdvisors(advisoryOrganizationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrgAdvisors(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrgAdvisorsQueryOptions(advisoryOrganizationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrgAdvisorsSuspenseQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrgAdvisorsQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrgAdvisors(advisoryOrganizationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrgAdvisorsSuspense(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrgAdvisorsSuspenseQueryOptions(advisoryOrganizationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAdvisoryOrganizationAdvisor = (advisoryOrganizationId, createAdvisorBody, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createAdvisorBody,
        signal
    });
};
export const getPostAdminAdvisoryOrganizationAdvisorMutationKey = ()=>[
        'postAdminAdvisoryOrganizationAdvisor'
    ];
export const getPostAdminAdvisoryOrganizationAdvisorMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrganizationAdvisorMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, data } = props ?? {};
        return postAdminAdvisoryOrganizationAdvisor(advisoryOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrganizationAdvisor = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrganizationAdvisorMutationOptions(options), queryClient);
};
export const postAdminAdvisoryOrgAdvisorsBulk = (advisoryOrganizationId, postAdminAdvisoryOrgAdvisorsBulkBody, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors/bulk`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdminAdvisoryOrgAdvisorsBulkBody,
        signal
    });
};
export const getPostAdminAdvisoryOrgAdvisorsBulkMutationKey = ()=>[
        'postAdminAdvisoryOrgAdvisorsBulk'
    ];
export const getPostAdminAdvisoryOrgAdvisorsBulkMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrgAdvisorsBulkMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, data } = props ?? {};
        return postAdminAdvisoryOrgAdvisorsBulk(advisoryOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrgAdvisorsBulk = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrgAdvisorsBulkMutationOptions(options), queryClient);
};
export const deleteAdminAdvisoryOrganizationAdvisor = (advisoryOrganizationId, advisorId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors/${advisorId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminAdvisoryOrganizationAdvisorMutationKey = ()=>[
        'deleteAdminAdvisoryOrganizationAdvisor'
    ];
export const getDeleteAdminAdvisoryOrganizationAdvisorMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAdvisoryOrganizationAdvisorMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, advisorId } = props ?? {};
        return deleteAdminAdvisoryOrganizationAdvisor(advisoryOrganizationId, advisorId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAdvisoryOrganizationAdvisor = (options, queryClient)=>{
    return useMutation(getDeleteAdminAdvisoryOrganizationAdvisorMutationOptions(options), queryClient);
};
export const patchAdminAdvisoryOrganizationAdvisor = (advisoryOrganizationId, advisorId, updateAdvisorBody, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors/${advisorId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateAdvisorBody,
        signal
    });
};
export const getPatchAdminAdvisoryOrganizationAdvisorMutationKey = ()=>[
        'patchAdminAdvisoryOrganizationAdvisor'
    ];
export const getPatchAdminAdvisoryOrganizationAdvisorMutationOptions = (options)=>{
    const mutationKey = getPatchAdminAdvisoryOrganizationAdvisorMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, advisorId, data } = props ?? {};
        return patchAdminAdvisoryOrganizationAdvisor(advisoryOrganizationId, advisorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminAdvisoryOrganizationAdvisor = (options, queryClient)=>{
    return useMutation(getPatchAdminAdvisoryOrganizationAdvisorMutationOptions(options), queryClient);
};
export const getAdminAdvisoryOrganizationAdvisorImpersonate = (advisoryOrganizationId, advisorId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors/${advisorId}/impersonate`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationAdvisorImpersonateQueryKey = (advisoryOrganizationId, advisorId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/advisors/${advisorId}/impersonate`
    ];
};
export const getGetAdminAdvisoryOrganizationAdvisorImpersonateQueryOptions = (advisoryOrganizationId, advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationAdvisorImpersonateQueryKey(advisoryOrganizationId, advisorId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationAdvisorImpersonate(advisoryOrganizationId, advisorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined && advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationAdvisorImpersonate(advisoryOrganizationId, advisorId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationAdvisorImpersonateQueryOptions(advisoryOrganizationId, advisorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationAdvisorImpersonateSuspenseQueryOptions = (advisoryOrganizationId, advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationAdvisorImpersonateQueryKey(advisoryOrganizationId, advisorId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationAdvisorImpersonate(advisoryOrganizationId, advisorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationAdvisorImpersonateSuspense(advisoryOrganizationId, advisorId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationAdvisorImpersonateSuspenseQueryOptions(advisoryOrganizationId, advisorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizationIntegrations = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/integrations`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationIntegrationsQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/integrations`
    ];
};
export const getGetAdminAdvisoryOrganizationIntegrationsQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationIntegrationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationIntegrations(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationIntegrations(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationIntegrationsQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationIntegrationsSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationIntegrationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationIntegrations(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationIntegrationsSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationIntegrationsSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizationUnlinkedIntegrations = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/integrations/unlinked`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationUnlinkedIntegrationsQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/integrations/unlinked`
    ];
};
export const getGetAdminAdvisoryOrganizationUnlinkedIntegrationsQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedIntegrationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedIntegrations(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationUnlinkedIntegrations(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedIntegrationsQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationUnlinkedIntegrationsSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedIntegrationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedIntegrations(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationUnlinkedIntegrationsSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedIntegrationsSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminAdvisoryOrganizationIntegration = (advisoryOrganizationId, integrationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/integrations/${integrationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminAdvisoryOrganizationIntegrationMutationKey = ()=>[
        'deleteAdminAdvisoryOrganizationIntegration'
    ];
export const getDeleteAdminAdvisoryOrganizationIntegrationMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAdvisoryOrganizationIntegrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, integrationId } = props ?? {};
        return deleteAdminAdvisoryOrganizationIntegration(advisoryOrganizationId, integrationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAdvisoryOrganizationIntegration = (options, queryClient)=>{
    return useMutation(getDeleteAdminAdvisoryOrganizationIntegrationMutationOptions(options), queryClient);
};
export const postAdminAdvisoryOrganizationIntegration = (advisoryOrganizationId, integrationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/integrations/${integrationId}`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAdvisoryOrganizationIntegrationMutationKey = ()=>[
        'postAdminAdvisoryOrganizationIntegration'
    ];
export const getPostAdminAdvisoryOrganizationIntegrationMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrganizationIntegrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, integrationId } = props ?? {};
        return postAdminAdvisoryOrganizationIntegration(advisoryOrganizationId, integrationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrganizationIntegration = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrganizationIntegrationMutationOptions(options), queryClient);
};
export const getAdminAdvisoryOrganizationLicenses = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/licenses`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationLicensesQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/licenses`
    ];
};
export const getGetAdminAdvisoryOrganizationLicensesQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationLicensesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationLicenses(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationLicenses(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationLicensesQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationLicensesSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationLicensesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationLicenses(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationLicensesSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationLicensesSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizationManagedAccountProviders = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/managed-account-providers`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationManagedAccountProvidersQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/managed-account-providers`
    ];
};
export const getGetAdminAdvisoryOrganizationManagedAccountProvidersQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationManagedAccountProvidersQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationManagedAccountProviders(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationManagedAccountProviders(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationManagedAccountProvidersQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationManagedAccountProvidersSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationManagedAccountProvidersQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationManagedAccountProviders(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationManagedAccountProvidersSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationManagedAccountProvidersSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizationUnlinkedManagedAccountProviders = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/managed-account-providers/unlinked`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/managed-account-providers/unlinked`
    ];
};
export const getGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedManagedAccountProviders(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationUnlinkedManagedAccountProviders(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedManagedAccountProviders(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedManagedAccountProvidersSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminAdvisoryOrganizationManagedAccountProvider = (advisoryOrganizationId, managedAccountProviderId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/managed-account-providers/${managedAccountProviderId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminAdvisoryOrganizationManagedAccountProviderMutationKey = ()=>[
        'deleteAdminAdvisoryOrganizationManagedAccountProvider'
    ];
export const getDeleteAdminAdvisoryOrganizationManagedAccountProviderMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAdvisoryOrganizationManagedAccountProviderMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, managedAccountProviderId } = props ?? {};
        return deleteAdminAdvisoryOrganizationManagedAccountProvider(advisoryOrganizationId, managedAccountProviderId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAdvisoryOrganizationManagedAccountProvider = (options, queryClient)=>{
    return useMutation(getDeleteAdminAdvisoryOrganizationManagedAccountProviderMutationOptions(options), queryClient);
};
export const postAdminAdvisoryOrganizationManagedAccountProvider = (advisoryOrganizationId, managedAccountProviderId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/managed-account-providers/${managedAccountProviderId}`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAdvisoryOrganizationManagedAccountProviderMutationKey = ()=>[
        'postAdminAdvisoryOrganizationManagedAccountProvider'
    ];
export const getPostAdminAdvisoryOrganizationManagedAccountProviderMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrganizationManagedAccountProviderMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, managedAccountProviderId } = props ?? {};
        return postAdminAdvisoryOrganizationManagedAccountProvider(advisoryOrganizationId, managedAccountProviderId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrganizationManagedAccountProvider = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrganizationManagedAccountProviderMutationOptions(options), queryClient);
};
export const getAdminAdvisoryOrganizationMethodologies = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/methodologies`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationMethodologiesQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/methodologies`
    ];
};
export const getGetAdminAdvisoryOrganizationMethodologiesQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationMethodologiesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationMethodologies(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationMethodologies(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationMethodologiesQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationMethodologiesSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationMethodologiesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationMethodologies(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationMethodologiesSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationMethodologiesSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizationUnlinkedMethodologies = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/methodologies/unlinked`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationUnlinkedMethodologiesQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/methodologies/unlinked`
    ];
};
export const getGetAdminAdvisoryOrganizationUnlinkedMethodologiesQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedMethodologiesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedMethodologies(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationUnlinkedMethodologies(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedMethodologiesQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationUnlinkedMethodologiesSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedMethodologiesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedMethodologies(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationUnlinkedMethodologiesSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedMethodologiesSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAdvisoryOrganizationMethodology = (advisoryOrganizationId, managedAccountMethodologyId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/methodologies/${managedAccountMethodologyId}`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAdvisoryOrganizationMethodologyMutationKey = ()=>[
        'postAdminAdvisoryOrganizationMethodology'
    ];
export const getPostAdminAdvisoryOrganizationMethodologyMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrganizationMethodologyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, managedAccountMethodologyId } = props ?? {};
        return postAdminAdvisoryOrganizationMethodology(advisoryOrganizationId, managedAccountMethodologyId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrganizationMethodology = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrganizationMethodologyMutationOptions(options), queryClient);
};
export const getAdminPlans = (advisoryOrganizationId, params, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminPlansQueryKey = (advisoryOrganizationId, params)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminPlansQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlansQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminPlans(advisoryOrganizationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminPlans(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminPlansQueryOptions(advisoryOrganizationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminPlansSuspenseQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlansQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminPlans(advisoryOrganizationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminPlansSuspense(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminPlansSuspenseQueryOptions(advisoryOrganizationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrgRecordKeeperExportQueues = (advisoryOrganizationId, params, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeper-export-queues`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminAdvisoryOrgRecordKeeperExportQueuesQueryKey = (advisoryOrganizationId, params)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeper-export-queues`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminAdvisoryOrgRecordKeeperExportQueuesQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrgRecordKeeperExportQueuesQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrgRecordKeeperExportQueues(advisoryOrganizationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrgRecordKeeperExportQueues(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrgRecordKeeperExportQueuesQueryOptions(advisoryOrganizationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrgRecordKeeperExportQueuesSuspenseQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrgRecordKeeperExportQueuesQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdminAdvisoryOrgRecordKeeperExportQueues(advisoryOrganizationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrgRecordKeeperExportQueuesSuspense(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrgRecordKeeperExportQueuesSuspenseQueryOptions(advisoryOrganizationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizationRecordKeepingOrganizations = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeping-organizations`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationRecordKeepingOrganizationsQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeping-organizations`
    ];
};
export const getGetAdminAdvisoryOrganizationRecordKeepingOrganizationsQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationRecordKeepingOrganizationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationRecordKeepingOrganizations(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationRecordKeepingOrganizations(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationRecordKeepingOrganizationsQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationRecordKeepingOrganizationsSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationRecordKeepingOrganizationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationRecordKeepingOrganizations(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationRecordKeepingOrganizationsSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationRecordKeepingOrganizationsSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizations = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeping-organizations/unlinked`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeping-organizations/unlinked`
    ];
};
export const getGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizations(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizations(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizations(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationUnlinkedRecordKeepingOrganizationsSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminAdvisoryOrganizationRecordKeepingOrganization = (advisoryOrganizationId, recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeping-organizations/${recordKeepingOrganizationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminAdvisoryOrganizationRecordKeepingOrganizationMutationKey = ()=>[
        'deleteAdminAdvisoryOrganizationRecordKeepingOrganization'
    ];
export const getDeleteAdminAdvisoryOrganizationRecordKeepingOrganizationMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAdvisoryOrganizationRecordKeepingOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, recordKeepingOrganizationId } = props ?? {};
        return deleteAdminAdvisoryOrganizationRecordKeepingOrganization(advisoryOrganizationId, recordKeepingOrganizationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAdvisoryOrganizationRecordKeepingOrganization = (options, queryClient)=>{
    return useMutation(getDeleteAdminAdvisoryOrganizationRecordKeepingOrganizationMutationOptions(options), queryClient);
};
export const postAdminAdvisoryOrganizationRecordKeepingOrganization = (advisoryOrganizationId, recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/record-keeping-organizations/${recordKeepingOrganizationId}`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAdvisoryOrganizationRecordKeepingOrganizationMutationKey = ()=>[
        'postAdminAdvisoryOrganizationRecordKeepingOrganization'
    ];
export const getPostAdminAdvisoryOrganizationRecordKeepingOrganizationMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrganizationRecordKeepingOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, recordKeepingOrganizationId } = props ?? {};
        return postAdminAdvisoryOrganizationRecordKeepingOrganization(advisoryOrganizationId, recordKeepingOrganizationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrganizationRecordKeepingOrganization = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrganizationRecordKeepingOrganizationMutationOptions(options), queryClient);
};
export const getAdminAdvisoryOrganizationWhiteLabels = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/whitelabels`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAdvisoryOrganizationWhiteLabelsQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/whitelabels`
    ];
};
export const getGetAdminAdvisoryOrganizationWhiteLabelsQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationWhiteLabelsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationWhiteLabels(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAdvisoryOrganizationWhiteLabels(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationWhiteLabelsQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAdvisoryOrganizationWhiteLabelsSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAdvisoryOrganizationWhiteLabelsQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdminAdvisoryOrganizationWhiteLabels(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAdvisoryOrganizationWhiteLabelsSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAdvisoryOrganizationWhiteLabelsSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAdvisoryOrganizationWhiteLabel = (advisoryOrganizationId, postWhitelabelBody, signal)=>{
    return client({
        url: `/api/v3/admin/advisory-organizations/${advisoryOrganizationId}/whitelabels`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postWhitelabelBody,
        signal
    });
};
export const getPostAdminAdvisoryOrganizationWhiteLabelMutationKey = ()=>[
        'postAdminAdvisoryOrganizationWhiteLabel'
    ];
export const getPostAdminAdvisoryOrganizationWhiteLabelMutationOptions = (options)=>{
    const mutationKey = getPostAdminAdvisoryOrganizationWhiteLabelMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, data } = props ?? {};
        return postAdminAdvisoryOrganizationWhiteLabel(advisoryOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAdvisoryOrganizationWhiteLabel = (options, queryClient)=>{
    return useMutation(getPostAdminAdvisoryOrganizationWhiteLabelMutationOptions(options), queryClient);
};
export const getAdminAnnuityAccountCreationErrors = (signal)=>{
    return client({
        url: `/api/v3/admin/annuity-account-errors`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAnnuityAccountCreationErrorsQueryKey = ()=>{
    return [
        `/api/v3/admin/annuity-account-errors`
    ];
};
export const getGetAdminAnnuityAccountCreationErrorsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAnnuityAccountCreationErrorsQueryKey();
    const queryFn = ({ signal })=>getAdminAnnuityAccountCreationErrors(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminAnnuityAccountCreationErrors(options, queryClient) {
    const queryOptions = getGetAdminAnnuityAccountCreationErrorsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAnnuityAccountCreationErrorsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAnnuityAccountCreationErrorsQueryKey();
    const queryFn = ({ signal })=>getAdminAnnuityAccountCreationErrors(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAnnuityAccountCreationErrorsSuspense(options, queryClient) {
    const queryOptions = getGetAdminAnnuityAccountCreationErrorsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAnnuityCarriers = (signal)=>{
    return client({
        url: `/api/v3/admin/annuity-carriers`,
        method: 'GET',
        signal
    });
};
export const getGetAnnuityCarriersQueryKey = ()=>{
    return [
        `/api/v3/admin/annuity-carriers`
    ];
};
export const getGetAnnuityCarriersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarriersQueryKey();
    const queryFn = ({ signal })=>getAnnuityCarriers(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAnnuityCarriers(options, queryClient) {
    const queryOptions = getGetAnnuityCarriersQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAnnuityCarriersSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarriersQueryKey();
    const queryFn = ({ signal })=>getAnnuityCarriers(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAnnuityCarriersSuspense(options, queryClient) {
    const queryOptions = getGetAnnuityCarriersSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAnnuityCarrier = (annuityIntegrationId, signal)=>{
    return client({
        url: `/api/v3/admin/annuity-carriers/${annuityIntegrationId}`,
        method: 'GET',
        signal
    });
};
export const getGetAnnuityCarrierQueryKey = (annuityIntegrationId)=>{
    return [
        `/api/v3/admin/annuity-carriers/${annuityIntegrationId}`
    ];
};
export const getGetAnnuityCarrierQueryOptions = (annuityIntegrationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarrierQueryKey(annuityIntegrationId);
    const queryFn = ({ signal })=>getAnnuityCarrier(annuityIntegrationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: annuityIntegrationId !== null && annuityIntegrationId !== undefined,
        ...queryOptions
    };
};
export function useGetAnnuityCarrier(annuityIntegrationId, options, queryClient) {
    const queryOptions = getGetAnnuityCarrierQueryOptions(annuityIntegrationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAnnuityCarrierSuspenseQueryOptions = (annuityIntegrationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarrierQueryKey(annuityIntegrationId);
    const queryFn = ({ signal })=>getAnnuityCarrier(annuityIntegrationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAnnuityCarrierSuspense(annuityIntegrationId, options, queryClient) {
    const queryOptions = getGetAnnuityCarrierSuspenseQueryOptions(annuityIntegrationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAnnuityCarrierExports = (annuityIntegrationId, params, signal)=>{
    return client({
        url: `/api/v3/admin/annuity-carriers/${annuityIntegrationId}/exports`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAnnuityCarrierExportsQueryKey = (annuityIntegrationId, params)=>{
    return [
        `/api/v3/admin/annuity-carriers/${annuityIntegrationId}/exports`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAnnuityCarrierExportsQueryOptions = (annuityIntegrationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarrierExportsQueryKey(annuityIntegrationId, params);
    const queryFn = ({ signal })=>getAnnuityCarrierExports(annuityIntegrationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: annuityIntegrationId !== null && annuityIntegrationId !== undefined,
        ...queryOptions
    };
};
export function useGetAnnuityCarrierExports(annuityIntegrationId, params, options, queryClient) {
    const queryOptions = getGetAnnuityCarrierExportsQueryOptions(annuityIntegrationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAnnuityCarrierExportsSuspenseQueryOptions = (annuityIntegrationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarrierExportsQueryKey(annuityIntegrationId, params);
    const queryFn = ({ signal })=>getAnnuityCarrierExports(annuityIntegrationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAnnuityCarrierExportsSuspense(annuityIntegrationId, params, options, queryClient) {
    const queryOptions = getGetAnnuityCarrierExportsSuspenseQueryOptions(annuityIntegrationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAnnuityCarrierExport = (annuityIntegrationId, id, patchAnnuityCarrierExportBody, signal)=>{
    return client({
        url: `/api/v3/admin/annuity-carriers/${annuityIntegrationId}/exports/${id}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAnnuityCarrierExportBody,
        signal
    });
};
export const getPatchAnnuityCarrierExportMutationKey = ()=>[
        'patchAnnuityCarrierExport'
    ];
export const getPatchAnnuityCarrierExportMutationOptions = (options)=>{
    const mutationKey = getPatchAnnuityCarrierExportMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { annuityIntegrationId, id, data } = props ?? {};
        return patchAnnuityCarrierExport(annuityIntegrationId, id, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAnnuityCarrierExport = (options, queryClient)=>{
    return useMutation(getPatchAnnuityCarrierExportMutationOptions(options), queryClient);
};
export const getAnnuityCarrierTransactions = (annuityIntegrationId, params, signal)=>{
    return client({
        url: `/api/v3/admin/annuity-carriers/${annuityIntegrationId}/transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAnnuityCarrierTransactionsQueryKey = (annuityIntegrationId, params)=>{
    return [
        `/api/v3/admin/annuity-carriers/${annuityIntegrationId}/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAnnuityCarrierTransactionsQueryOptions = (annuityIntegrationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarrierTransactionsQueryKey(annuityIntegrationId, params);
    const queryFn = ({ signal })=>getAnnuityCarrierTransactions(annuityIntegrationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: annuityIntegrationId !== null && annuityIntegrationId !== undefined,
        ...queryOptions
    };
};
export function useGetAnnuityCarrierTransactions(annuityIntegrationId, params, options, queryClient) {
    const queryOptions = getGetAnnuityCarrierTransactionsQueryOptions(annuityIntegrationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAnnuityCarrierTransactionsSuspenseQueryOptions = (annuityIntegrationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityCarrierTransactionsQueryKey(annuityIntegrationId, params);
    const queryFn = ({ signal })=>getAnnuityCarrierTransactions(annuityIntegrationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAnnuityCarrierTransactionsSuspense(annuityIntegrationId, params, options, queryClient) {
    const queryOptions = getGetAnnuityCarrierTransactionsSuspenseQueryOptions(annuityIntegrationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAnnuityCarrierTransaction = (annuityIntegrationId, id, patchAnnuityCarrierTransactionBody, signal)=>{
    return client({
        url: `/api/v3/admin/annuity-carriers/${annuityIntegrationId}/transactions/${id}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAnnuityCarrierTransactionBody,
        signal
    });
};
export const getPatchAnnuityCarrierTransactionMutationKey = ()=>[
        'patchAnnuityCarrierTransaction'
    ];
export const getPatchAnnuityCarrierTransactionMutationOptions = (options)=>{
    const mutationKey = getPatchAnnuityCarrierTransactionMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { annuityIntegrationId, id, data } = props ?? {};
        return patchAnnuityCarrierTransaction(annuityIntegrationId, id, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAnnuityCarrierTransaction = (options, queryClient)=>{
    return useMutation(getPatchAnnuityCarrierTransactionMutationOptions(options), queryClient);
};
export const getAdminApiKeys = (params, signal)=>{
    return client({
        url: `/api/v3/admin/api-keys`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminApiKeysQueryKey = (params)=>{
    return [
        `/api/v3/admin/api-keys`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminApiKeysQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminApiKeysQueryKey(params);
    const queryFn = ({ signal })=>getAdminApiKeys(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminApiKeys(params, options, queryClient) {
    const queryOptions = getGetAdminApiKeysQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminApiKeysSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminApiKeysQueryKey(params);
    const queryFn = ({ signal })=>getAdminApiKeys(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminApiKeysSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminApiKeysSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminApiKey = (adminPostApiKeysBody, signal)=>{
    return client({
        url: `/api/v3/admin/api-keys`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: adminPostApiKeysBody,
        signal
    });
};
export const getPostAdminApiKeyMutationKey = ()=>[
        'postAdminApiKey'
    ];
export const getPostAdminApiKeyMutationOptions = (options)=>{
    const mutationKey = getPostAdminApiKeyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminApiKey(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminApiKey = (options, queryClient)=>{
    return useMutation(getPostAdminApiKeyMutationOptions(options), queryClient);
};
export const getAdminApiKeyEntityTypes = (signal)=>{
    return client({
        url: `/api/v3/admin/api-keys/entity-types`,
        method: 'GET',
        signal
    });
};
export const getGetAdminApiKeyEntityTypesQueryKey = ()=>{
    return [
        `/api/v3/admin/api-keys/entity-types`
    ];
};
export const getGetAdminApiKeyEntityTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminApiKeyEntityTypesQueryKey();
    const queryFn = ({ signal })=>getAdminApiKeyEntityTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminApiKeyEntityTypes(options, queryClient) {
    const queryOptions = getGetAdminApiKeyEntityTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminApiKeyEntityTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminApiKeyEntityTypesQueryKey();
    const queryFn = ({ signal })=>getAdminApiKeyEntityTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminApiKeyEntityTypesSuspense(options, queryClient) {
    const queryOptions = getGetAdminApiKeyEntityTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminApiKeyScopes = (signal)=>{
    return client({
        url: `/api/v3/admin/api-keys/scopes`,
        method: 'GET',
        signal
    });
};
export const getGetAdminApiKeyScopesQueryKey = ()=>{
    return [
        `/api/v3/admin/api-keys/scopes`
    ];
};
export const getGetAdminApiKeyScopesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminApiKeyScopesQueryKey();
    const queryFn = ({ signal })=>getAdminApiKeyScopes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminApiKeyScopes(options, queryClient) {
    const queryOptions = getGetAdminApiKeyScopesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminApiKeyScopesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminApiKeyScopesQueryKey();
    const queryFn = ({ signal })=>getAdminApiKeyScopes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminApiKeyScopesSuspense(options, queryClient) {
    const queryOptions = getGetAdminApiKeyScopesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminApiKeyRevoke = (apiKeyId, signal)=>{
    return client({
        url: `/api/v3/admin/api-keys/${apiKeyId}/revoke`,
        method: 'POST',
        signal
    });
};
export const getPostAdminApiKeyRevokeMutationKey = ()=>[
        'postAdminApiKeyRevoke'
    ];
export const getPostAdminApiKeyRevokeMutationOptions = (options)=>{
    const mutationKey = getPostAdminApiKeyRevokeMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { apiKeyId } = props ?? {};
        return postAdminApiKeyRevoke(apiKeyId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminApiKeyRevoke = (options, queryClient)=>{
    return useMutation(getPostAdminApiKeyRevokeMutationOptions(options), queryClient);
};
export const uploadAsset = (kind, uploadAssetBody, signal)=>{
    return client({
        url: `/api/v3/admin/assets/${kind}`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: uploadAssetBody,
        signal
    });
};
export const getUploadAssetMutationKey = ()=>[
        'uploadAsset'
    ];
export const getUploadAssetMutationOptions = (options)=>{
    const mutationKey = getUploadAssetMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { kind, data } = props ?? {};
        return uploadAsset(kind, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useUploadAsset = (options, queryClient)=>{
    return useMutation(getUploadAssetMutationOptions(options), queryClient);
};
export const postLogin = (adminLoginBody, signal)=>{
    return client({
        url: `/api/v3/admin/auth/login`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: adminLoginBody,
        signal
    });
};
export const getPostLoginMutationKey = ()=>[
        'postLogin'
    ];
export const getPostLoginMutationOptions = (options)=>{
    const mutationKey = getPostLoginMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postLogin(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostLogin = (options, queryClient)=>{
    return useMutation(getPostLoginMutationOptions(options), queryClient);
};
export const deleteLogout = (signal)=>{
    return client({
        url: `/api/v3/admin/auth/logout`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteLogoutMutationKey = ()=>[
        'deleteLogout'
    ];
export const getDeleteLogoutMutationOptions = (options)=>{
    const mutationKey = getDeleteLogoutMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return deleteLogout();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteLogout = (options, queryClient)=>{
    return useMutation(getDeleteLogoutMutationOptions(options), queryClient);
};
export const postAdminAuthMfaEnroll = (verifyMfaBody, signal)=>{
    return client({
        url: `/api/v3/admin/auth/mfa/enroll`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: verifyMfaBody,
        signal
    });
};
export const getPostAdminAuthMfaEnrollMutationKey = ()=>[
        'postAdminAuthMfaEnroll'
    ];
export const getPostAdminAuthMfaEnrollMutationOptions = (options)=>{
    const mutationKey = getPostAdminAuthMfaEnrollMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminAuthMfaEnroll(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAuthMfaEnroll = (options, queryClient)=>{
    return useMutation(getPostAdminAuthMfaEnrollMutationOptions(options), queryClient);
};
export const postAdminAuthMfaGenerate = (signal)=>{
    return client({
        url: `/api/v3/admin/auth/mfa/generate`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAuthMfaGenerateMutationKey = ()=>[
        'postAdminAuthMfaGenerate'
    ];
export const getPostAdminAuthMfaGenerateMutationOptions = (options)=>{
    const mutationKey = getPostAdminAuthMfaGenerateMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postAdminAuthMfaGenerate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAuthMfaGenerate = (options, queryClient)=>{
    return useMutation(getPostAdminAuthMfaGenerateMutationOptions(options), queryClient);
};
export const postVerifyMfa = (adminVerifyMfaBody, signal)=>{
    return client({
        url: `/api/v3/admin/auth/verify-mfa`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: adminVerifyMfaBody,
        signal
    });
};
export const getPostVerifyMfaMutationKey = ()=>[
        'postVerifyMfa'
    ];
export const getPostVerifyMfaMutationOptions = (options)=>{
    const mutationKey = getPostVerifyMfaMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postVerifyMfa(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostVerifyMfa = (options, queryClient)=>{
    return useMutation(getPostVerifyMfaMutationOptions(options), queryClient);
};
export const getAdminAutoForceOuts = (params, signal)=>{
    return client({
        url: `/api/v3/admin/auto-force-outs`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminAutoForceOutsQueryKey = (params)=>{
    return [
        `/api/v3/admin/auto-force-outs`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminAutoForceOutsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAutoForceOutsQueryKey(params);
    const queryFn = ({ signal })=>getAdminAutoForceOuts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminAutoForceOuts(params, options, queryClient) {
    const queryOptions = getGetAdminAutoForceOutsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAutoForceOutsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAutoForceOutsQueryKey(params);
    const queryFn = ({ signal })=>getAdminAutoForceOuts(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAutoForceOutsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminAutoForceOutsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAutoForceOutPlans = (params, signal)=>{
    return client({
        url: `/api/v3/admin/auto-force-outs/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminAutoForceOutPlansQueryKey = (params)=>{
    return [
        `/api/v3/admin/auto-force-outs/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminAutoForceOutPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAutoForceOutPlansQueryKey(params);
    const queryFn = ({ signal })=>getAdminAutoForceOutPlans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminAutoForceOutPlans(params, options, queryClient) {
    const queryOptions = getGetAdminAutoForceOutPlansQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAutoForceOutPlansSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAutoForceOutPlansQueryKey(params);
    const queryFn = ({ signal })=>getAdminAutoForceOutPlans(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAutoForceOutPlansSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminAutoForceOutPlansSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAutoForceOutCancel = (rolloverParticipantId, signal)=>{
    return client({
        url: `/api/v3/admin/auto-force-outs/${rolloverParticipantId}/cancel`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAutoForceOutCancelMutationKey = ()=>[
        'postAdminAutoForceOutCancel'
    ];
export const getPostAdminAutoForceOutCancelMutationOptions = (options)=>{
    const mutationKey = getPostAdminAutoForceOutCancelMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { rolloverParticipantId } = props ?? {};
        return postAdminAutoForceOutCancel(rolloverParticipantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAutoForceOutCancel = (options, queryClient)=>{
    return useMutation(getPostAdminAutoForceOutCancelMutationOptions(options), queryClient);
};
export const postAdminAutoForceOutReprocess = (rolloverParticipantId, signal)=>{
    return client({
        url: `/api/v3/admin/auto-force-outs/${rolloverParticipantId}/reprocess`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAutoForceOutReprocessMutationKey = ()=>[
        'postAdminAutoForceOutReprocess'
    ];
export const getPostAdminAutoForceOutReprocessMutationOptions = (options)=>{
    const mutationKey = getPostAdminAutoForceOutReprocessMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { rolloverParticipantId } = props ?? {};
        return postAdminAutoForceOutReprocess(rolloverParticipantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAutoForceOutReprocess = (options, queryClient)=>{
    return useMutation(getPostAdminAutoForceOutReprocessMutationOptions(options), queryClient);
};
export const postAdminAutoJobQueueErrorTimeSeries = (errorTimeSeriesBody, signal)=>{
    return client({
        url: `/api/v3/admin/auto-job-queues/error-time-series`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: errorTimeSeriesBody,
        signal
    });
};
export const getPostAdminAutoJobQueueErrorTimeSeriesMutationKey = ()=>[
        'postAdminAutoJobQueueErrorTimeSeries'
    ];
export const getPostAdminAutoJobQueueErrorTimeSeriesMutationOptions = (options)=>{
    const mutationKey = getPostAdminAutoJobQueueErrorTimeSeriesMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminAutoJobQueueErrorTimeSeries(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAutoJobQueueErrorTimeSeries = (options, queryClient)=>{
    return useMutation(getPostAdminAutoJobQueueErrorTimeSeriesMutationOptions(options), queryClient);
};
export const postAdminAutoJobQueueStuck = (stuckAutoJobQueueBody, signal)=>{
    return client({
        url: `/api/v3/admin/auto-job-queues/stuck`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: stuckAutoJobQueueBody,
        signal
    });
};
export const getPostAdminAutoJobQueueStuckMutationKey = ()=>[
        'postAdminAutoJobQueueStuck'
    ];
export const getPostAdminAutoJobQueueStuckMutationOptions = (options)=>{
    const mutationKey = getPostAdminAutoJobQueueStuckMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminAutoJobQueueStuck(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAutoJobQueueStuck = (options, queryClient)=>{
    return useMutation(getPostAdminAutoJobQueueStuckMutationOptions(options), queryClient);
};
export const getAdminCampaignMessages = (params, signal)=>{
    return client({
        url: `/api/v3/admin/campaign-messages`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminCampaignMessagesQueryKey = (params)=>{
    return [
        `/api/v3/admin/campaign-messages`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminCampaignMessagesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignMessagesQueryKey(params);
    const queryFn = ({ signal })=>getAdminCampaignMessages(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminCampaignMessages(params, options, queryClient) {
    const queryOptions = getGetAdminCampaignMessagesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminCampaignMessagesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignMessagesQueryKey(params);
    const queryFn = ({ signal })=>getAdminCampaignMessages(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminCampaignMessagesSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminCampaignMessagesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminCampaignMessageCancel = (campaignMessageId, signal)=>{
    return client({
        url: `/api/v3/admin/campaign-messages/${campaignMessageId}/cancel`,
        method: 'POST',
        signal
    });
};
export const getPostAdminCampaignMessageCancelMutationKey = ()=>[
        'postAdminCampaignMessageCancel'
    ];
export const getPostAdminCampaignMessageCancelMutationOptions = (options)=>{
    const mutationKey = getPostAdminCampaignMessageCancelMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignMessageId } = props ?? {};
        return postAdminCampaignMessageCancel(campaignMessageId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminCampaignMessageCancel = (options, queryClient)=>{
    return useMutation(getPostAdminCampaignMessageCancelMutationOptions(options), queryClient);
};
export const postAdminCampaignMessageClone = (campaignMessageId, cloneCampaignMessageBody, signal)=>{
    return client({
        url: `/api/v3/admin/campaign-messages/${campaignMessageId}/clone`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: cloneCampaignMessageBody,
        signal
    });
};
export const getPostAdminCampaignMessageCloneMutationKey = ()=>[
        'postAdminCampaignMessageClone'
    ];
export const getPostAdminCampaignMessageCloneMutationOptions = (options)=>{
    const mutationKey = getPostAdminCampaignMessageCloneMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignMessageId, data } = props ?? {};
        return postAdminCampaignMessageClone(campaignMessageId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminCampaignMessageClone = (options, queryClient)=>{
    return useMutation(getPostAdminCampaignMessageCloneMutationOptions(options), queryClient);
};
export const postAdminCampaignMessageRetrigger = (campaignMessageId, signal)=>{
    return client({
        url: `/api/v3/admin/campaign-messages/${campaignMessageId}/retrigger`,
        method: 'POST',
        signal
    });
};
export const getPostAdminCampaignMessageRetriggerMutationKey = ()=>[
        'postAdminCampaignMessageRetrigger'
    ];
export const getPostAdminCampaignMessageRetriggerMutationOptions = (options)=>{
    const mutationKey = getPostAdminCampaignMessageRetriggerMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignMessageId } = props ?? {};
        return postAdminCampaignMessageRetrigger(campaignMessageId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminCampaignMessageRetrigger = (options, queryClient)=>{
    return useMutation(getPostAdminCampaignMessageRetriggerMutationOptions(options), queryClient);
};
export const getAdminCampaigns = (params, signal)=>{
    return client({
        url: `/api/v3/admin/campaigns`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminCampaignsQueryKey = (params)=>{
    return [
        `/api/v3/admin/campaigns`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminCampaignsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignsQueryKey(params);
    const queryFn = ({ signal })=>getAdminCampaigns(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminCampaigns(params, options, queryClient) {
    const queryOptions = getGetAdminCampaignsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminCampaignsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignsQueryKey(params);
    const queryFn = ({ signal })=>getAdminCampaigns(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminCampaignsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminCampaignsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminCampaign = (campaignId, signal)=>{
    return client({
        url: `/api/v3/admin/campaigns/${campaignId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminCampaignQueryKey = (campaignId)=>{
    return [
        `/api/v3/admin/campaigns/${campaignId}`
    ];
};
export const getGetAdminCampaignQueryOptions = (campaignId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignQueryKey(campaignId);
    const queryFn = ({ signal })=>getAdminCampaign(campaignId, signal);
    return {
        queryKey,
        queryFn,
        enabled: campaignId !== null && campaignId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminCampaign(campaignId, options, queryClient) {
    const queryOptions = getGetAdminCampaignQueryOptions(campaignId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminCampaignSuspenseQueryOptions = (campaignId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignQueryKey(campaignId);
    const queryFn = ({ signal })=>getAdminCampaign(campaignId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminCampaignSuspense(campaignId, options, queryClient) {
    const queryOptions = getGetAdminCampaignSuspenseQueryOptions(campaignId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminCampaignParticipants = (campaignId, params, signal)=>{
    return client({
        url: `/api/v3/admin/campaigns/${campaignId}/participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminCampaignParticipantsQueryKey = (campaignId, params)=>{
    return [
        `/api/v3/admin/campaigns/${campaignId}/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminCampaignParticipantsQueryOptions = (campaignId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignParticipantsQueryKey(campaignId, params);
    const queryFn = ({ signal })=>getAdminCampaignParticipants(campaignId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: campaignId !== null && campaignId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminCampaignParticipants(campaignId, params, options, queryClient) {
    const queryOptions = getGetAdminCampaignParticipantsQueryOptions(campaignId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminCampaignParticipantsSuspenseQueryOptions = (campaignId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCampaignParticipantsQueryKey(campaignId, params);
    const queryFn = ({ signal })=>getAdminCampaignParticipants(campaignId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminCampaignParticipantsSuspense(campaignId, params, options, queryClient) {
    const queryOptions = getGetAdminCampaignParticipantsSuspenseQueryOptions(campaignId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminConnectivityMapProviders = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/map-providers`,
        method: 'GET',
        signal
    });
};
export const getGetAdminConnectivityMapProvidersQueryKey = ()=>{
    return [
        `/api/v3/admin/connectivity/map-providers`
    ];
};
export const getGetAdminConnectivityMapProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityMapProvidersQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivityMapProviders(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminConnectivityMapProviders(options, queryClient) {
    const queryOptions = getGetAdminConnectivityMapProvidersQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminConnectivityMapProvidersSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityMapProvidersQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivityMapProviders(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminConnectivityMapProvidersSuspense(options, queryClient) {
    const queryOptions = getGetAdminConnectivityMapProvidersSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminConnectivityMapProviders = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/map-providers`,
        method: 'POST',
        signal
    });
};
export const getPostAdminConnectivityMapProvidersMutationKey = ()=>[
        'postAdminConnectivityMapProviders'
    ];
export const getPostAdminConnectivityMapProvidersMutationOptions = (options)=>{
    const mutationKey = getPostAdminConnectivityMapProvidersMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postAdminConnectivityMapProviders();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminConnectivityMapProviders = (options, queryClient)=>{
    return useMutation(getPostAdminConnectivityMapProvidersMutationOptions(options), queryClient);
};
export const getAdminConnectivityMisc = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/misc`,
        method: 'GET',
        signal
    });
};
export const getGetAdminConnectivityMiscQueryKey = ()=>{
    return [
        `/api/v3/admin/connectivity/misc`
    ];
};
export const getGetAdminConnectivityMiscQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityMiscQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivityMisc(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminConnectivityMisc(options, queryClient) {
    const queryOptions = getGetAdminConnectivityMiscQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminConnectivityMiscSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityMiscQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivityMisc(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminConnectivityMiscSuspense(options, queryClient) {
    const queryOptions = getGetAdminConnectivityMiscSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminConnectivityMisc = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/misc`,
        method: 'POST',
        signal
    });
};
export const getPostAdminConnectivityMiscMutationKey = ()=>[
        'postAdminConnectivityMisc'
    ];
export const getPostAdminConnectivityMiscMutationOptions = (options)=>{
    const mutationKey = getPostAdminConnectivityMiscMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postAdminConnectivityMisc();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminConnectivityMisc = (options, queryClient)=>{
    return useMutation(getPostAdminConnectivityMiscMutationOptions(options), queryClient);
};
export const getAdminConnectivityRecordKeepers = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/record-keepers`,
        method: 'GET',
        signal
    });
};
export const getGetAdminConnectivityRecordKeepersQueryKey = ()=>{
    return [
        `/api/v3/admin/connectivity/record-keepers`
    ];
};
export const getGetAdminConnectivityRecordKeepersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityRecordKeepersQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivityRecordKeepers(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminConnectivityRecordKeepers(options, queryClient) {
    const queryOptions = getGetAdminConnectivityRecordKeepersQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminConnectivityRecordKeepersSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityRecordKeepersQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivityRecordKeepers(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminConnectivityRecordKeepersSuspense(options, queryClient) {
    const queryOptions = getGetAdminConnectivityRecordKeepersSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminConnectivityRecordKeepers = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/record-keepers`,
        method: 'POST',
        signal
    });
};
export const getPostAdminConnectivityRecordKeepersMutationKey = ()=>[
        'postAdminConnectivityRecordKeepers'
    ];
export const getPostAdminConnectivityRecordKeepersMutationOptions = (options)=>{
    const mutationKey = getPostAdminConnectivityRecordKeepersMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postAdminConnectivityRecordKeepers();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminConnectivityRecordKeepers = (options, queryClient)=>{
    return useMutation(getPostAdminConnectivityRecordKeepersMutationOptions(options), queryClient);
};
export const getAdminConnectivitySftp = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/sftp`,
        method: 'GET',
        signal
    });
};
export const getGetAdminConnectivitySftpQueryKey = ()=>{
    return [
        `/api/v3/admin/connectivity/sftp`
    ];
};
export const getGetAdminConnectivitySftpQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivitySftpQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivitySftp(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminConnectivitySftp(options, queryClient) {
    const queryOptions = getGetAdminConnectivitySftpQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminConnectivitySftpSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivitySftpQueryKey();
    const queryFn = ({ signal })=>getAdminConnectivitySftp(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminConnectivitySftpSuspense(options, queryClient) {
    const queryOptions = getGetAdminConnectivitySftpSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminConnectivitySftp = (signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/sftp`,
        method: 'POST',
        signal
    });
};
export const getPostAdminConnectivitySftpMutationKey = ()=>[
        'postAdminConnectivitySftp'
    ];
export const getPostAdminConnectivitySftpMutationOptions = (options)=>{
    const mutationKey = getPostAdminConnectivitySftpMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postAdminConnectivitySftp();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminConnectivitySftp = (options, queryClient)=>{
    return useMutation(getPostAdminConnectivitySftpMutationOptions(options), queryClient);
};
export const getAdminConnectivityExport = (tab, signal)=>{
    return client({
        url: `/api/v3/admin/connectivity/${tab}/export`,
        method: 'GET',
        signal
    });
};
export const getGetAdminConnectivityExportQueryKey = (tab)=>{
    return [
        `/api/v3/admin/connectivity/${tab}/export`
    ];
};
export const getGetAdminConnectivityExportQueryOptions = (tab, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityExportQueryKey(tab);
    const queryFn = ({ signal })=>getAdminConnectivityExport(tab, signal);
    return {
        queryKey,
        queryFn,
        enabled: tab !== null && tab !== undefined,
        ...queryOptions
    };
};
export function useGetAdminConnectivityExport(tab, options, queryClient) {
    const queryOptions = getGetAdminConnectivityExportQueryOptions(tab, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminConnectivityExportSuspenseQueryOptions = (tab, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminConnectivityExportQueryKey(tab);
    const queryFn = ({ signal })=>getAdminConnectivityExport(tab, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminConnectivityExportSuspense(tab, options, queryClient) {
    const queryOptions = getGetAdminConnectivityExportSuspenseQueryOptions(tab, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminCronJobs = (signal)=>{
    return client({
        url: `/api/v3/admin/cron/jobs`,
        method: 'GET',
        signal
    });
};
export const getGetAdminCronJobsQueryKey = ()=>{
    return [
        `/api/v3/admin/cron/jobs`
    ];
};
export const getGetAdminCronJobsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCronJobsQueryKey();
    const queryFn = ({ signal })=>getAdminCronJobs(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminCronJobs(options, queryClient) {
    const queryOptions = getGetAdminCronJobsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminCronJobsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminCronJobsQueryKey();
    const queryFn = ({ signal })=>getAdminCronJobs(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminCronJobsSuspense(options, queryClient) {
    const queryOptions = getGetAdminCronJobsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminCronJobTrigger = (queueName, signal)=>{
    return client({
        url: `/api/v3/admin/cron/jobs/${queueName}/trigger`,
        method: 'POST',
        signal
    });
};
export const getPostAdminCronJobTriggerMutationKey = ()=>[
        'postAdminCronJobTrigger'
    ];
export const getPostAdminCronJobTriggerMutationOptions = (options)=>{
    const mutationKey = getPostAdminCronJobTriggerMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { queueName } = props ?? {};
        return postAdminCronJobTrigger(queueName);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminCronJobTrigger = (options, queryClient)=>{
    return useMutation(getPostAdminCronJobTriggerMutationOptions(options), queryClient);
};
export const getAdminDbInsightsCollations = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/collations`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsCollationsQueryKey = ()=>{
    return [
        `/api/v3/admin/db-insights/collations`
    ];
};
export const getGetAdminDbInsightsCollationsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsCollationsQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsCollations(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsCollations(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsCollationsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsCollationsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsCollationsQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsCollations(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsCollationsSuspense(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsCollationsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminDbInsightsDdl = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/ddl`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsDdlQueryKey = ()=>{
    return [
        `/api/v3/admin/db-insights/ddl`
    ];
};
export const getGetAdminDbInsightsDdlQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsDdlQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsDdl(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsDdl(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsDdlQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsDdlSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsDdlQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsDdl(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsDdlSuspense(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsDdlSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminDbInsightsDrift = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/drift`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsDriftQueryKey = ()=>{
    return [
        `/api/v3/admin/db-insights/drift`
    ];
};
export const getGetAdminDbInsightsDriftQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsDriftQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsDrift(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsDrift(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsDriftQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsDriftSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsDriftQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsDrift(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsDriftSuspense(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsDriftSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminDbInsightsDriftScript = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/drift/script`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsDriftScriptQueryKey = ()=>{
    return [
        `/api/v3/admin/db-insights/drift/script`
    ];
};
export const getGetAdminDbInsightsDriftScriptQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsDriftScriptQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsDriftScript(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsDriftScript(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsDriftScriptQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsDriftScriptSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsDriftScriptQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsDriftScript(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsDriftScriptSuspense(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsDriftScriptSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminDbInsightsImportData = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/import-data`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsImportDataQueryKey = ()=>{
    return [
        `/api/v3/admin/db-insights/import-data`
    ];
};
export const getGetAdminDbInsightsImportDataQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsImportDataQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsImportData(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsImportData(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsImportDataQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsImportDataSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsImportDataQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsImportData(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsImportDataSuspense(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsImportDataSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminDbInsightsImportDataPurge = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/import-data/purge`,
        method: 'POST',
        signal
    });
};
export const getPostAdminDbInsightsImportDataPurgeMutationKey = ()=>[
        'postAdminDbInsightsImportDataPurge'
    ];
export const getPostAdminDbInsightsImportDataPurgeMutationOptions = (options)=>{
    const mutationKey = getPostAdminDbInsightsImportDataPurgeMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postAdminDbInsightsImportDataPurge();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminDbInsightsImportDataPurge = (options, queryClient)=>{
    return useMutation(getPostAdminDbInsightsImportDataPurgeMutationOptions(options), queryClient);
};
export const getAdminDbInsightsSlowQueries = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/slow-queries`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsSlowQueriesQueryKey = ()=>{
    return [
        `/api/v3/admin/db-insights/slow-queries`
    ];
};
export const getGetAdminDbInsightsSlowQueriesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsSlowQueriesQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsSlowQueries(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsSlowQueries(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsSlowQueriesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsSlowQueriesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsSlowQueriesQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsSlowQueries(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsSlowQueriesSuspense(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsSlowQueriesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminDbInsightsTables = (signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/tables`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsTablesQueryKey = ()=>{
    return [
        `/api/v3/admin/db-insights/tables`
    ];
};
export const getGetAdminDbInsightsTablesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsTablesQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsTables(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsTables(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsTablesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsTablesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsTablesQueryKey();
    const queryFn = ({ signal })=>getAdminDbInsightsTables(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsTablesSuspense(options, queryClient) {
    const queryOptions = getGetAdminDbInsightsTablesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminDbInsightsTable = (table, signal)=>{
    return client({
        url: `/api/v3/admin/db-insights/tables/${table}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDbInsightsTableQueryKey = (table)=>{
    return [
        `/api/v3/admin/db-insights/tables/${table}`
    ];
};
export const getGetAdminDbInsightsTableQueryOptions = (table, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsTableQueryKey(table);
    const queryFn = ({ signal })=>getAdminDbInsightsTable(table, signal);
    return {
        queryKey,
        queryFn,
        enabled: table !== null && table !== undefined,
        ...queryOptions
    };
};
export function useGetAdminDbInsightsTable(table, options, queryClient) {
    const queryOptions = getGetAdminDbInsightsTableQueryOptions(table, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDbInsightsTableSuspenseQueryOptions = (table, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDbInsightsTableQueryKey(table);
    const queryFn = ({ signal })=>getAdminDbInsightsTable(table, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDbInsightsTableSuspense(table, options, queryClient) {
    const queryOptions = getGetAdminDbInsightsTableSuspenseQueryOptions(table, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminFlywayMigrations = (params, signal)=>{
    return client({
        url: `/api/v3/admin/flyway/migrations`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminFlywayMigrationsQueryKey = (params)=>{
    return [
        `/api/v3/admin/flyway/migrations`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminFlywayMigrationsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminFlywayMigrationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminFlywayMigrations(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminFlywayMigrations(params, options, queryClient) {
    const queryOptions = getGetAdminFlywayMigrationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminFlywayMigrationsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminFlywayMigrationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminFlywayMigrations(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminFlywayMigrationsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminFlywayMigrationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminFlywayMigration = (installedRank, signal)=>{
    return client({
        url: `/api/v3/admin/flyway/migrations/${installedRank}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminFlywayMigrationMutationKey = ()=>[
        'deleteAdminFlywayMigration'
    ];
export const getDeleteAdminFlywayMigrationMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminFlywayMigrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { installedRank } = props ?? {};
        return deleteAdminFlywayMigration(installedRank);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminFlywayMigration = (options, queryClient)=>{
    return useMutation(getDeleteAdminFlywayMigrationMutationOptions(options), queryClient);
};
export const getAdminGatedQueuePriorities = (signal)=>{
    return client({
        url: `/api/v3/admin/gated-queue-priorities`,
        method: 'GET',
        signal
    });
};
export const getGetAdminGatedQueuePrioritiesQueryKey = ()=>{
    return [
        `/api/v3/admin/gated-queue-priorities`
    ];
};
export const getGetAdminGatedQueuePrioritiesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminGatedQueuePrioritiesQueryKey();
    const queryFn = ({ signal })=>getAdminGatedQueuePriorities(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminGatedQueuePriorities(options, queryClient) {
    const queryOptions = getGetAdminGatedQueuePrioritiesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminGatedQueuePrioritiesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminGatedQueuePrioritiesQueryKey();
    const queryFn = ({ signal })=>getAdminGatedQueuePriorities(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminGatedQueuePrioritiesSuspense(options, queryClient) {
    const queryOptions = getGetAdminGatedQueuePrioritiesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminGatedQueuePriority = (queueName, updateGatedQueuePriorityBody, signal)=>{
    return client({
        url: `/api/v3/admin/gated-queue-priorities/${queueName}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateGatedQueuePriorityBody,
        signal
    });
};
export const getPatchAdminGatedQueuePriorityMutationKey = ()=>[
        'patchAdminGatedQueuePriority'
    ];
export const getPatchAdminGatedQueuePriorityMutationOptions = (options)=>{
    const mutationKey = getPatchAdminGatedQueuePriorityMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { queueName, data } = props ?? {};
        return patchAdminGatedQueuePriority(queueName, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminGatedQueuePriority = (options, queryClient)=>{
    return useMutation(getPatchAdminGatedQueuePriorityMutationOptions(options), queryClient);
};
export const getAdminIntegrations = (params, signal)=>{
    return client({
        url: `/api/v3/admin/integrations`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminIntegrationsQueryKey = (params)=>{
    return [
        `/api/v3/admin/integrations`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminIntegrationsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIntegrationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminIntegrations(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminIntegrations(params, options, queryClient) {
    const queryOptions = getGetAdminIntegrationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminIntegrationsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIntegrationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminIntegrations(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminIntegrationsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminIntegrationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminIntegration = (createIntegrationBody, signal)=>{
    return client({
        url: `/api/v3/admin/integrations`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createIntegrationBody,
        signal
    });
};
export const getPostAdminIntegrationMutationKey = ()=>[
        'postAdminIntegration'
    ];
export const getPostAdminIntegrationMutationOptions = (options)=>{
    const mutationKey = getPostAdminIntegrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminIntegration(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminIntegration = (options, queryClient)=>{
    return useMutation(getPostAdminIntegrationMutationOptions(options), queryClient);
};
export const getAdminIntegrationTypes = (signal)=>{
    return client({
        url: `/api/v3/admin/integrations/types`,
        method: 'GET',
        signal
    });
};
export const getGetAdminIntegrationTypesQueryKey = ()=>{
    return [
        `/api/v3/admin/integrations/types`
    ];
};
export const getGetAdminIntegrationTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIntegrationTypesQueryKey();
    const queryFn = ({ signal })=>getAdminIntegrationTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminIntegrationTypes(options, queryClient) {
    const queryOptions = getGetAdminIntegrationTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminIntegrationTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIntegrationTypesQueryKey();
    const queryFn = ({ signal })=>getAdminIntegrationTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminIntegrationTypesSuspense(options, queryClient) {
    const queryOptions = getGetAdminIntegrationTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminIntegration = (integrationId, signal)=>{
    return client({
        url: `/api/v3/admin/integrations/${integrationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminIntegrationMutationKey = ()=>[
        'deleteAdminIntegration'
    ];
export const getDeleteAdminIntegrationMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminIntegrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { integrationId } = props ?? {};
        return deleteAdminIntegration(integrationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminIntegration = (options, queryClient)=>{
    return useMutation(getDeleteAdminIntegrationMutationOptions(options), queryClient);
};
export const getAdminIntegration = (integrationId, signal)=>{
    return client({
        url: `/api/v3/admin/integrations/${integrationId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminIntegrationQueryKey = (integrationId)=>{
    return [
        `/api/v3/admin/integrations/${integrationId}`
    ];
};
export const getGetAdminIntegrationQueryOptions = (integrationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIntegrationQueryKey(integrationId);
    const queryFn = ({ signal })=>getAdminIntegration(integrationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: integrationId !== null && integrationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminIntegration(integrationId, options, queryClient) {
    const queryOptions = getGetAdminIntegrationQueryOptions(integrationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminIntegrationSuspenseQueryOptions = (integrationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIntegrationQueryKey(integrationId);
    const queryFn = ({ signal })=>getAdminIntegration(integrationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminIntegrationSuspense(integrationId, options, queryClient) {
    const queryOptions = getGetAdminIntegrationSuspenseQueryOptions(integrationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminIntegration = (integrationId, updateIntegrationBody, signal)=>{
    return client({
        url: `/api/v3/admin/integrations/${integrationId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateIntegrationBody,
        signal
    });
};
export const getPatchAdminIntegrationMutationKey = ()=>[
        'patchAdminIntegration'
    ];
export const getPatchAdminIntegrationMutationOptions = (options)=>{
    const mutationKey = getPatchAdminIntegrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { integrationId, data } = props ?? {};
        return patchAdminIntegration(integrationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminIntegration = (options, queryClient)=>{
    return useMutation(getPatchAdminIntegrationMutationOptions(options), queryClient);
};
export const patchAdminIntegrationConfiguration = (integrationId, updateIntegrationConfigurationBody, signal)=>{
    return client({
        url: `/api/v3/admin/integrations/${integrationId}/configuration`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateIntegrationConfigurationBody,
        signal
    });
};
export const getPatchAdminIntegrationConfigurationMutationKey = ()=>[
        'patchAdminIntegrationConfiguration'
    ];
export const getPatchAdminIntegrationConfigurationMutationOptions = (options)=>{
    const mutationKey = getPatchAdminIntegrationConfigurationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { integrationId, data } = props ?? {};
        return patchAdminIntegrationConfiguration(integrationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminIntegrationConfiguration = (options, queryClient)=>{
    return useMutation(getPatchAdminIntegrationConfigurationMutationOptions(options), queryClient);
};
export const patchAdminIntegrationReliusConfiguration = (integrationId, updateIntegrationReliusConfigurationBody, signal)=>{
    return client({
        url: `/api/v3/admin/integrations/${integrationId}/configuration/relius`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateIntegrationReliusConfigurationBody,
        signal
    });
};
export const getPatchAdminIntegrationReliusConfigurationMutationKey = ()=>[
        'patchAdminIntegrationReliusConfiguration'
    ];
export const getPatchAdminIntegrationReliusConfigurationMutationOptions = (options)=>{
    const mutationKey = getPatchAdminIntegrationReliusConfigurationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { integrationId, data } = props ?? {};
        return patchAdminIntegrationReliusConfiguration(integrationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminIntegrationReliusConfiguration = (options, queryClient)=>{
    return useMutation(getPatchAdminIntegrationReliusConfigurationMutationOptions(options), queryClient);
};
export const postAdminReliusConsole = (integrationId, postAdminReliusConsoleBody, signal)=>{
    return client({
        url: `/api/v3/admin/integrations/${integrationId}/relius/console`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdminReliusConsoleBody,
        signal
    });
};
export const getPostAdminReliusConsoleMutationKey = ()=>[
        'postAdminReliusConsole'
    ];
export const getPostAdminReliusConsoleMutationOptions = (options)=>{
    const mutationKey = getPostAdminReliusConsoleMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { integrationId, data } = props ?? {};
        return postAdminReliusConsole(integrationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminReliusConsole = (options, queryClient)=>{
    return useMutation(getPostAdminReliusConsoleMutationOptions(options), queryClient);
};
export const postAdminTestReliusConnection = (integrationId, signal)=>{
    return client({
        url: `/api/v3/admin/integrations/${integrationId}/test-relius-connection`,
        method: 'POST',
        signal
    });
};
export const getPostAdminTestReliusConnectionMutationKey = ()=>[
        'postAdminTestReliusConnection'
    ];
export const getPostAdminTestReliusConnectionMutationOptions = (options)=>{
    const mutationKey = getPostAdminTestReliusConnectionMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { integrationId } = props ?? {};
        return postAdminTestReliusConnection(integrationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminTestReliusConnection = (options, queryClient)=>{
    return useMutation(getPostAdminTestReliusConnectionMutationOptions(options), queryClient);
};
export const getAdminIraCompanions = (signal)=>{
    return client({
        url: `/api/v3/admin/ira-companions`,
        method: 'GET',
        signal
    });
};
export const getGetAdminIraCompanionsQueryKey = ()=>{
    return [
        `/api/v3/admin/ira-companions`
    ];
};
export const getGetAdminIraCompanionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIraCompanionsQueryKey();
    const queryFn = ({ signal })=>getAdminIraCompanions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminIraCompanions(options, queryClient) {
    const queryOptions = getGetAdminIraCompanionsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminIraCompanionsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIraCompanionsQueryKey();
    const queryFn = ({ signal })=>getAdminIraCompanions(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminIraCompanionsSuspense(options, queryClient) {
    const queryOptions = getGetAdminIraCompanionsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminIraCompanion = (postAdminIraCompanionBody, signal)=>{
    return client({
        url: `/api/v3/admin/ira-companions`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdminIraCompanionBody,
        signal
    });
};
export const getPostAdminIraCompanionMutationKey = ()=>[
        'postAdminIraCompanion'
    ];
export const getPostAdminIraCompanionMutationOptions = (options)=>{
    const mutationKey = getPostAdminIraCompanionMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminIraCompanion(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminIraCompanion = (options, queryClient)=>{
    return useMutation(getPostAdminIraCompanionMutationOptions(options), queryClient);
};
export const getAdminIraCompanionAvailablePlans = (signal)=>{
    return client({
        url: `/api/v3/admin/ira-companions/available-plans`,
        method: 'GET',
        signal
    });
};
export const getGetAdminIraCompanionAvailablePlansQueryKey = ()=>{
    return [
        `/api/v3/admin/ira-companions/available-plans`
    ];
};
export const getGetAdminIraCompanionAvailablePlansQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIraCompanionAvailablePlansQueryKey();
    const queryFn = ({ signal })=>getAdminIraCompanionAvailablePlans(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminIraCompanionAvailablePlans(options, queryClient) {
    const queryOptions = getGetAdminIraCompanionAvailablePlansQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminIraCompanionAvailablePlansSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIraCompanionAvailablePlansQueryKey();
    const queryFn = ({ signal })=>getAdminIraCompanionAvailablePlans(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminIraCompanionAvailablePlansSuspense(options, queryClient) {
    const queryOptions = getGetAdminIraCompanionAvailablePlansSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminIraCompanion = (iraCompanionId, signal)=>{
    return client({
        url: `/api/v3/admin/ira-companions/${iraCompanionId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminIraCompanionMutationKey = ()=>[
        'deleteAdminIraCompanion'
    ];
export const getDeleteAdminIraCompanionMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminIraCompanionMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { iraCompanionId } = props ?? {};
        return deleteAdminIraCompanion(iraCompanionId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminIraCompanion = (options, queryClient)=>{
    return useMutation(getDeleteAdminIraCompanionMutationOptions(options), queryClient);
};
export const getAdminIraCompanionPlans = (iraCompanionId, signal)=>{
    return client({
        url: `/api/v3/admin/ira-companions/${iraCompanionId}/plans`,
        method: 'GET',
        signal
    });
};
export const getGetAdminIraCompanionPlansQueryKey = (iraCompanionId)=>{
    return [
        `/api/v3/admin/ira-companions/${iraCompanionId}/plans`
    ];
};
export const getGetAdminIraCompanionPlansQueryOptions = (iraCompanionId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIraCompanionPlansQueryKey(iraCompanionId);
    const queryFn = ({ signal })=>getAdminIraCompanionPlans(iraCompanionId, signal);
    return {
        queryKey,
        queryFn,
        enabled: iraCompanionId !== null && iraCompanionId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminIraCompanionPlans(iraCompanionId, options, queryClient) {
    const queryOptions = getGetAdminIraCompanionPlansQueryOptions(iraCompanionId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminIraCompanionPlansSuspenseQueryOptions = (iraCompanionId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminIraCompanionPlansQueryKey(iraCompanionId);
    const queryFn = ({ signal })=>getAdminIraCompanionPlans(iraCompanionId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminIraCompanionPlansSuspense(iraCompanionId, options, queryClient) {
    const queryOptions = getGetAdminIraCompanionPlansSuspenseQueryOptions(iraCompanionId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminLogins = (params, signal)=>{
    return client({
        url: `/api/v3/admin/logins`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminLoginsQueryKey = (params)=>{
    return [
        `/api/v3/admin/logins`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminLoginsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginsQueryKey(params);
    const queryFn = ({ signal })=>getAdminLogins(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminLogins(params, options, queryClient) {
    const queryOptions = getGetAdminLoginsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminLoginsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginsQueryKey(params);
    const queryFn = ({ signal })=>getAdminLogins(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminLoginsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminLoginsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminLogin = (createAdminBody, signal)=>{
    return client({
        url: `/api/v3/admin/logins`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createAdminBody,
        signal
    });
};
export const getPostAdminLoginMutationKey = ()=>[
        'postAdminLogin'
    ];
export const getPostAdminLoginMutationOptions = (options)=>{
    const mutationKey = getPostAdminLoginMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminLogin(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminLogin = (options, queryClient)=>{
    return useMutation(getPostAdminLoginMutationOptions(options), queryClient);
};
export const postAdminLoginsPurgeOrphaned = (signal)=>{
    return client({
        url: `/api/v3/admin/logins/purge-orphaned`,
        method: 'POST',
        signal
    });
};
export const getPostAdminLoginsPurgeOrphanedMutationKey = ()=>[
        'postAdminLoginsPurgeOrphaned'
    ];
export const getPostAdminLoginsPurgeOrphanedMutationOptions = (options)=>{
    const mutationKey = getPostAdminLoginsPurgeOrphanedMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postAdminLoginsPurgeOrphaned();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminLoginsPurgeOrphaned = (options, queryClient)=>{
    return useMutation(getPostAdminLoginsPurgeOrphanedMutationOptions(options), queryClient);
};
export const deleteAdminLogin = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminLoginMutationKey = ()=>[
        'deleteAdminLogin'
    ];
export const getDeleteAdminLoginMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminLoginMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId } = props ?? {};
        return deleteAdminLogin(loginId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminLogin = (options, queryClient)=>{
    return useMutation(getDeleteAdminLoginMutationOptions(options), queryClient);
};
export const getAdminLogin = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminLoginQueryKey = (loginId)=>{
    return [
        `/api/v3/admin/logins/${loginId}`
    ];
};
export const getGetAdminLoginQueryOptions = (loginId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginQueryKey(loginId);
    const queryFn = ({ signal })=>getAdminLogin(loginId, signal);
    return {
        queryKey,
        queryFn,
        enabled: loginId !== null && loginId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminLogin(loginId, options, queryClient) {
    const queryOptions = getGetAdminLoginQueryOptions(loginId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminLoginSuspenseQueryOptions = (loginId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginQueryKey(loginId);
    const queryFn = ({ signal })=>getAdminLogin(loginId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminLoginSuspense(loginId, options, queryClient) {
    const queryOptions = getGetAdminLoginSuspenseQueryOptions(loginId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminLogin = (loginId, updateAdminBody, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateAdminBody,
        signal
    });
};
export const getPatchAdminLoginMutationKey = ()=>[
        'patchAdminLogin'
    ];
export const getPatchAdminLoginMutationOptions = (options)=>{
    const mutationKey = getPatchAdminLoginMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId, data } = props ?? {};
        return patchAdminLogin(loginId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminLogin = (options, queryClient)=>{
    return useMutation(getPatchAdminLoginMutationOptions(options), queryClient);
};
export const getAdminLoginAdvisoryOrganization = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/advisory-organization`,
        method: 'GET',
        signal
    });
};
export const getGetAdminLoginAdvisoryOrganizationQueryKey = (loginId)=>{
    return [
        `/api/v3/admin/logins/${loginId}/advisory-organization`
    ];
};
export const getGetAdminLoginAdvisoryOrganizationQueryOptions = (loginId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginAdvisoryOrganizationQueryKey(loginId);
    const queryFn = ({ signal })=>getAdminLoginAdvisoryOrganization(loginId, signal);
    return {
        queryKey,
        queryFn,
        enabled: loginId !== null && loginId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminLoginAdvisoryOrganization(loginId, options, queryClient) {
    const queryOptions = getGetAdminLoginAdvisoryOrganizationQueryOptions(loginId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminLoginAdvisoryOrganizationSuspenseQueryOptions = (loginId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginAdvisoryOrganizationQueryKey(loginId);
    const queryFn = ({ signal })=>getAdminLoginAdvisoryOrganization(loginId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminLoginAdvisoryOrganizationSuspense(loginId, options, queryClient) {
    const queryOptions = getGetAdminLoginAdvisoryOrganizationSuspenseQueryOptions(loginId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminLoginDisableMfa = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/disable-mfa`,
        method: 'PATCH',
        signal
    });
};
export const getPatchAdminLoginDisableMfaMutationKey = ()=>[
        'patchAdminLoginDisableMfa'
    ];
export const getPatchAdminLoginDisableMfaMutationOptions = (options)=>{
    const mutationKey = getPatchAdminLoginDisableMfaMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId } = props ?? {};
        return patchAdminLoginDisableMfa(loginId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminLoginDisableMfa = (options, queryClient)=>{
    return useMutation(getPatchAdminLoginDisableMfaMutationOptions(options), queryClient);
};
export const postAdminLoginMfaGenerate = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/mfa/generate`,
        method: 'POST',
        signal
    });
};
export const getPostAdminLoginMfaGenerateMutationKey = ()=>[
        'postAdminLoginMfaGenerate'
    ];
export const getPostAdminLoginMfaGenerateMutationOptions = (options)=>{
    const mutationKey = getPostAdminLoginMfaGenerateMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId } = props ?? {};
        return postAdminLoginMfaGenerate(loginId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminLoginMfaGenerate = (options, queryClient)=>{
    return useMutation(getPostAdminLoginMfaGenerateMutationOptions(options), queryClient);
};
export const patchAdminLoginMfaVerify = (loginId, verifyMfaBody, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/mfa/verify`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: verifyMfaBody,
        signal
    });
};
export const getPatchAdminLoginMfaVerifyMutationKey = ()=>[
        'patchAdminLoginMfaVerify'
    ];
export const getPatchAdminLoginMfaVerifyMutationOptions = (options)=>{
    const mutationKey = getPatchAdminLoginMfaVerifyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId, data } = props ?? {};
        return patchAdminLoginMfaVerify(loginId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminLoginMfaVerify = (options, queryClient)=>{
    return useMutation(getPatchAdminLoginMfaVerifyMutationOptions(options), queryClient);
};
export const getAdminLoginPlanEnrollments = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/plan-enrollments`,
        method: 'GET',
        signal
    });
};
export const getGetAdminLoginPlanEnrollmentsQueryKey = (loginId)=>{
    return [
        `/api/v3/admin/logins/${loginId}/plan-enrollments`
    ];
};
export const getGetAdminLoginPlanEnrollmentsQueryOptions = (loginId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginPlanEnrollmentsQueryKey(loginId);
    const queryFn = ({ signal })=>getAdminLoginPlanEnrollments(loginId, signal);
    return {
        queryKey,
        queryFn,
        enabled: loginId !== null && loginId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminLoginPlanEnrollments(loginId, options, queryClient) {
    const queryOptions = getGetAdminLoginPlanEnrollmentsQueryOptions(loginId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminLoginPlanEnrollmentsSuspenseQueryOptions = (loginId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginPlanEnrollmentsQueryKey(loginId);
    const queryFn = ({ signal })=>getAdminLoginPlanEnrollments(loginId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminLoginPlanEnrollmentsSuspense(loginId, options, queryClient) {
    const queryOptions = getGetAdminLoginPlanEnrollmentsSuspenseQueryOptions(loginId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminLoginResetPassword = (loginId, resetPasswordBody, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/reset-password`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: resetPasswordBody,
        signal
    });
};
export const getPatchAdminLoginResetPasswordMutationKey = ()=>[
        'patchAdminLoginResetPassword'
    ];
export const getPatchAdminLoginResetPasswordMutationOptions = (options)=>{
    const mutationKey = getPatchAdminLoginResetPasswordMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId, data } = props ?? {};
        return patchAdminLoginResetPassword(loginId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminLoginResetPassword = (options, queryClient)=>{
    return useMutation(getPatchAdminLoginResetPasswordMutationOptions(options), queryClient);
};
export const postAdminLoginSendInvitation = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/send-invitation`,
        method: 'POST',
        signal
    });
};
export const getPostAdminLoginSendInvitationMutationKey = ()=>[
        'postAdminLoginSendInvitation'
    ];
export const getPostAdminLoginSendInvitationMutationOptions = (options)=>{
    const mutationKey = getPostAdminLoginSendInvitationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId } = props ?? {};
        return postAdminLoginSendInvitation(loginId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminLoginSendInvitation = (options, queryClient)=>{
    return useMutation(getPostAdminLoginSendInvitationMutationOptions(options), queryClient);
};
export const patchAdminLoginUnlock = (loginId, signal)=>{
    return client({
        url: `/api/v3/admin/logins/${loginId}/unlock`,
        method: 'PATCH',
        signal
    });
};
export const getPatchAdminLoginUnlockMutationKey = ()=>[
        'patchAdminLoginUnlock'
    ];
export const getPatchAdminLoginUnlockMutationOptions = (options)=>{
    const mutationKey = getPatchAdminLoginUnlockMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { loginId } = props ?? {};
        return patchAdminLoginUnlock(loginId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminLoginUnlock = (options, queryClient)=>{
    return useMutation(getPatchAdminLoginUnlockMutationOptions(options), queryClient);
};
export const patchAdminManagedAccountProgram = (managedAccountProgramId, updateManagedAccountProgramBody, signal)=>{
    return client({
        url: `/api/v3/admin/managed-account-programs/${managedAccountProgramId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateManagedAccountProgramBody,
        signal
    });
};
export const getPatchAdminManagedAccountProgramMutationKey = ()=>[
        'patchAdminManagedAccountProgram'
    ];
export const getPatchAdminManagedAccountProgramMutationOptions = (options)=>{
    const mutationKey = getPatchAdminManagedAccountProgramMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountProgramId, data } = props ?? {};
        return patchAdminManagedAccountProgram(managedAccountProgramId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminManagedAccountProgram = (options, queryClient)=>{
    return useMutation(getPatchAdminManagedAccountProgramMutationOptions(options), queryClient);
};
export const postAdminManagedAccountProvider = (createManagedAccountProviderBody, signal)=>{
    return client({
        url: `/api/v3/admin/managed-account-providers`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createManagedAccountProviderBody,
        signal
    });
};
export const getPostAdminManagedAccountProviderMutationKey = ()=>[
        'postAdminManagedAccountProvider'
    ];
export const getPostAdminManagedAccountProviderMutationOptions = (options)=>{
    const mutationKey = getPostAdminManagedAccountProviderMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminManagedAccountProvider(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminManagedAccountProvider = (options, queryClient)=>{
    return useMutation(getPostAdminManagedAccountProviderMutationOptions(options), queryClient);
};
export const getAdminManagedAccountProviderAdvisoryOrganizations = (managedAccountProviderId, signal)=>{
    return client({
        url: `/api/v3/admin/managed-account-providers/${managedAccountProviderId}/advisory-organizations`,
        method: 'GET',
        signal
    });
};
export const getGetAdminManagedAccountProviderAdvisoryOrganizationsQueryKey = (managedAccountProviderId)=>{
    return [
        `/api/v3/admin/managed-account-providers/${managedAccountProviderId}/advisory-organizations`
    ];
};
export const getGetAdminManagedAccountProviderAdvisoryOrganizationsQueryOptions = (managedAccountProviderId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminManagedAccountProviderAdvisoryOrganizationsQueryKey(managedAccountProviderId);
    const queryFn = ({ signal })=>getAdminManagedAccountProviderAdvisoryOrganizations(managedAccountProviderId, signal);
    return {
        queryKey,
        queryFn,
        enabled: managedAccountProviderId !== null && managedAccountProviderId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminManagedAccountProviderAdvisoryOrganizations(managedAccountProviderId, options, queryClient) {
    const queryOptions = getGetAdminManagedAccountProviderAdvisoryOrganizationsQueryOptions(managedAccountProviderId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminManagedAccountProviderAdvisoryOrganizationsSuspenseQueryOptions = (managedAccountProviderId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminManagedAccountProviderAdvisoryOrganizationsQueryKey(managedAccountProviderId);
    const queryFn = ({ signal })=>getAdminManagedAccountProviderAdvisoryOrganizations(managedAccountProviderId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminManagedAccountProviderAdvisoryOrganizationsSuspense(managedAccountProviderId, options, queryClient) {
    const queryOptions = getGetAdminManagedAccountProviderAdvisoryOrganizationsSuspenseQueryOptions(managedAccountProviderId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminMapMethodologies = (signal)=>{
    return client({
        url: `/api/v3/admin/map-methodologies`,
        method: 'GET',
        signal
    });
};
export const getGetAdminMapMethodologiesQueryKey = ()=>{
    return [
        `/api/v3/admin/map-methodologies`
    ];
};
export const getGetAdminMapMethodologiesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminMapMethodologiesQueryKey();
    const queryFn = ({ signal })=>getAdminMapMethodologies(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminMapMethodologies(options, queryClient) {
    const queryOptions = getGetAdminMapMethodologiesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminMapMethodologiesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminMapMethodologiesQueryKey();
    const queryFn = ({ signal })=>getAdminMapMethodologies(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminMapMethodologiesSuspense(options, queryClient) {
    const queryOptions = getGetAdminMapMethodologiesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminParticipants = (params, signal)=>{
    return client({
        url: `/api/v3/admin/participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminParticipantsQueryKey = (params)=>{
    return [
        `/api/v3/admin/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getAdminParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminParticipants(params, options, queryClient) {
    const queryOptions = getGetAdminParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminParticipantsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getAdminParticipants(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminParticipantsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminParticipantsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminPlanValidations = (params, signal)=>{
    return client({
        url: `/api/v3/admin/plan-validations`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminPlanValidationsQueryKey = (params)=>{
    return [
        `/api/v3/admin/plan-validations`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminPlanValidationsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanValidationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminPlanValidations(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminPlanValidations(params, options, queryClient) {
    const queryOptions = getGetAdminPlanValidationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminPlanValidationsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanValidationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminPlanValidations(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminPlanValidationsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminPlanValidationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminPlanOptions = (params, signal)=>{
    return client({
        url: `/api/v3/admin/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminPlanOptionsQueryKey = (params)=>{
    return [
        `/api/v3/admin/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminPlanOptionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanOptionsQueryKey(params);
    const queryFn = ({ signal })=>getAdminPlanOptions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminPlanOptions(params, options, queryClient) {
    const queryOptions = getGetAdminPlanOptionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminPlanOptionsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanOptionsQueryKey(params);
    const queryFn = ({ signal })=>getAdminPlanOptions(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminPlanOptionsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminPlanOptionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAutoForceOutPlanReprocess = (planCorrelationId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planCorrelationId}/auto-force-outs/reprocess`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAutoForceOutPlanReprocessMutationKey = ()=>[
        'postAdminAutoForceOutPlanReprocess'
    ];
export const getPostAdminAutoForceOutPlanReprocessMutationOptions = (options)=>{
    const mutationKey = getPostAdminAutoForceOutPlanReprocessMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planCorrelationId } = props ?? {};
        return postAdminAutoForceOutPlanReprocess(planCorrelationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAutoForceOutPlanReprocess = (options, queryClient)=>{
    return useMutation(getPostAdminAutoForceOutPlanReprocessMutationOptions(options), queryClient);
};
export const getAdminPlanAdvisors = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/advisors`,
        method: 'GET',
        signal
    });
};
export const getGetAdminPlanAdvisorsQueryKey = (planId)=>{
    return [
        `/api/v3/admin/plans/${planId}/advisors`
    ];
};
export const getGetAdminPlanAdvisorsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanAdvisorsQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanAdvisors(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminPlanAdvisors(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanAdvisorsQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminPlanAdvisorsSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanAdvisorsQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanAdvisors(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminPlanAdvisorsSuspense(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanAdvisorsSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminPlanAdvisor = (planId, postAdminPlanAdvisorBody, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/advisors`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdminPlanAdvisorBody,
        signal
    });
};
export const getPostAdminPlanAdvisorMutationKey = ()=>[
        'postAdminPlanAdvisor'
    ];
export const getPostAdminPlanAdvisorMutationOptions = (options)=>{
    const mutationKey = getPostAdminPlanAdvisorMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return postAdminPlanAdvisor(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminPlanAdvisor = (options, queryClient)=>{
    return useMutation(getPostAdminPlanAdvisorMutationOptions(options), queryClient);
};
export const deleteAdminPlanAdvisor = (planId, advisorId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/advisors/${advisorId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminPlanAdvisorMutationKey = ()=>[
        'deleteAdminPlanAdvisor'
    ];
export const getDeleteAdminPlanAdvisorMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminPlanAdvisorMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, advisorId } = props ?? {};
        return deleteAdminPlanAdvisor(planId, advisorId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminPlanAdvisor = (options, queryClient)=>{
    return useMutation(getDeleteAdminPlanAdvisorMutationOptions(options), queryClient);
};
export const deleteAdminPlanEnrollment = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminPlanEnrollmentMutationKey = ()=>[
        'deleteAdminPlanEnrollment'
    ];
export const getDeleteAdminPlanEnrollmentMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminPlanEnrollmentMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, planEnrollmentId } = props ?? {};
        return deleteAdminPlanEnrollment(planId, planEnrollmentId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminPlanEnrollment = (options, queryClient)=>{
    return useMutation(getDeleteAdminPlanEnrollmentMutationOptions(options), queryClient);
};
export const getEnrollmentDetail = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}`,
        method: 'GET',
        signal
    });
};
export const getGetEnrollmentDetailQueryKey = (planId, planEnrollmentId)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}`
    ];
};
export const getGetEnrollmentDetailQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentDetailQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentDetail(planId, planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentDetail(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentDetailQueryOptions(planId, planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentDetailSuspenseQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentDetailQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentDetail(planId, planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentDetailSuspense(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentDetailSuspenseQueryOptions(planId, planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnrollmentActivity = (planId, planEnrollmentId, params, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/activity`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEnrollmentActivityQueryKey = (planId, planEnrollmentId, params)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/activity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEnrollmentActivityQueryOptions = (planId, planEnrollmentId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentActivityQueryKey(planId, planEnrollmentId, params);
    const queryFn = ({ signal })=>getEnrollmentActivity(planId, planEnrollmentId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentActivity(planId, planEnrollmentId, params, options, queryClient) {
    const queryOptions = getGetEnrollmentActivityQueryOptions(planId, planEnrollmentId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentActivitySuspenseQueryOptions = (planId, planEnrollmentId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentActivityQueryKey(planId, planEnrollmentId, params);
    const queryFn = ({ signal })=>getEnrollmentActivity(planId, planEnrollmentId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentActivitySuspense(planId, planEnrollmentId, params, options, queryClient) {
    const queryOptions = getGetEnrollmentActivitySuspenseQueryOptions(planId, planEnrollmentId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnrollmentAnnuityPolicies = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/annuity-policies`,
        method: 'GET',
        signal
    });
};
export const getGetEnrollmentAnnuityPoliciesQueryKey = (planId, planEnrollmentId)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/annuity-policies`
    ];
};
export const getGetEnrollmentAnnuityPoliciesQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentAnnuityPoliciesQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentAnnuityPolicies(planId, planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentAnnuityPolicies(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentAnnuityPoliciesQueryOptions(planId, planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentAnnuityPoliciesSuspenseQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentAnnuityPoliciesQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentAnnuityPolicies(planId, planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentAnnuityPoliciesSuspense(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentAnnuityPoliciesSuspenseQueryOptions(planId, planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteEnrollmentAnnuityPolicy = (planId, planEnrollmentId, annuityPolicyParticipantId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/annuity-policies/${annuityPolicyParticipantId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteEnrollmentAnnuityPolicyMutationKey = ()=>[
        'deleteEnrollmentAnnuityPolicy'
    ];
export const getDeleteEnrollmentAnnuityPolicyMutationOptions = (options)=>{
    const mutationKey = getDeleteEnrollmentAnnuityPolicyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, planEnrollmentId, annuityPolicyParticipantId } = props ?? {};
        return deleteEnrollmentAnnuityPolicy(planId, planEnrollmentId, annuityPolicyParticipantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteEnrollmentAnnuityPolicy = (options, queryClient)=>{
    return useMutation(getDeleteEnrollmentAnnuityPolicyMutationOptions(options), queryClient);
};
export const patchEnrollmentAnnuityPolicy = (planId, planEnrollmentId, annuityPolicyParticipantId, patchEnrollmentAnnuityPolicyBody, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/annuity-policies/${annuityPolicyParticipantId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchEnrollmentAnnuityPolicyBody,
        signal
    });
};
export const getPatchEnrollmentAnnuityPolicyMutationKey = ()=>[
        'patchEnrollmentAnnuityPolicy'
    ];
export const getPatchEnrollmentAnnuityPolicyMutationOptions = (options)=>{
    const mutationKey = getPatchEnrollmentAnnuityPolicyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, planEnrollmentId, annuityPolicyParticipantId, data } = props ?? {};
        return patchEnrollmentAnnuityPolicy(planId, planEnrollmentId, annuityPolicyParticipantId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchEnrollmentAnnuityPolicy = (options, queryClient)=>{
    return useMutation(getPatchEnrollmentAnnuityPolicyMutationOptions(options), queryClient);
};
export const getAdminDebugSnapshot = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/debug-snapshot`,
        method: 'GET',
        signal
    });
};
export const getGetAdminDebugSnapshotQueryKey = (planId, planEnrollmentId)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/debug-snapshot`
    ];
};
export const getGetAdminDebugSnapshotQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDebugSnapshotQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getAdminDebugSnapshot(planId, planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminDebugSnapshot(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetAdminDebugSnapshotQueryOptions(planId, planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminDebugSnapshotSuspenseQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminDebugSnapshotQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getAdminDebugSnapshot(planId, planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminDebugSnapshotSuspense(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetAdminDebugSnapshotSuspenseQueryOptions(planId, planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnrollmentFundBalances = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/fund-balances`,
        method: 'GET',
        signal
    });
};
export const getGetEnrollmentFundBalancesQueryKey = (planId, planEnrollmentId)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/fund-balances`
    ];
};
export const getGetEnrollmentFundBalancesQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentFundBalancesQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentFundBalances(planId, planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentFundBalances(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentFundBalancesQueryOptions(planId, planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentFundBalancesSuspenseQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentFundBalancesQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentFundBalances(planId, planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentFundBalancesSuspense(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentFundBalancesSuspenseQueryOptions(planId, planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnrollmentMap = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/map`,
        method: 'GET',
        signal
    });
};
export const getGetEnrollmentMapQueryKey = (planId, planEnrollmentId)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/map`
    ];
};
export const getGetEnrollmentMapQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentMapQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentMap(planId, planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentMap(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentMapQueryOptions(planId, planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentMapSuspenseQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentMapQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentMap(planId, planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentMapSuspense(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentMapSuspenseQueryOptions(planId, planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnrollmentRkTransactionExports = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/rk-transaction-exports`,
        method: 'GET',
        signal
    });
};
export const getGetEnrollmentRkTransactionExportsQueryKey = (planId, planEnrollmentId)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/rk-transaction-exports`
    ];
};
export const getGetEnrollmentRkTransactionExportsQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentRkTransactionExportsQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentRkTransactionExports(planId, planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentRkTransactionExports(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentRkTransactionExportsQueryOptions(planId, planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentRkTransactionExportsSuspenseQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentRkTransactionExportsQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentRkTransactionExports(planId, planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentRkTransactionExportsSuspense(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentRkTransactionExportsSuspenseQueryOptions(planId, planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnrollmentRkTransactions = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/rk-transactions`,
        method: 'GET',
        signal
    });
};
export const getGetEnrollmentRkTransactionsQueryKey = (planId, planEnrollmentId)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/rk-transactions`
    ];
};
export const getGetEnrollmentRkTransactionsQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentRkTransactionsQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentRkTransactions(planId, planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentRkTransactions(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentRkTransactionsQueryOptions(planId, planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentRkTransactionsSuspenseQueryOptions = (planId, planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentRkTransactionsQueryKey(planId, planEnrollmentId);
    const queryFn = ({ signal })=>getEnrollmentRkTransactions(planId, planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentRkTransactionsSuspense(planId, planEnrollmentId, options, queryClient) {
    const queryOptions = getGetEnrollmentRkTransactionsSuspenseQueryOptions(planId, planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnrollmentSubmissionLog = (planId, planEnrollmentId, params, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/submission-log`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEnrollmentSubmissionLogQueryKey = (planId, planEnrollmentId, params)=>{
    return [
        `/api/v3/admin/plans/${planId}/enrollments/${planEnrollmentId}/submission-log`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEnrollmentSubmissionLogQueryOptions = (planId, planEnrollmentId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentSubmissionLogQueryKey(planId, planEnrollmentId, params);
    const queryFn = ({ signal })=>getEnrollmentSubmissionLog(planId, planEnrollmentId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetEnrollmentSubmissionLog(planId, planEnrollmentId, params, options, queryClient) {
    const queryOptions = getGetEnrollmentSubmissionLogQueryOptions(planId, planEnrollmentId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnrollmentSubmissionLogSuspenseQueryOptions = (planId, planEnrollmentId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnrollmentSubmissionLogQueryKey(planId, planEnrollmentId, params);
    const queryFn = ({ signal })=>getEnrollmentSubmissionLog(planId, planEnrollmentId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnrollmentSubmissionLogSuspense(planId, planEnrollmentId, params, options, queryClient) {
    const queryOptions = getGetEnrollmentSubmissionLogSuspenseQueryOptions(planId, planEnrollmentId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminPlanEquityWashRules = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/equity-wash-rules`,
        method: 'GET',
        signal
    });
};
export const getGetAdminPlanEquityWashRulesQueryKey = (planId)=>{
    return [
        `/api/v3/admin/plans/${planId}/equity-wash-rules`
    ];
};
export const getGetAdminPlanEquityWashRulesQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanEquityWashRulesQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanEquityWashRules(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminPlanEquityWashRules(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanEquityWashRulesQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminPlanEquityWashRulesSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanEquityWashRulesQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanEquityWashRules(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminPlanEquityWashRulesSuspense(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanEquityWashRulesSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminPlanFunds = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/funds`,
        method: 'GET',
        signal
    });
};
export const getGetAdminPlanFundsQueryKey = (planId)=>{
    return [
        `/api/v3/admin/plans/${planId}/funds`
    ];
};
export const getGetAdminPlanFundsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanFundsQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanFunds(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminPlanFunds(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanFundsQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminPlanFundsSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanFundsQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanFunds(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminPlanFundsSuspense(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanFundsSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminPlanManagedAccountProgram = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/managed-account-program`,
        method: 'GET',
        signal
    });
};
export const getGetAdminPlanManagedAccountProgramQueryKey = (planId)=>{
    return [
        `/api/v3/admin/plans/${planId}/managed-account-program`
    ];
};
export const getGetAdminPlanManagedAccountProgramQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanManagedAccountProgramQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanManagedAccountProgram(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminPlanManagedAccountProgram(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanManagedAccountProgramQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminPlanManagedAccountProgramSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminPlanManagedAccountProgramQueryKey(planId);
    const queryFn = ({ signal })=>getAdminPlanManagedAccountProgram(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminPlanManagedAccountProgramSuspense(planId, options, queryClient) {
    const queryOptions = getGetAdminPlanManagedAccountProgramSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminPlanMapReanalysis = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/map-reanalysis`,
        method: 'POST',
        signal
    });
};
export const getPostAdminPlanMapReanalysisMutationKey = ()=>[
        'postAdminPlanMapReanalysis'
    ];
export const getPostAdminPlanMapReanalysisMutationOptions = (options)=>{
    const mutationKey = getPostAdminPlanMapReanalysisMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postAdminPlanMapReanalysis(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminPlanMapReanalysis = (options, queryClient)=>{
    return useMutation(getPostAdminPlanMapReanalysisMutationOptions(options), queryClient);
};
export const postAdminParticipantLiteSync = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/participant-lite-sync`,
        method: 'POST',
        signal
    });
};
export const getPostAdminParticipantLiteSyncMutationKey = ()=>[
        'postAdminParticipantLiteSync'
    ];
export const getPostAdminParticipantLiteSyncMutationOptions = (options)=>{
    const mutationKey = getPostAdminParticipantLiteSyncMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postAdminParticipantLiteSync(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminParticipantLiteSync = (options, queryClient)=>{
    return useMutation(getPostAdminParticipantLiteSyncMutationOptions(options), queryClient);
};
export const postAdminMapReanalysis = (planId, participantId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/participants/${participantId}/map-reanalysis`,
        method: 'POST',
        signal
    });
};
export const getPostAdminMapReanalysisMutationKey = ()=>[
        'postAdminMapReanalysis'
    ];
export const getPostAdminMapReanalysisMutationOptions = (options)=>{
    const mutationKey = getPostAdminMapReanalysisMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, participantId } = props ?? {};
        return postAdminMapReanalysis(planId, participantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminMapReanalysis = (options, queryClient)=>{
    return useMutation(getPostAdminMapReanalysisMutationOptions(options), queryClient);
};
export const postAdminParticipantLiteSyncForParticipant = (planId, participantId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/participants/${participantId}/participant-lite-sync`,
        method: 'POST',
        signal
    });
};
export const getPostAdminParticipantLiteSyncForParticipantMutationKey = ()=>[
        'postAdminParticipantLiteSyncForParticipant'
    ];
export const getPostAdminParticipantLiteSyncForParticipantMutationOptions = (options)=>{
    const mutationKey = getPostAdminParticipantLiteSyncForParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, participantId } = props ?? {};
        return postAdminParticipantLiteSyncForParticipant(planId, participantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminParticipantLiteSyncForParticipant = (options, queryClient)=>{
    return useMutation(getPostAdminParticipantLiteSyncForParticipantMutationOptions(options), queryClient);
};
export const postAdminParticipantSync = (planId, participantId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/participants/${participantId}/sync`,
        method: 'POST',
        signal
    });
};
export const getPostAdminParticipantSyncMutationKey = ()=>[
        'postAdminParticipantSync'
    ];
export const getPostAdminParticipantSyncMutationOptions = (options)=>{
    const mutationKey = getPostAdminParticipantSyncMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, participantId } = props ?? {};
        return postAdminParticipantSync(planId, participantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminParticipantSync = (options, queryClient)=>{
    return useMutation(getPostAdminParticipantSyncMutationOptions(options), queryClient);
};
export const postAdminForceOutReprocess = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/plan-enrollments/${planEnrollmentId}/force-out-reprocess`,
        method: 'POST',
        signal
    });
};
export const getPostAdminForceOutReprocessMutationKey = ()=>[
        'postAdminForceOutReprocess'
    ];
export const getPostAdminForceOutReprocessMutationOptions = (options)=>{
    const mutationKey = getPostAdminForceOutReprocessMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, planEnrollmentId } = props ?? {};
        return postAdminForceOutReprocess(planId, planEnrollmentId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminForceOutReprocess = (options, queryClient)=>{
    return useMutation(getPostAdminForceOutReprocessMutationOptions(options), queryClient);
};
export const postAdminRemoveFromMap = (planId, planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/plan-enrollments/${planEnrollmentId}/remove-from-map`,
        method: 'POST',
        signal
    });
};
export const getPostAdminRemoveFromMapMutationKey = ()=>[
        'postAdminRemoveFromMap'
    ];
export const getPostAdminRemoveFromMapMutationOptions = (options)=>{
    const mutationKey = getPostAdminRemoveFromMapMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, planEnrollmentId } = props ?? {};
        return postAdminRemoveFromMap(planId, planEnrollmentId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminRemoveFromMap = (options, queryClient)=>{
    return useMutation(getPostAdminRemoveFromMapMutationOptions(options), queryClient);
};
export const postAdminPlanReliusCheckIJoinEnabled = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/relius/check-ijoin-enabled`,
        method: 'POST',
        signal
    });
};
export const getPostAdminPlanReliusCheckIJoinEnabledMutationKey = ()=>[
        'postAdminPlanReliusCheckIJoinEnabled'
    ];
export const getPostAdminPlanReliusCheckIJoinEnabledMutationOptions = (options)=>{
    const mutationKey = getPostAdminPlanReliusCheckIJoinEnabledMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postAdminPlanReliusCheckIJoinEnabled(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminPlanReliusCheckIJoinEnabled = (options, queryClient)=>{
    return useMutation(getPostAdminPlanReliusCheckIJoinEnabledMutationOptions(options), queryClient);
};
export const postAdminPlanReliusParticipantSync = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/relius/participant-sync`,
        method: 'POST',
        signal
    });
};
export const getPostAdminPlanReliusParticipantSyncMutationKey = ()=>[
        'postAdminPlanReliusParticipantSync'
    ];
export const getPostAdminPlanReliusParticipantSyncMutationOptions = (options)=>{
    const mutationKey = getPostAdminPlanReliusParticipantSyncMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postAdminPlanReliusParticipantSync(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminPlanReliusParticipantSync = (options, queryClient)=>{
    return useMutation(getPostAdminPlanReliusParticipantSyncMutationOptions(options), queryClient);
};
export const postAdminPlanReliusPlanSync = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/relius/plan-sync`,
        method: 'POST',
        signal
    });
};
export const getPostAdminPlanReliusPlanSyncMutationKey = ()=>[
        'postAdminPlanReliusPlanSync'
    ];
export const getPostAdminPlanReliusPlanSyncMutationOptions = (options)=>{
    const mutationKey = getPostAdminPlanReliusPlanSyncMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postAdminPlanReliusPlanSync(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminPlanReliusPlanSync = (options, queryClient)=>{
    return useMutation(getPostAdminPlanReliusPlanSyncMutationOptions(options), queryClient);
};
export const postAdminSsnReset = (planId, postAdminSsnResetBody, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/ssn-reset`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdminSsnResetBody,
        signal
    });
};
export const getPostAdminSsnResetMutationKey = ()=>[
        'postAdminSsnReset'
    ];
export const getPostAdminSsnResetMutationOptions = (options)=>{
    const mutationKey = getPostAdminSsnResetMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return postAdminSsnReset(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminSsnReset = (options, queryClient)=>{
    return useMutation(getPostAdminSsnResetMutationOptions(options), queryClient);
};
export const postAdminSsnResetAll = (planId, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/ssn-reset-all`,
        method: 'POST',
        signal
    });
};
export const getPostAdminSsnResetAllMutationKey = ()=>[
        'postAdminSsnResetAll'
    ];
export const getPostAdminSsnResetAllMutationOptions = (options)=>{
    const mutationKey = getPostAdminSsnResetAllMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postAdminSsnResetAll(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminSsnResetAll = (options, queryClient)=>{
    return useMutation(getPostAdminSsnResetAllMutationOptions(options), queryClient);
};
export const patchAdminPlanStatus = (planId, patchAdminPlanStatusBody, signal)=>{
    return client({
        url: `/api/v3/admin/plans/${planId}/status`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAdminPlanStatusBody,
        signal
    });
};
export const getPatchAdminPlanStatusMutationKey = ()=>[
        'patchAdminPlanStatus'
    ];
export const getPatchAdminPlanStatusMutationOptions = (options)=>{
    const mutationKey = getPatchAdminPlanStatusMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return patchAdminPlanStatus(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminPlanStatus = (options, queryClient)=>{
    return useMutation(getPatchAdminPlanStatusMutationOptions(options), queryClient);
};
export const getAdminQueues = (signal)=>{
    return client({
        url: `/api/v3/admin/queues`,
        method: 'GET',
        signal
    });
};
export const getGetAdminQueuesQueryKey = ()=>{
    return [
        `/api/v3/admin/queues`
    ];
};
export const getGetAdminQueuesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueuesQueryKey();
    const queryFn = ({ signal })=>getAdminQueues(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminQueues(options, queryClient) {
    const queryOptions = getGetAdminQueuesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminQueuesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueuesQueryKey();
    const queryFn = ({ signal })=>getAdminQueues(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminQueuesSuspense(options, queryClient) {
    const queryOptions = getGetAdminQueuesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminQueuesPurge = (purgeQueueBody, signal)=>{
    return client({
        url: `/api/v3/admin/queues/purge`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: purgeQueueBody,
        signal
    });
};
export const getPostAdminQueuesPurgeMutationKey = ()=>[
        'postAdminQueuesPurge'
    ];
export const getPostAdminQueuesPurgeMutationOptions = (options)=>{
    const mutationKey = getPostAdminQueuesPurgeMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminQueuesPurge(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminQueuesPurge = (options, queryClient)=>{
    return useMutation(getPostAdminQueuesPurgeMutationOptions(options), queryClient);
};
export const postAdminQueuesSetVisibilityTimeout = (setVisibilityTimeoutBody, signal)=>{
    return client({
        url: `/api/v3/admin/queues/set-visibility-timeout`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: setVisibilityTimeoutBody,
        signal
    });
};
export const getPostAdminQueuesSetVisibilityTimeoutMutationKey = ()=>[
        'postAdminQueuesSetVisibilityTimeout'
    ];
export const getPostAdminQueuesSetVisibilityTimeoutMutationOptions = (options)=>{
    const mutationKey = getPostAdminQueuesSetVisibilityTimeoutMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminQueuesSetVisibilityTimeout(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminQueuesSetVisibilityTimeout = (options, queryClient)=>{
    return useMutation(getPostAdminQueuesSetVisibilityTimeoutMutationOptions(options), queryClient);
};
export const getAdminQueue = (name, signal)=>{
    return client({
        url: `/api/v3/admin/queues/${name}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminQueueQueryKey = (name)=>{
    return [
        `/api/v3/admin/queues/${name}`
    ];
};
export const getGetAdminQueueQueryOptions = (name, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueueQueryKey(name);
    const queryFn = ({ signal })=>getAdminQueue(name, signal);
    return {
        queryKey,
        queryFn,
        enabled: name !== null && name !== undefined,
        ...queryOptions
    };
};
export function useGetAdminQueue(name, options, queryClient) {
    const queryOptions = getGetAdminQueueQueryOptions(name, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminQueueSuspenseQueryOptions = (name, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueueQueryKey(name);
    const queryFn = ({ signal })=>getAdminQueue(name, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminQueueSuspense(name, options, queryClient) {
    const queryOptions = getGetAdminQueueSuspenseQueryOptions(name, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminQueueGateSamples = (name, params, signal)=>{
    return client({
        url: `/api/v3/admin/queues/${name}/gate-samples`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminQueueGateSamplesQueryKey = (name, params)=>{
    return [
        `/api/v3/admin/queues/${name}/gate-samples`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminQueueGateSamplesQueryOptions = (name, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueueGateSamplesQueryKey(name, params);
    const queryFn = ({ signal })=>getAdminQueueGateSamples(name, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: name !== null && name !== undefined,
        ...queryOptions
    };
};
export function useGetAdminQueueGateSamples(name, params, options, queryClient) {
    const queryOptions = getGetAdminQueueGateSamplesQueryOptions(name, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminQueueGateSamplesSuspenseQueryOptions = (name, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueueGateSamplesQueryKey(name, params);
    const queryFn = ({ signal })=>getAdminQueueGateSamples(name, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminQueueGateSamplesSuspense(name, params, options, queryClient) {
    const queryOptions = getGetAdminQueueGateSamplesSuspenseQueryOptions(name, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminQueueSamples = (name, params, signal)=>{
    return client({
        url: `/api/v3/admin/queues/${name}/samples`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminQueueSamplesQueryKey = (name, params)=>{
    return [
        `/api/v3/admin/queues/${name}/samples`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminQueueSamplesQueryOptions = (name, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueueSamplesQueryKey(name, params);
    const queryFn = ({ signal })=>getAdminQueueSamples(name, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: name !== null && name !== undefined,
        ...queryOptions
    };
};
export function useGetAdminQueueSamples(name, params, options, queryClient) {
    const queryOptions = getGetAdminQueueSamplesQueryOptions(name, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminQueueSamplesSuspenseQueryOptions = (name, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminQueueSamplesQueryKey(name, params);
    const queryFn = ({ signal })=>getAdminQueueSamples(name, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminQueueSamplesSuspense(name, params, options, queryClient) {
    const queryOptions = getGetAdminQueueSamplesSuspenseQueryOptions(name, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminRecordKeeperExportQueues = (params, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeper-export-queues`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminRecordKeeperExportQueuesQueryKey = (params)=>{
    return [
        `/api/v3/admin/record-keeper-export-queues`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminRecordKeeperExportQueuesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeeperExportQueuesQueryKey(params);
    const queryFn = ({ signal })=>getAdminRecordKeeperExportQueues(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminRecordKeeperExportQueues(params, options, queryClient) {
    const queryOptions = getGetAdminRecordKeeperExportQueuesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeeperExportQueuesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeeperExportQueuesQueryKey(params);
    const queryFn = ({ signal })=>getAdminRecordKeeperExportQueues(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeeperExportQueuesSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminRecordKeeperExportQueuesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminRecordKeeperExportQueueErrorTimeSeries = (recordKeeperExportQueueErrorTimeSeriesBody, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeper-export-queues/error-time-series`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: recordKeeperExportQueueErrorTimeSeriesBody,
        signal
    });
};
export const getPostAdminRecordKeeperExportQueueErrorTimeSeriesMutationKey = ()=>[
        'postAdminRecordKeeperExportQueueErrorTimeSeries'
    ];
export const getPostAdminRecordKeeperExportQueueErrorTimeSeriesMutationOptions = (options)=>{
    const mutationKey = getPostAdminRecordKeeperExportQueueErrorTimeSeriesMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminRecordKeeperExportQueueErrorTimeSeries(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminRecordKeeperExportQueueErrorTimeSeries = (options, queryClient)=>{
    return useMutation(getPostAdminRecordKeeperExportQueueErrorTimeSeriesMutationOptions(options), queryClient);
};
export const getAdminRecordKeeperExportQueue = (id, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeper-export-queues/${id}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRecordKeeperExportQueueQueryKey = (id)=>{
    return [
        `/api/v3/admin/record-keeper-export-queues/${id}`
    ];
};
export const getGetAdminRecordKeeperExportQueueQueryOptions = (id, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeeperExportQueueQueryKey(id);
    const queryFn = ({ signal })=>getAdminRecordKeeperExportQueue(id, signal);
    return {
        queryKey,
        queryFn,
        enabled: id !== null && id !== undefined,
        ...queryOptions
    };
};
export function useGetAdminRecordKeeperExportQueue(id, options, queryClient) {
    const queryOptions = getGetAdminRecordKeeperExportQueueQueryOptions(id, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeeperExportQueueSuspenseQueryOptions = (id, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeeperExportQueueQueryKey(id);
    const queryFn = ({ signal })=>getAdminRecordKeeperExportQueue(id, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeeperExportQueueSuspense(id, options, queryClient) {
    const queryOptions = getGetAdminRecordKeeperExportQueueSuspenseQueryOptions(id, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminRecordKeeperExportQueueReprocess = (id, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeper-export-queues/${id}/reprocess`,
        method: 'POST',
        signal
    });
};
export const getPostAdminRecordKeeperExportQueueReprocessMutationKey = ()=>[
        'postAdminRecordKeeperExportQueueReprocess'
    ];
export const getPostAdminRecordKeeperExportQueueReprocessMutationOptions = (options)=>{
    const mutationKey = getPostAdminRecordKeeperExportQueueReprocessMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { id } = props ?? {};
        return postAdminRecordKeeperExportQueueReprocess(id);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminRecordKeeperExportQueueReprocess = (options, queryClient)=>{
    return useMutation(getPostAdminRecordKeeperExportQueueReprocessMutationOptions(options), queryClient);
};
export const getAdminRecordKeepingOrganizations = (params, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminRecordKeepingOrganizationsQueryKey = (params)=>{
    return [
        `/api/v3/admin/record-keeping-organizations`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminRecordKeepingOrganizationsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizations(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminRecordKeepingOrganizations(params, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeepingOrganizationsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationsQueryKey(params);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizations(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeepingOrganizationsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminRecordKeepingOrganization = (createRecordKeepingOrganizationBody, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createRecordKeepingOrganizationBody,
        signal
    });
};
export const getPostAdminRecordKeepingOrganizationMutationKey = ()=>[
        'postAdminRecordKeepingOrganization'
    ];
export const getPostAdminRecordKeepingOrganizationMutationOptions = (options)=>{
    const mutationKey = getPostAdminRecordKeepingOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminRecordKeepingOrganization(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminRecordKeepingOrganization = (options, queryClient)=>{
    return useMutation(getPostAdminRecordKeepingOrganizationMutationOptions(options), queryClient);
};
export const getAdminRkoLicenseTypes = (signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/license-types`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRkoLicenseTypesQueryKey = ()=>{
    return [
        `/api/v3/admin/record-keeping-organizations/license-types`
    ];
};
export const getGetAdminRkoLicenseTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRkoLicenseTypesQueryKey();
    const queryFn = ({ signal })=>getAdminRkoLicenseTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminRkoLicenseTypes(options, queryClient) {
    const queryOptions = getGetAdminRkoLicenseTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRkoLicenseTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRkoLicenseTypesQueryKey();
    const queryFn = ({ signal })=>getAdminRkoLicenseTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRkoLicenseTypesSuspense(options, queryClient) {
    const queryOptions = getGetAdminRkoLicenseTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminRecordKeeperTypes = (signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/types`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRecordKeeperTypesQueryKey = ()=>{
    return [
        `/api/v3/admin/record-keeping-organizations/types`
    ];
};
export const getGetAdminRecordKeeperTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeeperTypesQueryKey();
    const queryFn = ({ signal })=>getAdminRecordKeeperTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminRecordKeeperTypes(options, queryClient) {
    const queryOptions = getGetAdminRecordKeeperTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeeperTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeeperTypesQueryKey();
    const queryFn = ({ signal })=>getAdminRecordKeeperTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeeperTypesSuspense(options, queryClient) {
    const queryOptions = getGetAdminRecordKeeperTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminRecordKeepingOrganization = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminRecordKeepingOrganizationMutationKey = ()=>[
        'deleteAdminRecordKeepingOrganization'
    ];
export const getDeleteAdminRecordKeepingOrganizationMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminRecordKeepingOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId } = props ?? {};
        return deleteAdminRecordKeepingOrganization(recordKeepingOrganizationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminRecordKeepingOrganization = (options, queryClient)=>{
    return useMutation(getDeleteAdminRecordKeepingOrganizationMutationOptions(options), queryClient);
};
export const getAdminRecordKeepingOrganization = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRecordKeepingOrganizationQueryKey = (recordKeepingOrganizationId)=>{
    return [
        `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}`
    ];
};
export const getGetAdminRecordKeepingOrganizationQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganization(recordKeepingOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: recordKeepingOrganizationId !== null && recordKeepingOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminRecordKeepingOrganization(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationQueryOptions(recordKeepingOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeepingOrganizationSuspenseQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganization(recordKeepingOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeepingOrganizationSuspense(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationSuspenseQueryOptions(recordKeepingOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminRecordKeepingOrganization = (recordKeepingOrganizationId, updateRecordKeepingOrganizationBody, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateRecordKeepingOrganizationBody,
        signal
    });
};
export const getPatchAdminRecordKeepingOrganizationMutationKey = ()=>[
        'patchAdminRecordKeepingOrganization'
    ];
export const getPatchAdminRecordKeepingOrganizationMutationOptions = (options)=>{
    const mutationKey = getPatchAdminRecordKeepingOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, data } = props ?? {};
        return patchAdminRecordKeepingOrganization(recordKeepingOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminRecordKeepingOrganization = (options, queryClient)=>{
    return useMutation(getPatchAdminRecordKeepingOrganizationMutationOptions(options), queryClient);
};
export const getAdminRecordKeepingOrganizationAdvisoryOrganizations = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/advisory-organizations`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRecordKeepingOrganizationAdvisoryOrganizationsQueryKey = (recordKeepingOrganizationId)=>{
    return [
        `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/advisory-organizations`
    ];
};
export const getGetAdminRecordKeepingOrganizationAdvisoryOrganizationsQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationAdvisoryOrganizationsQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationAdvisoryOrganizations(recordKeepingOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: recordKeepingOrganizationId !== null && recordKeepingOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminRecordKeepingOrganizationAdvisoryOrganizations(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationAdvisoryOrganizationsQueryOptions(recordKeepingOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeepingOrganizationAdvisoryOrganizationsSuspenseQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationAdvisoryOrganizationsQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationAdvisoryOrganizations(recordKeepingOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeepingOrganizationAdvisoryOrganizationsSuspense(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationAdvisoryOrganizationsSuspenseQueryOptions(recordKeepingOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminAnnuityCarrier = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/annuity-carrier`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminAnnuityCarrierMutationKey = ()=>[
        'deleteAdminAnnuityCarrier'
    ];
export const getDeleteAdminAnnuityCarrierMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminAnnuityCarrierMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId } = props ?? {};
        return deleteAdminAnnuityCarrier(recordKeepingOrganizationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminAnnuityCarrier = (options, queryClient)=>{
    return useMutation(getDeleteAdminAnnuityCarrierMutationOptions(options), queryClient);
};
export const getAdminAnnuityCarrier = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/annuity-carrier`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAnnuityCarrierQueryKey = (recordKeepingOrganizationId)=>{
    return [
        `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/annuity-carrier`
    ];
};
export const getGetAdminAnnuityCarrierQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAnnuityCarrierQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminAnnuityCarrier(recordKeepingOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: recordKeepingOrganizationId !== null && recordKeepingOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminAnnuityCarrier(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAnnuityCarrierQueryOptions(recordKeepingOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAnnuityCarrierSuspenseQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAnnuityCarrierQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminAnnuityCarrier(recordKeepingOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAnnuityCarrierSuspense(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminAnnuityCarrierSuspenseQueryOptions(recordKeepingOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminAnnuityCarrier = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/annuity-carrier`,
        method: 'POST',
        signal
    });
};
export const getPostAdminAnnuityCarrierMutationKey = ()=>[
        'postAdminAnnuityCarrier'
    ];
export const getPostAdminAnnuityCarrierMutationOptions = (options)=>{
    const mutationKey = getPostAdminAnnuityCarrierMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId } = props ?? {};
        return postAdminAnnuityCarrier(recordKeepingOrganizationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminAnnuityCarrier = (options, queryClient)=>{
    return useMutation(getPostAdminAnnuityCarrierMutationOptions(options), queryClient);
};
export const getAdminRecordKeepingOrganizationIntegrations = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/integrations`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRecordKeepingOrganizationIntegrationsQueryKey = (recordKeepingOrganizationId)=>{
    return [
        `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/integrations`
    ];
};
export const getGetAdminRecordKeepingOrganizationIntegrationsQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationIntegrationsQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationIntegrations(recordKeepingOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: recordKeepingOrganizationId !== null && recordKeepingOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminRecordKeepingOrganizationIntegrations(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationIntegrationsQueryOptions(recordKeepingOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeepingOrganizationIntegrationsSuspenseQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationIntegrationsQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationIntegrations(recordKeepingOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeepingOrganizationIntegrationsSuspense(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationIntegrationsSuspenseQueryOptions(recordKeepingOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteAdminRecordKeepingOrganizationIntegration = (recordKeepingOrganizationId, integrationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/integrations/${integrationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminRecordKeepingOrganizationIntegrationMutationKey = ()=>[
        'deleteAdminRecordKeepingOrganizationIntegration'
    ];
export const getDeleteAdminRecordKeepingOrganizationIntegrationMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminRecordKeepingOrganizationIntegrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, integrationId } = props ?? {};
        return deleteAdminRecordKeepingOrganizationIntegration(recordKeepingOrganizationId, integrationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminRecordKeepingOrganizationIntegration = (options, queryClient)=>{
    return useMutation(getDeleteAdminRecordKeepingOrganizationIntegrationMutationOptions(options), queryClient);
};
export const postAdminRecordKeepingOrganizationIntegration = (recordKeepingOrganizationId, integrationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/integrations/${integrationId}`,
        method: 'POST',
        signal
    });
};
export const getPostAdminRecordKeepingOrganizationIntegrationMutationKey = ()=>[
        'postAdminRecordKeepingOrganizationIntegration'
    ];
export const getPostAdminRecordKeepingOrganizationIntegrationMutationOptions = (options)=>{
    const mutationKey = getPostAdminRecordKeepingOrganizationIntegrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, integrationId } = props ?? {};
        return postAdminRecordKeepingOrganizationIntegration(recordKeepingOrganizationId, integrationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminRecordKeepingOrganizationIntegration = (options, queryClient)=>{
    return useMutation(getPostAdminRecordKeepingOrganizationIntegrationMutationOptions(options), queryClient);
};
export const getAdminRecordKeepingOrganizationLicenses = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/licenses`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRecordKeepingOrganizationLicensesQueryKey = (recordKeepingOrganizationId)=>{
    return [
        `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/licenses`
    ];
};
export const getGetAdminRecordKeepingOrganizationLicensesQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationLicensesQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationLicenses(recordKeepingOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: recordKeepingOrganizationId !== null && recordKeepingOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminRecordKeepingOrganizationLicenses(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationLicensesQueryOptions(recordKeepingOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeepingOrganizationLicensesSuspenseQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationLicensesQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationLicenses(recordKeepingOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeepingOrganizationLicensesSuspense(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationLicensesSuspenseQueryOptions(recordKeepingOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminRecordKeepingOrganizationLicense = (recordKeepingOrganizationId, createRkoLicenseBody, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/licenses`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createRkoLicenseBody,
        signal
    });
};
export const getPostAdminRecordKeepingOrganizationLicenseMutationKey = ()=>[
        'postAdminRecordKeepingOrganizationLicense'
    ];
export const getPostAdminRecordKeepingOrganizationLicenseMutationOptions = (options)=>{
    const mutationKey = getPostAdminRecordKeepingOrganizationLicenseMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, data } = props ?? {};
        return postAdminRecordKeepingOrganizationLicense(recordKeepingOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminRecordKeepingOrganizationLicense = (options, queryClient)=>{
    return useMutation(getPostAdminRecordKeepingOrganizationLicenseMutationOptions(options), queryClient);
};
export const deleteAdminRecordKeepingOrganizationLicense = (recordKeepingOrganizationId, rkoLicenseId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/licenses/${rkoLicenseId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminRecordKeepingOrganizationLicenseMutationKey = ()=>[
        'deleteAdminRecordKeepingOrganizationLicense'
    ];
export const getDeleteAdminRecordKeepingOrganizationLicenseMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminRecordKeepingOrganizationLicenseMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, rkoLicenseId } = props ?? {};
        return deleteAdminRecordKeepingOrganizationLicense(recordKeepingOrganizationId, rkoLicenseId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminRecordKeepingOrganizationLicense = (options, queryClient)=>{
    return useMutation(getDeleteAdminRecordKeepingOrganizationLicenseMutationOptions(options), queryClient);
};
export const getAdminRecordKeepingOrganizationSsos = (recordKeepingOrganizationId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/ssos`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRecordKeepingOrganizationSsosQueryKey = (recordKeepingOrganizationId)=>{
    return [
        `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/ssos`
    ];
};
export const getGetAdminRecordKeepingOrganizationSsosQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationSsosQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationSsos(recordKeepingOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: recordKeepingOrganizationId !== null && recordKeepingOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminRecordKeepingOrganizationSsos(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationSsosQueryOptions(recordKeepingOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRecordKeepingOrganizationSsosSuspenseQueryOptions = (recordKeepingOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRecordKeepingOrganizationSsosQueryKey(recordKeepingOrganizationId);
    const queryFn = ({ signal })=>getAdminRecordKeepingOrganizationSsos(recordKeepingOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRecordKeepingOrganizationSsosSuspense(recordKeepingOrganizationId, options, queryClient) {
    const queryOptions = getGetAdminRecordKeepingOrganizationSsosSuspenseQueryOptions(recordKeepingOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminRecordKeepingOrganizationSso = (recordKeepingOrganizationId, upsertRkoSsoBody, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/ssos`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: upsertRkoSsoBody,
        signal
    });
};
export const getPostAdminRecordKeepingOrganizationSsoMutationKey = ()=>[
        'postAdminRecordKeepingOrganizationSso'
    ];
export const getPostAdminRecordKeepingOrganizationSsoMutationOptions = (options)=>{
    const mutationKey = getPostAdminRecordKeepingOrganizationSsoMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, data } = props ?? {};
        return postAdminRecordKeepingOrganizationSso(recordKeepingOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminRecordKeepingOrganizationSso = (options, queryClient)=>{
    return useMutation(getPostAdminRecordKeepingOrganizationSsoMutationOptions(options), queryClient);
};
export const deleteAdminRecordKeepingOrganizationSso = (recordKeepingOrganizationId, ssoId, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/ssos/${ssoId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdminRecordKeepingOrganizationSsoMutationKey = ()=>[
        'deleteAdminRecordKeepingOrganizationSso'
    ];
export const getDeleteAdminRecordKeepingOrganizationSsoMutationOptions = (options)=>{
    const mutationKey = getDeleteAdminRecordKeepingOrganizationSsoMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, ssoId } = props ?? {};
        return deleteAdminRecordKeepingOrganizationSso(recordKeepingOrganizationId, ssoId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdminRecordKeepingOrganizationSso = (options, queryClient)=>{
    return useMutation(getDeleteAdminRecordKeepingOrganizationSsoMutationOptions(options), queryClient);
};
export const patchAdminRecordKeepingOrganizationSso = (recordKeepingOrganizationId, ssoId, upsertRkoSsoBody, signal)=>{
    return client({
        url: `/api/v3/admin/record-keeping-organizations/${recordKeepingOrganizationId}/ssos/${ssoId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: upsertRkoSsoBody,
        signal
    });
};
export const getPatchAdminRecordKeepingOrganizationSsoMutationKey = ()=>[
        'patchAdminRecordKeepingOrganizationSso'
    ];
export const getPatchAdminRecordKeepingOrganizationSsoMutationOptions = (options)=>{
    const mutationKey = getPatchAdminRecordKeepingOrganizationSsoMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeepingOrganizationId, ssoId, data } = props ?? {};
        return patchAdminRecordKeepingOrganizationSso(recordKeepingOrganizationId, ssoId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminRecordKeepingOrganizationSso = (options, queryClient)=>{
    return useMutation(getPatchAdminRecordKeepingOrganizationSsoMutationOptions(options), queryClient);
};
export const getAdminLoginHealth = (params, signal)=>{
    return client({
        url: `/api/v3/admin/relationship-health/login-health`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminLoginHealthQueryKey = (params)=>{
    return [
        `/api/v3/admin/relationship-health/login-health`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminLoginHealthQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginHealthQueryKey(params);
    const queryFn = ({ signal })=>getAdminLoginHealth(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminLoginHealth(params, options, queryClient) {
    const queryOptions = getGetAdminLoginHealthQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminLoginHealthSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminLoginHealthQueryKey(params);
    const queryFn = ({ signal })=>getAdminLoginHealth(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminLoginHealthSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminLoginHealthSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminReliusArchivedPlans = (params, signal)=>{
    return client({
        url: `/api/v3/admin/relius/archived-plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminReliusArchivedPlansQueryKey = (params)=>{
    return [
        `/api/v3/admin/relius/archived-plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminReliusArchivedPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminReliusArchivedPlansQueryKey(params);
    const queryFn = ({ signal })=>getAdminReliusArchivedPlans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminReliusArchivedPlans(params, options, queryClient) {
    const queryOptions = getGetAdminReliusArchivedPlansQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminReliusArchivedPlansSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminReliusArchivedPlansQueryKey(params);
    const queryFn = ({ signal })=>getAdminReliusArchivedPlans(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminReliusArchivedPlansSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminReliusArchivedPlansSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminReliusConsoleFunctions = (signal)=>{
    return client({
        url: `/api/v3/admin/relius/console/functions`,
        method: 'GET',
        signal
    });
};
export const getGetAdminReliusConsoleFunctionsQueryKey = ()=>{
    return [
        `/api/v3/admin/relius/console/functions`
    ];
};
export const getGetAdminReliusConsoleFunctionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminReliusConsoleFunctionsQueryKey();
    const queryFn = ({ signal })=>getAdminReliusConsoleFunctions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminReliusConsoleFunctions(options, queryClient) {
    const queryOptions = getGetAdminReliusConsoleFunctionsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminReliusConsoleFunctionsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminReliusConsoleFunctionsQueryKey();
    const queryFn = ({ signal })=>getAdminReliusConsoleFunctions(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminReliusConsoleFunctionsSuspense(options, queryClient) {
    const queryOptions = getGetAdminReliusConsoleFunctionsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminRkTransactionExports = (params, signal)=>{
    return client({
        url: `/api/v3/admin/rk-transaction-exports`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminRkTransactionExportsQueryKey = (params)=>{
    return [
        `/api/v3/admin/rk-transaction-exports`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminRkTransactionExportsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRkTransactionExportsQueryKey(params);
    const queryFn = ({ signal })=>getAdminRkTransactionExports(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminRkTransactionExports(params, options, queryClient) {
    const queryOptions = getGetAdminRkTransactionExportsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRkTransactionExportsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRkTransactionExportsQueryKey(params);
    const queryFn = ({ signal })=>getAdminRkTransactionExports(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRkTransactionExportsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminRkTransactionExportsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminRkTransactionExport = (id, patchAdminRkTransactionExportBody, signal)=>{
    return client({
        url: `/api/v3/admin/rk-transaction-exports/${id}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAdminRkTransactionExportBody,
        signal
    });
};
export const getPatchAdminRkTransactionExportMutationKey = ()=>[
        'patchAdminRkTransactionExport'
    ];
export const getPatchAdminRkTransactionExportMutationOptions = (options)=>{
    const mutationKey = getPatchAdminRkTransactionExportMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { id, data } = props ?? {};
        return patchAdminRkTransactionExport(id, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminRkTransactionExport = (options, queryClient)=>{
    return useMutation(getPatchAdminRkTransactionExportMutationOptions(options), queryClient);
};
export const getAdminRkTransactions = (params, signal)=>{
    return client({
        url: `/api/v3/admin/rk-transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminRkTransactionsQueryKey = (params)=>{
    return [
        `/api/v3/admin/rk-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminRkTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRkTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getAdminRkTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminRkTransactions(params, options, queryClient) {
    const queryOptions = getGetAdminRkTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRkTransactionsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRkTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getAdminRkTransactions(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRkTransactionsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminRkTransactionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminRolloverProviders = (signal)=>{
    return client({
        url: `/api/v3/admin/rollover-providers`,
        method: 'GET',
        signal
    });
};
export const getGetAdminRolloverProvidersQueryKey = ()=>{
    return [
        `/api/v3/admin/rollover-providers`
    ];
};
export const getGetAdminRolloverProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRolloverProvidersQueryKey();
    const queryFn = ({ signal })=>getAdminRolloverProviders(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminRolloverProviders(options, queryClient) {
    const queryOptions = getGetAdminRolloverProvidersQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminRolloverProvidersSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminRolloverProvidersQueryKey();
    const queryFn = ({ signal })=>getAdminRolloverProviders(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminRolloverProvidersSuspense(options, queryClient) {
    const queryOptions = getGetAdminRolloverProvidersSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const listBuckets = (signal)=>{
    return client({
        url: `/api/v3/admin/s3/buckets`,
        method: 'GET',
        signal
    });
};
export const getListBucketsQueryKey = ()=>{
    return [
        `/api/v3/admin/s3/buckets`
    ];
};
export const getListBucketsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListBucketsQueryKey();
    const queryFn = ({ signal })=>listBuckets(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useListBuckets(options, queryClient) {
    const queryOptions = getListBucketsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getListBucketsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListBucketsQueryKey();
    const queryFn = ({ signal })=>listBuckets(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useListBucketsSuspense(options, queryClient) {
    const queryOptions = getListBucketsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const createFolder = (bucket, createFolderBody, signal)=>{
    return client({
        url: `/api/v3/admin/s3/buckets/${bucket}/folders`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createFolderBody,
        signal
    });
};
export const getCreateFolderMutationKey = ()=>[
        'createFolder'
    ];
export const getCreateFolderMutationOptions = (options)=>{
    const mutationKey = getCreateFolderMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { bucket, data } = props ?? {};
        return createFolder(bucket, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useCreateFolder = (options, queryClient)=>{
    return useMutation(getCreateFolderMutationOptions(options), queryClient);
};
export const deleteObject = (bucket, objectKeyBody, signal)=>{
    return client({
        url: `/api/v3/admin/s3/buckets/${bucket}/objects`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: objectKeyBody,
        signal
    });
};
export const getDeleteObjectMutationKey = ()=>[
        'deleteObject'
    ];
export const getDeleteObjectMutationOptions = (options)=>{
    const mutationKey = getDeleteObjectMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { bucket, data } = props ?? {};
        return deleteObject(bucket, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteObject = (options, queryClient)=>{
    return useMutation(getDeleteObjectMutationOptions(options), queryClient);
};
export const listObjects = (bucket, params, signal)=>{
    return client({
        url: `/api/v3/admin/s3/buckets/${bucket}/objects`,
        method: 'GET',
        params,
        signal
    });
};
export const getListObjectsQueryKey = (bucket, params)=>{
    return [
        `/api/v3/admin/s3/buckets/${bucket}/objects`,
        ...params ? [
            params
        ] : []
    ];
};
export const getListObjectsQueryOptions = (bucket, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListObjectsQueryKey(bucket, params);
    const queryFn = ({ signal })=>listObjects(bucket, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: bucket !== null && bucket !== undefined,
        ...queryOptions
    };
};
export function useListObjects(bucket, params, options, queryClient) {
    const queryOptions = getListObjectsQueryOptions(bucket, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getListObjectsSuspenseQueryOptions = (bucket, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getListObjectsQueryKey(bucket, params);
    const queryFn = ({ signal })=>listObjects(bucket, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useListObjectsSuspense(bucket, params, options, queryClient) {
    const queryOptions = getListObjectsSuspenseQueryOptions(bucket, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const uploadObject = (bucket, uploadObjectBody, signal)=>{
    return client({
        url: `/api/v3/admin/s3/buckets/${bucket}/objects`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: uploadObjectBody,
        signal
    });
};
export const getUploadObjectMutationKey = ()=>[
        'uploadObject'
    ];
export const getUploadObjectMutationOptions = (options)=>{
    const mutationKey = getUploadObjectMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { bucket, data } = props ?? {};
        return uploadObject(bucket, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useUploadObject = (options, queryClient)=>{
    return useMutation(getUploadObjectMutationOptions(options), queryClient);
};
export const getDownloadUrl = (bucket, params, signal)=>{
    return client({
        url: `/api/v3/admin/s3/buckets/${bucket}/objects/download`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDownloadUrlQueryKey = (bucket, params)=>{
    return [
        `/api/v3/admin/s3/buckets/${bucket}/objects/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDownloadUrlQueryOptions = (bucket, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadUrlQueryKey(bucket, params);
    const queryFn = ({ signal })=>getDownloadUrl(bucket, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: bucket !== null && bucket !== undefined,
        ...queryOptions
    };
};
export function useGetDownloadUrl(bucket, params, options, queryClient) {
    const queryOptions = getGetDownloadUrlQueryOptions(bucket, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetDownloadUrlSuspenseQueryOptions = (bucket, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadUrlQueryKey(bucket, params);
    const queryFn = ({ signal })=>getDownloadUrl(bucket, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetDownloadUrlSuspense(bucket, params, options, queryClient) {
    const queryOptions = getGetDownloadUrlSuspenseQueryOptions(bucket, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const moveObject = (moveObjectBody, signal)=>{
    return client({
        url: `/api/v3/admin/s3/move`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: moveObjectBody,
        signal
    });
};
export const getMoveObjectMutationKey = ()=>[
        'moveObject'
    ];
export const getMoveObjectMutationOptions = (options)=>{
    const mutationKey = getMoveObjectMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return moveObject(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useMoveObject = (options, queryClient)=>{
    return useMutation(getMoveObjectMutationOptions(options), queryClient);
};
export const getSettings = (signal)=>{
    return client({
        url: `/api/v3/admin/s3/settings`,
        method: 'GET',
        signal
    });
};
export const getGetSettingsQueryKey = ()=>{
    return [
        `/api/v3/admin/s3/settings`
    ];
};
export const getGetSettingsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();
    const queryFn = ({ signal })=>getSettings(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetSettings(options, queryClient) {
    const queryOptions = getGetSettingsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetSettingsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSettingsQueryKey();
    const queryFn = ({ signal })=>getSettings(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetSettingsSuspense(options, queryClient) {
    const queryOptions = getGetSettingsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminSsoErrors = (params, signal)=>{
    return client({
        url: `/api/v3/admin/sso-errors`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdminSsoErrorsQueryKey = (params)=>{
    return [
        `/api/v3/admin/sso-errors`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdminSsoErrorsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminSsoErrorsQueryKey(params);
    const queryFn = ({ signal })=>getAdminSsoErrors(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminSsoErrors(params, options, queryClient) {
    const queryOptions = getGetAdminSsoErrorsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminSsoErrorsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminSsoErrorsQueryKey(params);
    const queryFn = ({ signal })=>getAdminSsoErrors(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminSsoErrorsSuspense(params, options, queryClient) {
    const queryOptions = getGetAdminSsoErrorsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdminSsoErrorTimeSeries = (postAdminSsoErrorTimeSeriesBody, signal)=>{
    return client({
        url: `/api/v3/admin/sso-errors/time-series`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdminSsoErrorTimeSeriesBody,
        signal
    });
};
export const getPostAdminSsoErrorTimeSeriesMutationKey = ()=>[
        'postAdminSsoErrorTimeSeries'
    ];
export const getPostAdminSsoErrorTimeSeriesMutationOptions = (options)=>{
    const mutationKey = getPostAdminSsoErrorTimeSeriesMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdminSsoErrorTimeSeries(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdminSsoErrorTimeSeries = (options, queryClient)=>{
    return useMutation(getPostAdminSsoErrorTimeSeriesMutationOptions(options), queryClient);
};
export const getAdminSsoError = (ssoErrorId, signal)=>{
    return client({
        url: `/api/v3/admin/sso-errors/${ssoErrorId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdminSsoErrorQueryKey = (ssoErrorId)=>{
    return [
        `/api/v3/admin/sso-errors/${ssoErrorId}`
    ];
};
export const getGetAdminSsoErrorQueryOptions = (ssoErrorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminSsoErrorQueryKey(ssoErrorId);
    const queryFn = ({ signal })=>getAdminSsoError(ssoErrorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: ssoErrorId !== null && ssoErrorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdminSsoError(ssoErrorId, options, queryClient) {
    const queryOptions = getGetAdminSsoErrorQueryOptions(ssoErrorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminSsoErrorSuspenseQueryOptions = (ssoErrorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminSsoErrorQueryKey(ssoErrorId);
    const queryFn = ({ signal })=>getAdminSsoError(ssoErrorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminSsoErrorSuspense(ssoErrorId, options, queryClient) {
    const queryOptions = getGetAdminSsoErrorSuspenseQueryOptions(ssoErrorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdminSsoError = (ssoErrorId, patchSsoErrorBody, signal)=>{
    return client({
        url: `/api/v3/admin/sso-errors/${ssoErrorId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchSsoErrorBody,
        signal
    });
};
export const getPatchAdminSsoErrorMutationKey = ()=>[
        'patchAdminSsoError'
    ];
export const getPatchAdminSsoErrorMutationOptions = (options)=>{
    const mutationKey = getPatchAdminSsoErrorMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { ssoErrorId, data } = props ?? {};
        return patchAdminSsoError(ssoErrorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdminSsoError = (options, queryClient)=>{
    return useMutation(getPatchAdminSsoErrorMutationOptions(options), queryClient);
};
export const getAdminWhiteLabels = (signal)=>{
    return client({
        url: `/api/v3/admin/white-labels`,
        method: 'GET',
        signal
    });
};
export const getGetAdminWhiteLabelsQueryKey = ()=>{
    return [
        `/api/v3/admin/white-labels`
    ];
};
export const getGetAdminWhiteLabelsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminWhiteLabelsQueryKey();
    const queryFn = ({ signal })=>getAdminWhiteLabels(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminWhiteLabels(options, queryClient) {
    const queryOptions = getGetAdminWhiteLabelsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminWhiteLabelsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminWhiteLabelsQueryKey();
    const queryFn = ({ signal })=>getAdminWhiteLabels(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminWhiteLabelsSuspense(options, queryClient) {
    const queryOptions = getGetAdminWhiteLabelsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteWhitelabel = (whiteLabelId, signal)=>{
    return client({
        url: `/api/v3/admin/whitelabels/${whiteLabelId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteWhitelabelMutationKey = ()=>[
        'deleteWhitelabel'
    ];
export const getDeleteWhitelabelMutationOptions = (options)=>{
    const mutationKey = getDeleteWhitelabelMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { whiteLabelId } = props ?? {};
        return deleteWhitelabel(whiteLabelId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteWhitelabel = (options, queryClient)=>{
    return useMutation(getDeleteWhitelabelMutationOptions(options), queryClient);
};
export const getWhitelabelById = (whiteLabelId, signal)=>{
    return client({
        url: `/api/v3/admin/whitelabels/${whiteLabelId}`,
        method: 'GET',
        signal
    });
};
export const getGetWhitelabelByIdQueryKey = (whiteLabelId)=>{
    return [
        `/api/v3/admin/whitelabels/${whiteLabelId}`
    ];
};
export const getGetWhitelabelByIdQueryOptions = (whiteLabelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWhitelabelByIdQueryKey(whiteLabelId);
    const queryFn = ({ signal })=>getWhitelabelById(whiteLabelId, signal);
    return {
        queryKey,
        queryFn,
        enabled: whiteLabelId !== null && whiteLabelId !== undefined,
        ...queryOptions
    };
};
export function useGetWhitelabelById(whiteLabelId, options, queryClient) {
    const queryOptions = getGetWhitelabelByIdQueryOptions(whiteLabelId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetWhitelabelByIdSuspenseQueryOptions = (whiteLabelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWhitelabelByIdQueryKey(whiteLabelId);
    const queryFn = ({ signal })=>getWhitelabelById(whiteLabelId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetWhitelabelByIdSuspense(whiteLabelId, options, queryClient) {
    const queryOptions = getGetWhitelabelByIdSuspenseQueryOptions(whiteLabelId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchWhitelabel = (whiteLabelId, patchWhitelabelBody, signal)=>{
    return client({
        url: `/api/v3/admin/whitelabels/${whiteLabelId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchWhitelabelBody,
        signal
    });
};
export const getPatchWhitelabelMutationKey = ()=>[
        'patchWhitelabel'
    ];
export const getPatchWhitelabelMutationOptions = (options)=>{
    const mutationKey = getPatchWhitelabelMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { whiteLabelId, data } = props ?? {};
        return patchWhitelabel(whiteLabelId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchWhitelabel = (options, queryClient)=>{
    return useMutation(getPatchWhitelabelMutationOptions(options), queryClient);
};
export const getActParticipants = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/act-participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetActParticipantsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/act-participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetActParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetActParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getActParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetActParticipants(params, options, queryClient) {
    const queryOptions = getGetActParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetActParticipantsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetActParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getActParticipants(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetActParticipantsSuspense(params, options, queryClient) {
    const queryOptions = getGetActParticipantsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportActParticipants = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/act-participants/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportActParticipantsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/act-participants/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportActParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportActParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getExportActParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportActParticipants(params, options, queryClient) {
    const queryOptions = getGetExportActParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportActParticipantsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportActParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getExportActParticipants(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportActParticipantsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportActParticipantsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorActivity = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/activity`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorActivityQueryKey = (params)=>{
    return [
        `/api/v3/advisor/activity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorActivityQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorActivityQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorActivity(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdvisorActivity(params, options, queryClient) {
    const queryOptions = getGetAdvisorActivityQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorActivitySuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorActivityQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorActivity(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorActivitySuspense(params, options, queryClient) {
    const queryOptions = getGetAdvisorActivitySuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportAdvisorActivity = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/activity/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportAdvisorActivityQueryKey = (params)=>{
    return [
        `/api/v3/advisor/activity/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportAdvisorActivityQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAdvisorActivityQueryKey(params);
    const queryFn = ({ signal })=>getExportAdvisorActivity(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportAdvisorActivity(params, options, queryClient) {
    const queryOptions = getGetExportAdvisorActivityQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportAdvisorActivitySuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAdvisorActivityQueryKey(params);
    const queryFn = ({ signal })=>getExportAdvisorActivity(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportAdvisorActivitySuspense(params, options, queryClient) {
    const queryOptions = getGetExportAdvisorActivitySuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postReprocessAdvisorActivity = (jobId, signal)=>{
    return client({
        url: `/api/v3/advisor/activity/${jobId}/reprocess`,
        method: 'POST',
        signal
    });
};
export const getPostReprocessAdvisorActivityMutationKey = ()=>[
        'postReprocessAdvisorActivity'
    ];
export const getPostReprocessAdvisorActivityMutationOptions = (options)=>{
    const mutationKey = getPostReprocessAdvisorActivityMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { jobId } = props ?? {};
        return postReprocessAdvisorActivity(jobId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostReprocessAdvisorActivity = (options, queryClient)=>{
    return useMutation(getPostReprocessAdvisorActivityMutationOptions(options), queryClient);
};
export const deleteAdvisorAuth = (signal)=>{
    return client({
        url: `/api/v3/advisor/auth/logout`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdvisorAuthMutationKey = ()=>[
        'deleteAdvisorAuth'
    ];
export const getDeleteAdvisorAuthMutationOptions = (options)=>{
    const mutationKey = getDeleteAdvisorAuthMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return deleteAdvisorAuth();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdvisorAuth = (options, queryClient)=>{
    return useMutation(getDeleteAdvisorAuthMutationOptions(options), queryClient);
};
export const getAutoForceOuts = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/auto-force-outs`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAutoForceOutsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/auto-force-outs`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAutoForceOutsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAutoForceOutsQueryKey(params);
    const queryFn = ({ signal })=>getAutoForceOuts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAutoForceOuts(params, options, queryClient) {
    const queryOptions = getGetAutoForceOutsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAutoForceOutsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAutoForceOutsQueryKey(params);
    const queryFn = ({ signal })=>getAutoForceOuts(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAutoForceOutsSuspense(params, options, queryClient) {
    const queryOptions = getGetAutoForceOutsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportAutoForceOuts = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/auto-force-outs/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportAutoForceOutsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/auto-force-outs/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportAutoForceOutsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAutoForceOutsQueryKey(params);
    const queryFn = ({ signal })=>getExportAutoForceOuts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportAutoForceOuts(params, options, queryClient) {
    const queryOptions = getGetExportAutoForceOutsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportAutoForceOutsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAutoForceOutsQueryKey(params);
    const queryFn = ({ signal })=>getExportAutoForceOuts(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportAutoForceOutsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportAutoForceOutsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorAutoJobQueueErrorCount = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/auto-job-queues/error-count`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorAutoJobQueueErrorCountQueryKey = (params)=>{
    return [
        `/api/v3/advisor/auto-job-queues/error-count`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorAutoJobQueueErrorCountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorAutoJobQueueErrorCountQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorAutoJobQueueErrorCount(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdvisorAutoJobQueueErrorCount(params, options, queryClient) {
    const queryOptions = getGetAdvisorAutoJobQueueErrorCountQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorAutoJobQueueErrorCountSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorAutoJobQueueErrorCountQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorAutoJobQueueErrorCount(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorAutoJobQueueErrorCountSuspense(params, options, queryClient) {
    const queryOptions = getGetAdvisorAutoJobQueueErrorCountSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCampaignSummary = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/campaign-summary`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCampaignSummaryQueryKey = (params)=>{
    return [
        `/api/v3/advisor/campaign-summary`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCampaignSummaryQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCampaignSummaryQueryKey(params);
    const queryFn = ({ signal })=>getCampaignSummary(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetCampaignSummary(params, options, queryClient) {
    const queryOptions = getGetCampaignSummaryQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetCampaignSummarySuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCampaignSummaryQueryKey(params);
    const queryFn = ({ signal })=>getCampaignSummary(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetCampaignSummarySuspense(params, options, queryClient) {
    const queryOptions = getGetCampaignSummarySuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportCampaignSummary = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/campaign-summary/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportCampaignSummaryQueryKey = (params)=>{
    return [
        `/api/v3/advisor/campaign-summary/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportCampaignSummaryQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportCampaignSummaryQueryKey(params);
    const queryFn = ({ signal })=>getExportCampaignSummary(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportCampaignSummary(params, options, queryClient) {
    const queryOptions = getGetExportCampaignSummaryQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportCampaignSummarySuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportCampaignSummaryQueryKey(params);
    const queryFn = ({ signal })=>getExportCampaignSummary(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportCampaignSummarySuspense(params, options, queryClient) {
    const queryOptions = getGetExportCampaignSummarySuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postCampaign = (signal)=>{
    return client({
        url: `/api/v3/advisor/campaigns`,
        method: 'POST',
        signal
    });
};
export const getPostCampaignMutationKey = ()=>[
        'postCampaign'
    ];
export const getPostCampaignMutationOptions = (options)=>{
    const mutationKey = getPostCampaignMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postCampaign();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCampaign = (options, queryClient)=>{
    return useMutation(getPostCampaignMutationOptions(options), queryClient);
};
export const deletePendingCampaign = (campaignId, signal)=>{
    return client({
        url: `/api/v3/advisor/campaigns/${campaignId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeletePendingCampaignMutationKey = ()=>[
        'deletePendingCampaign'
    ];
export const getDeletePendingCampaignMutationOptions = (options)=>{
    const mutationKey = getDeletePendingCampaignMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignId } = props ?? {};
        return deletePendingCampaign(campaignId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePendingCampaign = (options, queryClient)=>{
    return useMutation(getDeletePendingCampaignMutationOptions(options), queryClient);
};
export const postCampaignClone = (campaignId, signal)=>{
    return client({
        url: `/api/v3/advisor/campaigns/${campaignId}/clone`,
        method: 'POST',
        signal
    });
};
export const getPostCampaignCloneMutationKey = ()=>[
        'postCampaignClone'
    ];
export const getPostCampaignCloneMutationOptions = (options)=>{
    const mutationKey = getPostCampaignCloneMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignId } = props ?? {};
        return postCampaignClone(campaignId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCampaignClone = (options, queryClient)=>{
    return useMutation(getPostCampaignCloneMutationOptions(options), queryClient);
};
export const deleteCampaignPlan = (campaignId, planCorrelationId, signal)=>{
    return client({
        url: `/api/v3/advisor/campaigns/${campaignId}/plans/${planCorrelationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteCampaignPlanMutationKey = ()=>[
        'deleteCampaignPlan'
    ];
export const getDeleteCampaignPlanMutationOptions = (options)=>{
    const mutationKey = getDeleteCampaignPlanMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignId, planCorrelationId } = props ?? {};
        return deleteCampaignPlan(campaignId, planCorrelationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteCampaignPlan = (options, queryClient)=>{
    return useMutation(getDeleteCampaignPlanMutationOptions(options), queryClient);
};
export const getCampaignEvents = (campaignId, planCorrelationId, eventType, signal)=>{
    return client({
        url: `/api/v3/advisor/campaigns/${campaignId}/plans/${planCorrelationId}/events/${eventType}`,
        method: 'GET',
        signal
    });
};
export const getGetCampaignEventsQueryKey = (campaignId, planCorrelationId, eventType)=>{
    return [
        `/api/v3/advisor/campaigns/${campaignId}/plans/${planCorrelationId}/events/${eventType}`
    ];
};
export const getGetCampaignEventsQueryOptions = (campaignId, planCorrelationId, eventType, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCampaignEventsQueryKey(campaignId, planCorrelationId, eventType);
    const queryFn = ({ signal })=>getCampaignEvents(campaignId, planCorrelationId, eventType, signal);
    return {
        queryKey,
        queryFn,
        enabled: campaignId !== null && campaignId !== undefined && planCorrelationId !== null && planCorrelationId !== undefined && eventType !== null && eventType !== undefined,
        ...queryOptions
    };
};
export function useGetCampaignEvents(campaignId, planCorrelationId, eventType, options, queryClient) {
    const queryOptions = getGetCampaignEventsQueryOptions(campaignId, planCorrelationId, eventType, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetCampaignEventsSuspenseQueryOptions = (campaignId, planCorrelationId, eventType, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCampaignEventsQueryKey(campaignId, planCorrelationId, eventType);
    const queryFn = ({ signal })=>getCampaignEvents(campaignId, planCorrelationId, eventType, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetCampaignEventsSuspense(campaignId, planCorrelationId, eventType, options, queryClient) {
    const queryOptions = getGetCampaignEventsSuspenseQueryOptions(campaignId, planCorrelationId, eventType, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getDecisionAnalysisReportUrl = (decisionReportId, signal)=>{
    return client({
        url: `/api/v3/advisor/decision-analysis-reports/${decisionReportId}/download-url`,
        method: 'GET',
        signal
    });
};
export const getGetDecisionAnalysisReportUrlQueryKey = (decisionReportId)=>{
    return [
        `/api/v3/advisor/decision-analysis-reports/${decisionReportId}/download-url`
    ];
};
export const getGetDecisionAnalysisReportUrlQueryOptions = (decisionReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDecisionAnalysisReportUrlQueryKey(decisionReportId);
    const queryFn = ({ signal })=>getDecisionAnalysisReportUrl(decisionReportId, signal);
    return {
        queryKey,
        queryFn,
        enabled: decisionReportId !== null && decisionReportId !== undefined,
        ...queryOptions
    };
};
export function useGetDecisionAnalysisReportUrl(decisionReportId, options, queryClient) {
    const queryOptions = getGetDecisionAnalysisReportUrlQueryOptions(decisionReportId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetDecisionAnalysisReportUrlSuspenseQueryOptions = (decisionReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDecisionAnalysisReportUrlQueryKey(decisionReportId);
    const queryFn = ({ signal })=>getDecisionAnalysisReportUrl(decisionReportId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetDecisionAnalysisReportUrlSuspense(decisionReportId, options, queryClient) {
    const queryOptions = getGetDecisionAnalysisReportUrlSuspenseQueryOptions(decisionReportId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEmploymentStatusTypes = (signal)=>{
    return client({
        url: `/api/v3/advisor/employment-status-types`,
        method: 'GET',
        signal
    });
};
export const getGetEmploymentStatusTypesQueryKey = ()=>{
    return [
        `/api/v3/advisor/employment-status-types`
    ];
};
export const getGetEmploymentStatusTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmploymentStatusTypesQueryKey();
    const queryFn = ({ signal })=>getEmploymentStatusTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetEmploymentStatusTypes(options, queryClient) {
    const queryOptions = getGetEmploymentStatusTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEmploymentStatusTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmploymentStatusTypesQueryKey();
    const queryFn = ({ signal })=>getEmploymentStatusTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEmploymentStatusTypesSuspense(options, queryClient) {
    const queryOptions = getGetEmploymentStatusTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getInvestments = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/investments`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetInvestmentsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/investments`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetInvestmentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentsQueryKey(params);
    const queryFn = ({ signal })=>getInvestments(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetInvestments(params, options, queryClient) {
    const queryOptions = getGetInvestmentsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetInvestmentsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentsQueryKey(params);
    const queryFn = ({ signal })=>getInvestments(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetInvestmentsSuspense(params, options, queryClient) {
    const queryOptions = getGetInvestmentsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportInvestments = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/investments/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportInvestmentsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/investments/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportInvestmentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportInvestmentsQueryKey(params);
    const queryFn = ({ signal })=>getExportInvestments(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportInvestments(params, options, queryClient) {
    const queryOptions = getGetExportInvestmentsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportInvestmentsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportInvestmentsQueryKey(params);
    const queryFn = ({ signal })=>getExportInvestments(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportInvestmentsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportInvestmentsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchInvestment = (fundId, patchInvestmentBody, signal)=>{
    return client({
        url: `/api/v3/advisor/investments/${fundId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchInvestmentBody,
        signal
    });
};
export const getPatchInvestmentMutationKey = ()=>[
        'patchInvestment'
    ];
export const getPatchInvestmentMutationOptions = (options)=>{
    const mutationKey = getPatchInvestmentMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { fundId, data } = props ?? {};
        return patchInvestment(fundId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchInvestment = (options, queryClient)=>{
    return useMutation(getPatchInvestmentMutationOptions(options), queryClient);
};
export const getIraProspects = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/ira-prospects`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetIraProspectsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/ira-prospects`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetIraProspectsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectsQueryKey(params);
    const queryFn = ({ signal })=>getIraProspects(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetIraProspects(params, options, queryClient) {
    const queryOptions = getGetIraProspectsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIraProspectsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectsQueryKey(params);
    const queryFn = ({ signal })=>getIraProspects(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIraProspectsSuspense(params, options, queryClient) {
    const queryOptions = getGetIraProspectsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const updateIraProspects = (updateIraProspectsBody, signal)=>{
    return client({
        url: `/api/v3/advisor/ira-prospects`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateIraProspectsBody,
        signal
    });
};
export const getUpdateIraProspectsMutationKey = ()=>[
        'updateIraProspects'
    ];
export const getUpdateIraProspectsMutationOptions = (options)=>{
    const mutationKey = getUpdateIraProspectsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return updateIraProspects(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useUpdateIraProspects = (options, queryClient)=>{
    return useMutation(getUpdateIraProspectsMutationOptions(options), queryClient);
};
export const createIraProspects = (createIraProspectsBody, signal)=>{
    return client({
        url: `/api/v3/advisor/ira-prospects`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createIraProspectsBody,
        signal
    });
};
export const getCreateIraProspectsMutationKey = ()=>[
        'createIraProspects'
    ];
export const getCreateIraProspectsMutationOptions = (options)=>{
    const mutationKey = getCreateIraProspectsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return createIraProspects(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useCreateIraProspects = (options, queryClient)=>{
    return useMutation(getCreateIraProspectsMutationOptions(options), queryClient);
};
export const getExportIraProspects = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/ira-prospects/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportIraProspectsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/ira-prospects/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportIraProspectsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportIraProspectsQueryKey(params);
    const queryFn = ({ signal })=>getExportIraProspects(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportIraProspects(params, options, queryClient) {
    const queryOptions = getGetExportIraProspectsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportIraProspectsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportIraProspectsQueryKey(params);
    const queryFn = ({ signal })=>getExportIraProspects(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportIraProspectsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportIraProspectsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getManagedAccounts = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/managed-accounts`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetManagedAccountsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/managed-accounts`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetManagedAccountsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountsQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccounts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetManagedAccounts(params, options, queryClient) {
    const queryOptions = getGetManagedAccountsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountsQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccounts(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountsSuspense(params, options, queryClient) {
    const queryOptions = getGetManagedAccountsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportManagedAccounts = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/managed-accounts/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportManagedAccountsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/managed-accounts/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportManagedAccountsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportManagedAccountsQueryKey(params);
    const queryFn = ({ signal })=>getExportManagedAccounts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportManagedAccounts(params, options, queryClient) {
    const queryOptions = getGetExportManagedAccountsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportManagedAccountsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportManagedAccountsQueryKey(params);
    const queryFn = ({ signal })=>getExportManagedAccounts(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportManagedAccountsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportManagedAccountsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getMapFeeReports = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/map-fee-reports`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetMapFeeReportsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/map-fee-reports`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetMapFeeReportsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapFeeReportsQueryKey(params);
    const queryFn = ({ signal })=>getMapFeeReports(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetMapFeeReports(params, options, queryClient) {
    const queryOptions = getGetMapFeeReportsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetMapFeeReportsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapFeeReportsQueryKey(params);
    const queryFn = ({ signal })=>getMapFeeReports(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetMapFeeReportsSuspense(params, options, queryClient) {
    const queryOptions = getGetMapFeeReportsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportMapFeeReports = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/map-fee-reports/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportMapFeeReportsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/map-fee-reports/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportMapFeeReportsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportMapFeeReportsQueryKey(params);
    const queryFn = ({ signal })=>getExportMapFeeReports(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportMapFeeReports(params, options, queryClient) {
    const queryOptions = getGetExportMapFeeReportsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportMapFeeReportsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportMapFeeReportsQueryKey(params);
    const queryFn = ({ signal })=>getExportMapFeeReports(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportMapFeeReportsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportMapFeeReportsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchArchiveMapFeeReport = (mapFeeReportId, signal)=>{
    return client({
        url: `/api/v3/advisor/map-fee-reports/${mapFeeReportId}/archive`,
        method: 'PATCH',
        signal
    });
};
export const getPatchArchiveMapFeeReportMutationKey = ()=>[
        'patchArchiveMapFeeReport'
    ];
export const getPatchArchiveMapFeeReportMutationOptions = (options)=>{
    const mutationKey = getPatchArchiveMapFeeReportMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { mapFeeReportId } = props ?? {};
        return patchArchiveMapFeeReport(mapFeeReportId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchArchiveMapFeeReport = (options, queryClient)=>{
    return useMutation(getPatchArchiveMapFeeReportMutationOptions(options), queryClient);
};
export const getDataExportMapFeeReport = (mapFeeReportId, signal)=>{
    return client({
        url: `/api/v3/advisor/map-fee-reports/${mapFeeReportId}/data-export`,
        method: 'GET',
        signal
    });
};
export const getGetDataExportMapFeeReportQueryKey = (mapFeeReportId)=>{
    return [
        `/api/v3/advisor/map-fee-reports/${mapFeeReportId}/data-export`
    ];
};
export const getGetDataExportMapFeeReportQueryOptions = (mapFeeReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDataExportMapFeeReportQueryKey(mapFeeReportId);
    const queryFn = ({ signal })=>getDataExportMapFeeReport(mapFeeReportId, signal);
    return {
        queryKey,
        queryFn,
        enabled: mapFeeReportId !== null && mapFeeReportId !== undefined,
        ...queryOptions
    };
};
export function useGetDataExportMapFeeReport(mapFeeReportId, options, queryClient) {
    const queryOptions = getGetDataExportMapFeeReportQueryOptions(mapFeeReportId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetDataExportMapFeeReportSuspenseQueryOptions = (mapFeeReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDataExportMapFeeReportQueryKey(mapFeeReportId);
    const queryFn = ({ signal })=>getDataExportMapFeeReport(mapFeeReportId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetDataExportMapFeeReportSuspense(mapFeeReportId, options, queryClient) {
    const queryOptions = getGetDataExportMapFeeReportSuspenseQueryOptions(mapFeeReportId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getDownloadMapFeeReport = (mapFeeReportId, signal)=>{
    return client({
        url: `/api/v3/advisor/map-fee-reports/${mapFeeReportId}/download`,
        method: 'GET',
        signal
    });
};
export const getGetDownloadMapFeeReportQueryKey = (mapFeeReportId)=>{
    return [
        `/api/v3/advisor/map-fee-reports/${mapFeeReportId}/download`
    ];
};
export const getGetDownloadMapFeeReportQueryOptions = (mapFeeReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadMapFeeReportQueryKey(mapFeeReportId);
    const queryFn = ({ signal })=>getDownloadMapFeeReport(mapFeeReportId, signal);
    return {
        queryKey,
        queryFn,
        enabled: mapFeeReportId !== null && mapFeeReportId !== undefined,
        ...queryOptions
    };
};
export function useGetDownloadMapFeeReport(mapFeeReportId, options, queryClient) {
    const queryOptions = getGetDownloadMapFeeReportQueryOptions(mapFeeReportId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetDownloadMapFeeReportSuspenseQueryOptions = (mapFeeReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadMapFeeReportQueryKey(mapFeeReportId);
    const queryFn = ({ signal })=>getDownloadMapFeeReport(mapFeeReportId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetDownloadMapFeeReportSuspense(mapFeeReportId, options, queryClient) {
    const queryOptions = getGetDownloadMapFeeReportSuspenseQueryOptions(mapFeeReportId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getDownloadTotalsMapFeeReport = (mapFeeReportId, signal)=>{
    return client({
        url: `/api/v3/advisor/map-fee-reports/${mapFeeReportId}/download-totals`,
        method: 'GET',
        signal
    });
};
export const getGetDownloadTotalsMapFeeReportQueryKey = (mapFeeReportId)=>{
    return [
        `/api/v3/advisor/map-fee-reports/${mapFeeReportId}/download-totals`
    ];
};
export const getGetDownloadTotalsMapFeeReportQueryOptions = (mapFeeReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadTotalsMapFeeReportQueryKey(mapFeeReportId);
    const queryFn = ({ signal })=>getDownloadTotalsMapFeeReport(mapFeeReportId, signal);
    return {
        queryKey,
        queryFn,
        enabled: mapFeeReportId !== null && mapFeeReportId !== undefined,
        ...queryOptions
    };
};
export function useGetDownloadTotalsMapFeeReport(mapFeeReportId, options, queryClient) {
    const queryOptions = getGetDownloadTotalsMapFeeReportQueryOptions(mapFeeReportId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetDownloadTotalsMapFeeReportSuspenseQueryOptions = (mapFeeReportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadTotalsMapFeeReportQueryKey(mapFeeReportId);
    const queryFn = ({ signal })=>getDownloadTotalsMapFeeReport(mapFeeReportId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetDownloadTotalsMapFeeReportSuspense(mapFeeReportId, options, queryClient) {
    const queryOptions = getGetDownloadTotalsMapFeeReportSuspenseQueryOptions(mapFeeReportId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getMapMethodologies = (signal)=>{
    return client({
        url: `/api/v3/advisor/map-methodologies`,
        method: 'GET',
        signal
    });
};
export const getGetMapMethodologiesQueryKey = ()=>{
    return [
        `/api/v3/advisor/map-methodologies`
    ];
};
export const getGetMapMethodologiesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapMethodologiesQueryKey();
    const queryFn = ({ signal })=>getMapMethodologies(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetMapMethodologies(options, queryClient) {
    const queryOptions = getGetMapMethodologiesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetMapMethodologiesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapMethodologiesQueryKey();
    const queryFn = ({ signal })=>getMapMethodologies(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetMapMethodologiesSuspense(options, queryClient) {
    const queryOptions = getGetMapMethodologiesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getOptOutLog = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/opt-out-log`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetOptOutLogQueryKey = (params)=>{
    return [
        `/api/v3/advisor/opt-out-log`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetOptOutLogQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutLogQueryKey(params);
    const queryFn = ({ signal })=>getOptOutLog(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetOptOutLog(params, options, queryClient) {
    const queryOptions = getGetOptOutLogQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetOptOutLogSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutLogQueryKey(params);
    const queryFn = ({ signal })=>getOptOutLog(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetOptOutLogSuspense(params, options, queryClient) {
    const queryOptions = getGetOptOutLogSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getOptOutLogExport = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/opt-out-log/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetOptOutLogExportQueryKey = (params)=>{
    return [
        `/api/v3/advisor/opt-out-log/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetOptOutLogExportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutLogExportQueryKey(params);
    const queryFn = ({ signal })=>getOptOutLogExport(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetOptOutLogExport(params, options, queryClient) {
    const queryOptions = getGetOptOutLogExportQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetOptOutLogExportSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutLogExportQueryKey(params);
    const queryFn = ({ signal })=>getOptOutLogExport(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetOptOutLogExportSuspense(params, options, queryClient) {
    const queryOptions = getGetOptOutLogExportSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getOptOutStatusTypes = (signal)=>{
    return client({
        url: `/api/v3/advisor/opt-out-status-types`,
        method: 'GET',
        signal
    });
};
export const getGetOptOutStatusTypesQueryKey = ()=>{
    return [
        `/api/v3/advisor/opt-out-status-types`
    ];
};
export const getGetOptOutStatusTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutStatusTypesQueryKey();
    const queryFn = ({ signal })=>getOptOutStatusTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetOptOutStatusTypes(options, queryClient) {
    const queryOptions = getGetOptOutStatusTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetOptOutStatusTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutStatusTypesQueryKey();
    const queryFn = ({ signal })=>getOptOutStatusTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetOptOutStatusTypesSuspense(options, queryClient) {
    const queryOptions = getGetOptOutStatusTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPendingCampaigns = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/pending-campaigns`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPendingCampaignsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/pending-campaigns`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPendingCampaignsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPendingCampaignsQueryKey(params);
    const queryFn = ({ signal })=>getPendingCampaigns(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetPendingCampaigns(params, options, queryClient) {
    const queryOptions = getGetPendingCampaignsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPendingCampaignsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPendingCampaignsQueryKey(params);
    const queryFn = ({ signal })=>getPendingCampaigns(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPendingCampaignsSuspense(params, options, queryClient) {
    const queryOptions = getGetPendingCampaignsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPlanFilterOptions = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/plan-filter-options`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanFilterOptionsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/plan-filter-options`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanFilterOptionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanFilterOptionsQueryKey(params);
    const queryFn = ({ signal })=>getPlanFilterOptions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetPlanFilterOptions(params, options, queryClient) {
    const queryOptions = getGetPlanFilterOptionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanFilterOptionsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanFilterOptionsQueryKey(params);
    const queryFn = ({ signal })=>getPlanFilterOptions(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanFilterOptionsSuspense(params, options, queryClient) {
    const queryOptions = getGetPlanFilterOptionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getMapSetup = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/plans-map-setup`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetMapSetupQueryKey = (params)=>{
    return [
        `/api/v3/advisor/plans-map-setup`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetMapSetupQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapSetupQueryKey(params);
    const queryFn = ({ signal })=>getMapSetup(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetMapSetup(params, options, queryClient) {
    const queryOptions = getGetMapSetupQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetMapSetupSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapSetupQueryKey(params);
    const queryFn = ({ signal })=>getMapSetup(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetMapSetupSuspense(params, options, queryClient) {
    const queryOptions = getGetMapSetupSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportMapSetup = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/plans-map-setup/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportMapSetupQueryKey = (params)=>{
    return [
        `/api/v3/advisor/plans-map-setup/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportMapSetupQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportMapSetupQueryKey(params);
    const queryFn = ({ signal })=>getExportMapSetup(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportMapSetup(params, options, queryClient) {
    const queryOptions = getGetExportMapSetupQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportMapSetupSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportMapSetupQueryKey(params);
    const queryFn = ({ signal })=>getExportMapSetup(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportMapSetupSuspense(params, options, queryClient) {
    const queryOptions = getGetExportMapSetupSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPlanMetrics = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/plans-metrics`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanMetricsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/plans-metrics`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanMetricsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanMetricsQueryKey(params);
    const queryFn = ({ signal })=>getPlanMetrics(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetPlanMetrics(params, options, queryClient) {
    const queryOptions = getGetPlanMetricsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanMetricsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanMetricsQueryKey(params);
    const queryFn = ({ signal })=>getPlanMetrics(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanMetricsSuspense(params, options, queryClient) {
    const queryOptions = getGetPlanMetricsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportPlanMetrics = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/plans-metrics/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportPlanMetricsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/plans-metrics/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportPlanMetricsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportPlanMetricsQueryKey(params);
    const queryFn = ({ signal })=>getExportPlanMetrics(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportPlanMetrics(params, options, queryClient) {
    const queryOptions = getGetExportPlanMetricsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportPlanMetricsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportPlanMetricsQueryKey(params);
    const queryFn = ({ signal })=>getExportPlanMetrics(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportPlanMetricsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportPlanMetricsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPlanParticipants = (planId, params, signal)=>{
    return client({
        url: `/api/v3/advisor/plans/${planId}/participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanParticipantsQueryKey = (planId, params)=>{
    return [
        `/api/v3/advisor/plans/${planId}/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanParticipantsQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanParticipantsQueryKey(planId, params);
    const queryFn = ({ signal })=>getPlanParticipants(planId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetPlanParticipants(planId, params, options, queryClient) {
    const queryOptions = getGetPlanParticipantsQueryOptions(planId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanParticipantsSuspenseQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanParticipantsQueryKey(planId, params);
    const queryFn = ({ signal })=>getPlanParticipants(planId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanParticipantsSuspense(planId, params, options, queryClient) {
    const queryOptions = getGetPlanParticipantsSuspenseQueryOptions(planId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportPlanParticipants = (planId, params, signal)=>{
    return client({
        url: `/api/v3/advisor/plans/${planId}/participants/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportPlanParticipantsQueryKey = (planId, params)=>{
    return [
        `/api/v3/advisor/plans/${planId}/participants/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportPlanParticipantsQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportPlanParticipantsQueryKey(planId, params);
    const queryFn = ({ signal })=>getExportPlanParticipants(planId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetExportPlanParticipants(planId, params, options, queryClient) {
    const queryOptions = getGetExportPlanParticipantsQueryOptions(planId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportPlanParticipantsSuspenseQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportPlanParticipantsQueryKey(planId, params);
    const queryFn = ({ signal })=>getExportPlanParticipants(planId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportPlanParticipantsSuspense(planId, params, options, queryClient) {
    const queryOptions = getGetExportPlanParticipantsSuspenseQueryOptions(planId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdvisorEnrollmentReset = (planId, participantId, signal)=>{
    return client({
        url: `/api/v3/advisor/plans/${planId}/participants/${participantId}/enrollment-reset`,
        method: 'POST',
        signal
    });
};
export const getPostAdvisorEnrollmentResetMutationKey = ()=>[
        'postAdvisorEnrollmentReset'
    ];
export const getPostAdvisorEnrollmentResetMutationOptions = (options)=>{
    const mutationKey = getPostAdvisorEnrollmentResetMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, participantId } = props ?? {};
        return postAdvisorEnrollmentReset(planId, participantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorEnrollmentReset = (options, queryClient)=>{
    return useMutation(getPostAdvisorEnrollmentResetMutationOptions(options), queryClient);
};
export const getAdvisorRecordKeeperExportQueues = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/record-keeper-export-queues`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorRecordKeeperExportQueuesQueryKey = (params)=>{
    return [
        `/api/v3/advisor/record-keeper-export-queues`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorRecordKeeperExportQueuesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorRecordKeeperExportQueuesQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorRecordKeeperExportQueues(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdvisorRecordKeeperExportQueues(params, options, queryClient) {
    const queryOptions = getGetAdvisorRecordKeeperExportQueuesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorRecordKeeperExportQueuesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorRecordKeeperExportQueuesQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorRecordKeeperExportQueues(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorRecordKeeperExportQueuesSuspense(params, options, queryClient) {
    const queryOptions = getGetAdvisorRecordKeeperExportQueuesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportAdvisorRecordKeeperExportQueues = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/record-keeper-export-queues/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportAdvisorRecordKeeperExportQueuesQueryKey = (params)=>{
    return [
        `/api/v3/advisor/record-keeper-export-queues/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportAdvisorRecordKeeperExportQueuesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAdvisorRecordKeeperExportQueuesQueryKey(params);
    const queryFn = ({ signal })=>getExportAdvisorRecordKeeperExportQueues(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportAdvisorRecordKeeperExportQueues(params, options, queryClient) {
    const queryOptions = getGetExportAdvisorRecordKeeperExportQueuesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportAdvisorRecordKeeperExportQueuesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAdvisorRecordKeeperExportQueuesQueryKey(params);
    const queryFn = ({ signal })=>getExportAdvisorRecordKeeperExportQueues(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportAdvisorRecordKeeperExportQueuesSuspense(params, options, queryClient) {
    const queryOptions = getGetExportAdvisorRecordKeeperExportQueuesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postReprocessAdvisorRecordKeeperExportQueue = (recordKeeperExportQueueId, signal)=>{
    return client({
        url: `/api/v3/advisor/record-keeper-export-queues/${recordKeeperExportQueueId}/reprocess`,
        method: 'POST',
        signal
    });
};
export const getPostReprocessAdvisorRecordKeeperExportQueueMutationKey = ()=>[
        'postReprocessAdvisorRecordKeeperExportQueue'
    ];
export const getPostReprocessAdvisorRecordKeeperExportQueueMutationOptions = (options)=>{
    const mutationKey = getPostReprocessAdvisorRecordKeeperExportQueueMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordKeeperExportQueueId } = props ?? {};
        return postReprocessAdvisorRecordKeeperExportQueue(recordKeeperExportQueueId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostReprocessAdvisorRecordKeeperExportQueue = (options, queryClient)=>{
    return useMutation(getPostReprocessAdvisorRecordKeeperExportQueueMutationOptions(options), queryClient);
};
export const getReports = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/reports`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetReportsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/reports`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetReportsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetReportsQueryKey(params);
    const queryFn = ({ signal })=>getReports(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetReports(params, options, queryClient) {
    const queryOptions = getGetReportsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetReportsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetReportsQueryKey(params);
    const queryFn = ({ signal })=>getReports(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetReportsSuspense(params, options, queryClient) {
    const queryOptions = getGetReportsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportReports = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/reports/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportReportsQueryKey = (params)=>{
    return [
        `/api/v3/advisor/reports/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportReportsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportReportsQueryKey(params);
    const queryFn = ({ signal })=>getExportReports(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportReports(params, options, queryClient) {
    const queryOptions = getGetExportReportsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportReportsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportReportsQueryKey(params);
    const queryFn = ({ signal })=>getExportReports(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportReportsSuspense(params, options, queryClient) {
    const queryOptions = getGetExportReportsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getReportsInProgressCount = (signal)=>{
    return client({
        url: `/api/v3/advisor/reports/in-progress-count`,
        method: 'GET',
        signal
    });
};
export const getGetReportsInProgressCountQueryKey = ()=>{
    return [
        `/api/v3/advisor/reports/in-progress-count`
    ];
};
export const getGetReportsInProgressCountQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetReportsInProgressCountQueryKey();
    const queryFn = ({ signal })=>getReportsInProgressCount(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetReportsInProgressCount(options, queryClient) {
    const queryOptions = getGetReportsInProgressCountQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetReportsInProgressCountSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetReportsInProgressCountQueryKey();
    const queryFn = ({ signal })=>getReportsInProgressCount(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetReportsInProgressCountSuspense(options, queryClient) {
    const queryOptions = getGetReportsInProgressCountSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchReport = (reportId, patchReportBody, signal)=>{
    return client({
        url: `/api/v3/advisor/reports/${reportId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchReportBody,
        signal
    });
};
export const getPatchReportMutationKey = ()=>[
        'patchReport'
    ];
export const getPatchReportMutationOptions = (options)=>{
    const mutationKey = getPatchReportMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { reportId, data } = props ?? {};
        return patchReport(reportId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchReport = (options, queryClient)=>{
    return useMutation(getPatchReportMutationOptions(options), queryClient);
};
export const getReportDownload = (reportId, signal)=>{
    return client({
        url: `/api/v3/advisor/reports/${reportId}/download`,
        method: 'GET',
        signal
    });
};
export const getGetReportDownloadQueryKey = (reportId)=>{
    return [
        `/api/v3/advisor/reports/${reportId}/download`
    ];
};
export const getGetReportDownloadQueryOptions = (reportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetReportDownloadQueryKey(reportId);
    const queryFn = ({ signal })=>getReportDownload(reportId, signal);
    return {
        queryKey,
        queryFn,
        enabled: reportId !== null && reportId !== undefined,
        ...queryOptions
    };
};
export function useGetReportDownload(reportId, options, queryClient) {
    const queryOptions = getGetReportDownloadQueryOptions(reportId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetReportDownloadSuspenseQueryOptions = (reportId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetReportDownloadQueryKey(reportId);
    const queryFn = ({ signal })=>getReportDownload(reportId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetReportDownloadSuspense(reportId, options, queryClient) {
    const queryOptions = getGetReportDownloadSuspenseQueryOptions(reportId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postReportEmail = (reportId, emailReportBody, signal)=>{
    return client({
        url: `/api/v3/advisor/reports/${reportId}/email`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: emailReportBody,
        signal
    });
};
export const getPostReportEmailMutationKey = ()=>[
        'postReportEmail'
    ];
export const getPostReportEmailMutationOptions = (options)=>{
    const mutationKey = getPostReportEmailMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { reportId, data } = props ?? {};
        return postReportEmail(reportId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostReportEmail = (options, queryClient)=>{
    return useMutation(getPostReportEmailMutationOptions(options), queryClient);
};
export const getSummaryPlans = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/summary-plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSummaryPlansQueryKey = (params)=>{
    return [
        `/api/v3/advisor/summary-plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSummaryPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSummaryPlansQueryKey(params);
    const queryFn = ({ signal })=>getSummaryPlans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetSummaryPlans(params, options, queryClient) {
    const queryOptions = getGetSummaryPlansQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetSummaryPlansSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSummaryPlansQueryKey(params);
    const queryFn = ({ signal })=>getSummaryPlans(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetSummaryPlansSuspense(params, options, queryClient) {
    const queryOptions = getGetSummaryPlansSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportSummaryPlans = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/summary-plans/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportSummaryPlansQueryKey = (params)=>{
    return [
        `/api/v3/advisor/summary-plans/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportSummaryPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportSummaryPlansQueryKey(params);
    const queryFn = ({ signal })=>getExportSummaryPlans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportSummaryPlans(params, options, queryClient) {
    const queryOptions = getGetExportSummaryPlansQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportSummaryPlansSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportSummaryPlansQueryKey(params);
    const queryFn = ({ signal })=>getExportSummaryPlans(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportSummaryPlansSuspense(params, options, queryClient) {
    const queryOptions = getGetExportSummaryPlansSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorTaskSchedules = (params, signal)=>{
    return client({
        url: `/api/v3/advisor/task-schedules`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorTaskSchedulesQueryKey = (params)=>{
    return [
        `/api/v3/advisor/task-schedules`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorTaskSchedulesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorTaskSchedulesQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorTaskSchedules(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdvisorTaskSchedules(params, options, queryClient) {
    const queryOptions = getGetAdvisorTaskSchedulesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorTaskSchedulesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorTaskSchedulesQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorTaskSchedules(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorTaskSchedulesSuspense(params, options, queryClient) {
    const queryOptions = getGetAdvisorTaskSchedulesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdvisorTaskSchedule = (createTaskScheduleBody, signal)=>{
    return client({
        url: `/api/v3/advisor/task-schedules`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createTaskScheduleBody,
        signal
    });
};
export const getPostAdvisorTaskScheduleMutationKey = ()=>[
        'postAdvisorTaskSchedule'
    ];
export const getPostAdvisorTaskScheduleMutationOptions = (options)=>{
    const mutationKey = getPostAdvisorTaskScheduleMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorTaskSchedule(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorTaskSchedule = (options, queryClient)=>{
    return useMutation(getPostAdvisorTaskScheduleMutationOptions(options), queryClient);
};
export const deleteAdvisorTaskSchedule = (taskScheduleId, signal)=>{
    return client({
        url: `/api/v3/advisor/task-schedules/${taskScheduleId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdvisorTaskScheduleMutationKey = ()=>[
        'deleteAdvisorTaskSchedule'
    ];
export const getDeleteAdvisorTaskScheduleMutationOptions = (options)=>{
    const mutationKey = getDeleteAdvisorTaskScheduleMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { taskScheduleId } = props ?? {};
        return deleteAdvisorTaskSchedule(taskScheduleId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdvisorTaskSchedule = (options, queryClient)=>{
    return useMutation(getDeleteAdvisorTaskScheduleMutationOptions(options), queryClient);
};
export const getAdvisorTaskSchedule = (taskScheduleId, signal)=>{
    return client({
        url: `/api/v3/advisor/task-schedules/${taskScheduleId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorTaskScheduleQueryKey = (taskScheduleId)=>{
    return [
        `/api/v3/advisor/task-schedules/${taskScheduleId}`
    ];
};
export const getGetAdvisorTaskScheduleQueryOptions = (taskScheduleId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorTaskScheduleQueryKey(taskScheduleId);
    const queryFn = ({ signal })=>getAdvisorTaskSchedule(taskScheduleId, signal);
    return {
        queryKey,
        queryFn,
        enabled: taskScheduleId !== null && taskScheduleId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorTaskSchedule(taskScheduleId, options, queryClient) {
    const queryOptions = getGetAdvisorTaskScheduleQueryOptions(taskScheduleId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorTaskScheduleSuspenseQueryOptions = (taskScheduleId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorTaskScheduleQueryKey(taskScheduleId);
    const queryFn = ({ signal })=>getAdvisorTaskSchedule(taskScheduleId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorTaskScheduleSuspense(taskScheduleId, options, queryClient) {
    const queryOptions = getGetAdvisorTaskScheduleSuspenseQueryOptions(taskScheduleId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdvisorTaskSchedule = (taskScheduleId, updateTaskScheduleBody, signal)=>{
    return client({
        url: `/api/v3/advisor/task-schedules/${taskScheduleId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateTaskScheduleBody,
        signal
    });
};
export const getPatchAdvisorTaskScheduleMutationKey = ()=>[
        'patchAdvisorTaskSchedule'
    ];
export const getPatchAdvisorTaskScheduleMutationOptions = (options)=>{
    const mutationKey = getPatchAdvisorTaskScheduleMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { taskScheduleId, data } = props ?? {};
        return patchAdvisorTaskSchedule(taskScheduleId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdvisorTaskSchedule = (options, queryClient)=>{
    return useMutation(getPatchAdvisorTaskScheduleMutationOptions(options), queryClient);
};
export const postAdvisorsRefIraCompanion = (postAdvisorsRefIraCompanionBody, signal)=>{
    return client({
        url: `/api/v3/advisors-ref-ira-companions`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdvisorsRefIraCompanionBody,
        signal
    });
};
export const getPostAdvisorsRefIraCompanionMutationKey = ()=>[
        'postAdvisorsRefIraCompanion'
    ];
export const getPostAdvisorsRefIraCompanionMutationOptions = (options)=>{
    const mutationKey = getPostAdvisorsRefIraCompanionMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorsRefIraCompanion(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorsRefIraCompanion = (options, queryClient)=>{
    return useMutation(getPostAdvisorsRefIraCompanionMutationOptions(options), queryClient);
};
export const deleteAdvisorsRefIraCompanion = (advisorsRefIraCompanionsId, signal)=>{
    return client({
        url: `/api/v3/advisors-ref-ira-companions/${advisorsRefIraCompanionsId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdvisorsRefIraCompanionMutationKey = ()=>[
        'deleteAdvisorsRefIraCompanion'
    ];
export const getDeleteAdvisorsRefIraCompanionMutationOptions = (options)=>{
    const mutationKey = getDeleteAdvisorsRefIraCompanionMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisorsRefIraCompanionsId } = props ?? {};
        return deleteAdvisorsRefIraCompanion(advisorsRefIraCompanionsId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdvisorsRefIraCompanion = (options, queryClient)=>{
    return useMutation(getDeleteAdvisorsRefIraCompanionMutationOptions(options), queryClient);
};
export const getAdvisor = (advisorId, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorQueryKey = (advisorId)=>{
    return [
        `/api/v3/advisors/${advisorId}`
    ];
};
export const getGetAdvisorQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisor(advisorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisor(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorQueryOptions(advisorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorSuspenseQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisor(advisorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorSuspense(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorSuspenseQueryOptions(advisorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdvisor = (advisorId, patchAdvisorBody, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAdvisorBody,
        signal
    });
};
export const getPatchAdvisorMutationKey = ()=>[
        'patchAdvisor'
    ];
export const getPatchAdvisorMutationOptions = (options)=>{
    const mutationKey = getPatchAdvisorMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisorId, data } = props ?? {};
        return patchAdvisor(advisorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdvisor = (options, queryClient)=>{
    return useMutation(getPatchAdvisorMutationOptions(options), queryClient);
};
export const getAdvisorBarePlans = (advisorId, params, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/bare-plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorBarePlansQueryKey = (advisorId, params)=>{
    return [
        `/api/v3/advisors/${advisorId}/bare-plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorBarePlansQueryOptions = (advisorId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorBarePlansQueryKey(advisorId, params);
    const queryFn = ({ signal })=>getAdvisorBarePlans(advisorId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorBarePlans(advisorId, params, options, queryClient) {
    const queryOptions = getGetAdvisorBarePlansQueryOptions(advisorId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorBarePlansSuspenseQueryOptions = (advisorId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorBarePlansQueryKey(advisorId, params);
    const queryFn = ({ signal })=>getAdvisorBarePlans(advisorId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorBarePlansSuspense(advisorId, params, options, queryClient) {
    const queryOptions = getGetAdvisorBarePlansSuspenseQueryOptions(advisorId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdvisorBatchUpdate = (advisorId, batchUpdateDto, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/batch-update`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: batchUpdateDto,
        signal
    });
};
export const getPostAdvisorBatchUpdateMutationKey = ()=>[
        'postAdvisorBatchUpdate'
    ];
export const getPostAdvisorBatchUpdateMutationOptions = (options)=>{
    const mutationKey = getPostAdvisorBatchUpdateMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisorId, data } = props ?? {};
        return postAdvisorBatchUpdate(advisorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorBatchUpdate = (options, queryClient)=>{
    return useMutation(getPostAdvisorBatchUpdateMutationOptions(options), queryClient);
};
export const getAdvisorCampaignEmails = (advisorId, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/campaign-emails`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorCampaignEmailsQueryKey = (advisorId)=>{
    return [
        `/api/v3/advisors/${advisorId}/campaign-emails`
    ];
};
export const getGetAdvisorCampaignEmailsQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorCampaignEmailsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorCampaignEmails(advisorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorCampaignEmails(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorCampaignEmailsQueryOptions(advisorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorCampaignEmailsSuspenseQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorCampaignEmailsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorCampaignEmails(advisorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorCampaignEmailsSuspense(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorCampaignEmailsSuspenseQueryOptions(advisorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorFilteredPlans = (advisorId, params, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/filtered-plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorFilteredPlansQueryKey = (advisorId, params)=>{
    return [
        `/api/v3/advisors/${advisorId}/filtered-plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorFilteredPlansQueryOptions = (advisorId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorFilteredPlansQueryKey(advisorId, params);
    const queryFn = ({ signal })=>getAdvisorFilteredPlans(advisorId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorFilteredPlans(advisorId, params, options, queryClient) {
    const queryOptions = getGetAdvisorFilteredPlansQueryOptions(advisorId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorFilteredPlansSuspenseQueryOptions = (advisorId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorFilteredPlansQueryKey(advisorId, params);
    const queryFn = ({ signal })=>getAdvisorFilteredPlans(advisorId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorFilteredPlansSuspense(advisorId, params, options, queryClient) {
    const queryOptions = getGetAdvisorFilteredPlansSuspenseQueryOptions(advisorId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorIraCompanions = (advisorId, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/ira-companions`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorIraCompanionsQueryKey = (advisorId)=>{
    return [
        `/api/v3/advisors/${advisorId}/ira-companions`
    ];
};
export const getGetAdvisorIraCompanionsQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorIraCompanionsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorIraCompanions(advisorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorIraCompanions(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorIraCompanionsQueryOptions(advisorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorIraCompanionsSuspenseQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorIraCompanionsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorIraCompanions(advisorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorIraCompanionsSuspense(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorIraCompanionsSuspenseQueryOptions(advisorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorIraProspectPlanAdvisorsRefs = (advisorId, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/ira-prospect-plan-advisor-refs`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorIraProspectPlanAdvisorsRefsQueryKey = (advisorId)=>{
    return [
        `/api/v3/advisors/${advisorId}/ira-prospect-plan-advisor-refs`
    ];
};
export const getGetAdvisorIraProspectPlanAdvisorsRefsQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorIraProspectPlanAdvisorsRefsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorIraProspectPlanAdvisorsRefs(advisorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorIraProspectPlanAdvisorsRefs(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorIraProspectPlanAdvisorsRefsQueryOptions(advisorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorIraProspectPlanAdvisorsRefsSuspenseQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorIraProspectPlanAdvisorsRefsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorIraProspectPlanAdvisorsRefs(advisorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorIraProspectPlanAdvisorsRefsSuspense(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorIraProspectPlanAdvisorsRefsSuspenseQueryOptions(advisorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorLogin = (advisorId, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/login`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorLoginQueryKey = (advisorId)=>{
    return [
        `/api/v3/advisors/${advisorId}/login`
    ];
};
export const getGetAdvisorLoginQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorLoginQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorLogin(advisorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorLogin(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorLoginQueryOptions(advisorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorLoginSuspenseQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorLoginQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorLogin(advisorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorLoginSuspense(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorLoginSuspenseQueryOptions(advisorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdvisorManagedAccountProvider = (advisorId, createAdvisorManagedAccountProviderBody, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/managed-account-providers`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createAdvisorManagedAccountProviderBody,
        signal
    });
};
export const getPostAdvisorManagedAccountProviderMutationKey = ()=>[
        'postAdvisorManagedAccountProvider'
    ];
export const getPostAdvisorManagedAccountProviderMutationOptions = (options)=>{
    const mutationKey = getPostAdvisorManagedAccountProviderMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisorId, data } = props ?? {};
        return postAdvisorManagedAccountProvider(advisorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorManagedAccountProvider = (options, queryClient)=>{
    return useMutation(getPostAdvisorManagedAccountProviderMutationOptions(options), queryClient);
};
export const getAdvisorHeaderMetrics = (advisorId, params, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/metrics/header`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorHeaderMetricsQueryKey = (advisorId, params)=>{
    return [
        `/api/v3/advisors/${advisorId}/metrics/header`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorHeaderMetricsQueryOptions = (advisorId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorHeaderMetricsQueryKey(advisorId, params);
    const queryFn = ({ signal })=>getAdvisorHeaderMetrics(advisorId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorHeaderMetrics(advisorId, params, options, queryClient) {
    const queryOptions = getGetAdvisorHeaderMetricsQueryOptions(advisorId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorHeaderMetricsSuspenseQueryOptions = (advisorId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorHeaderMetricsQueryKey(advisorId, params);
    const queryFn = ({ signal })=>getAdvisorHeaderMetrics(advisorId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorHeaderMetricsSuspense(advisorId, params, options, queryClient) {
    const queryOptions = getGetAdvisorHeaderMetricsSuspenseQueryOptions(advisorId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdvisorPassword = (advisorId, changeAdvisorPasswordBody, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/password`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: changeAdvisorPasswordBody,
        signal
    });
};
export const getPatchAdvisorPasswordMutationKey = ()=>[
        'patchAdvisorPassword'
    ];
export const getPatchAdvisorPasswordMutationOptions = (options)=>{
    const mutationKey = getPatchAdvisorPasswordMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisorId, data } = props ?? {};
        return patchAdvisorPassword(advisorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdvisorPassword = (options, queryClient)=>{
    return useMutation(getPatchAdvisorPasswordMutationOptions(options), queryClient);
};
export const postAdvisorReEnrollPlansBatch = (advisorId, batchReEnrollPlansRequest, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/re-enroll-plans-batch`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: batchReEnrollPlansRequest,
        signal
    });
};
export const getPostAdvisorReEnrollPlansBatchMutationKey = ()=>[
        'postAdvisorReEnrollPlansBatch'
    ];
export const getPostAdvisorReEnrollPlansBatchMutationOptions = (options)=>{
    const mutationKey = getPostAdvisorReEnrollPlansBatchMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisorId, data } = props ?? {};
        return postAdvisorReEnrollPlansBatch(advisorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorReEnrollPlansBatch = (options, queryClient)=>{
    return useMutation(getPostAdvisorReEnrollPlansBatchMutationOptions(options), queryClient);
};
export const getAdvisorWhitelabels = (advisorId, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/whitelabels`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorWhitelabelsQueryKey = (advisorId)=>{
    return [
        `/api/v3/advisors/${advisorId}/whitelabels`
    ];
};
export const getGetAdvisorWhitelabelsQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorWhitelabelsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorWhitelabels(advisorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisorId !== null && advisorId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorWhitelabels(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorWhitelabelsQueryOptions(advisorId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorWhitelabelsSuspenseQueryOptions = (advisorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorWhitelabelsQueryKey(advisorId);
    const queryFn = ({ signal })=>getAdvisorWhitelabels(advisorId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorWhitelabelsSuspense(advisorId, options, queryClient) {
    const queryOptions = getGetAdvisorWhitelabelsSuspenseQueryOptions(advisorId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postWhitelabel = (advisorId, postWhitelabelBody, signal)=>{
    return client({
        url: `/api/v3/advisors/${advisorId}/whitelabels`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postWhitelabelBody,
        signal
    });
};
export const getPostWhitelabelMutationKey = ()=>[
        'postWhitelabel'
    ];
export const getPostWhitelabelMutationOptions = (options)=>{
    const mutationKey = getPostWhitelabelMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisorId, data } = props ?? {};
        return postWhitelabel(advisorId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostWhitelabel = (options, queryClient)=>{
    return useMutation(getPostWhitelabelMutationOptions(options), queryClient);
};
export const postAdvisoryGroup = (advisoryGroupBody, signal)=>{
    return client({
        url: `/api/v3/advisory-groups`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: advisoryGroupBody,
        signal
    });
};
export const getPostAdvisoryGroupMutationKey = ()=>[
        'postAdvisoryGroup'
    ];
export const getPostAdvisoryGroupMutationOptions = (options)=>{
    const mutationKey = getPostAdvisoryGroupMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisoryGroup(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisoryGroup = (options, queryClient)=>{
    return useMutation(getPostAdvisoryGroupMutationOptions(options), queryClient);
};
export const deleteAdvisoryGroup = (advisoryGroupId, signal)=>{
    return client({
        url: `/api/v3/advisory-groups/${advisoryGroupId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteAdvisoryGroupMutationKey = ()=>[
        'deleteAdvisoryGroup'
    ];
export const getDeleteAdvisoryGroupMutationOptions = (options)=>{
    const mutationKey = getDeleteAdvisoryGroupMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryGroupId } = props ?? {};
        return deleteAdvisoryGroup(advisoryGroupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteAdvisoryGroup = (options, queryClient)=>{
    return useMutation(getDeleteAdvisoryGroupMutationOptions(options), queryClient);
};
export const patchAdvisoryGroup = (advisoryGroupId, advisoryGroupBody, signal)=>{
    return client({
        url: `/api/v3/advisory-groups/${advisoryGroupId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: advisoryGroupBody,
        signal
    });
};
export const getPatchAdvisoryGroupMutationKey = ()=>[
        'patchAdvisoryGroup'
    ];
export const getPatchAdvisoryGroupMutationOptions = (options)=>{
    const mutationKey = getPatchAdvisoryGroupMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryGroupId, data } = props ?? {};
        return patchAdvisoryGroup(advisoryGroupId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdvisoryGroup = (options, queryClient)=>{
    return useMutation(getPatchAdvisoryGroupMutationOptions(options), queryClient);
};
export const getAdvisoryOrganizationById = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisoryOrganizationByIdQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}`
    ];
};
export const getGetAdvisoryOrganizationByIdQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisoryOrganizationByIdQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisoryOrganizationById(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisoryOrganizationById(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisoryOrganizationByIdQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisoryOrganizationByIdSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisoryOrganizationByIdQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisoryOrganizationById(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisoryOrganizationByIdSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisoryOrganizationByIdSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAdvisoryOrganization = (advisoryOrganizationId, patchAdvisoryOrganizationBody, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAdvisoryOrganizationBody,
        signal
    });
};
export const getPatchAdvisoryOrganizationMutationKey = ()=>[
        'patchAdvisoryOrganization'
    ];
export const getPatchAdvisoryOrganizationMutationOptions = (options)=>{
    const mutationKey = getPatchAdvisoryOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, data } = props ?? {};
        return patchAdvisoryOrganization(advisoryOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAdvisoryOrganization = (options, queryClient)=>{
    return useMutation(getPatchAdvisoryOrganizationMutationOptions(options), queryClient);
};
export const getAdvisorsOfAdvisoryOrganization = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/advisors`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorsOfAdvisoryOrganizationQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/advisors`
    ];
};
export const getGetAdvisorsOfAdvisoryOrganizationQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorsOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisorsOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorsOfAdvisoryOrganization(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisorsOfAdvisoryOrganizationQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorsOfAdvisoryOrganizationSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorsOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisorsOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorsOfAdvisoryOrganizationSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisorsOfAdvisoryOrganizationSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisoryGroupsOfAdvisoryOrganization = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/advisory-groups`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisoryGroupsOfAdvisoryOrganizationQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/advisory-groups`
    ];
};
export const getGetAdvisoryGroupsOfAdvisoryOrganizationQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisoryGroupsOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisoryGroupsOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisoryGroupsOfAdvisoryOrganization(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisoryGroupsOfAdvisoryOrganizationQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisoryGroupsOfAdvisoryOrganizationSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisoryGroupsOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisoryGroupsOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisoryGroupsOfAdvisoryOrganizationSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisoryGroupsOfAdvisoryOrganizationSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getApiKeysOfAdvisoryOrganization = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/api-keys`,
        method: 'GET',
        signal
    });
};
export const getGetApiKeysOfAdvisoryOrganizationQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/api-keys`
    ];
};
export const getGetApiKeysOfAdvisoryOrganizationQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetApiKeysOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getApiKeysOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetApiKeysOfAdvisoryOrganization(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetApiKeysOfAdvisoryOrganizationQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetApiKeysOfAdvisoryOrganizationSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetApiKeysOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getApiKeysOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetApiKeysOfAdvisoryOrganizationSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetApiKeysOfAdvisoryOrganizationSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getManagedAccountFees = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/managed-account-fees`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountFeesQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/managed-account-fees`
    ];
};
export const getGetManagedAccountFeesQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountFeesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getManagedAccountFees(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetManagedAccountFees(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetManagedAccountFeesQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountFeesSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountFeesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getManagedAccountFees(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountFeesSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetManagedAccountFeesSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteManagedAccountProvider = (advisoryOrganizationId, managedAccountProviderId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/managed-account-providers/${managedAccountProviderId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteManagedAccountProviderMutationKey = ()=>[
        'deleteManagedAccountProvider'
    ];
export const getDeleteManagedAccountProviderMutationOptions = (options)=>{
    const mutationKey = getDeleteManagedAccountProviderMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, managedAccountProviderId } = props ?? {};
        return deleteManagedAccountProvider(advisoryOrganizationId, managedAccountProviderId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountProvider = (options, queryClient)=>{
    return useMutation(getDeleteManagedAccountProviderMutationOptions(options), queryClient);
};
export const getAdvisoryOrganizationMethodologies = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/methodologies`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisoryOrganizationMethodologiesQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/methodologies`
    ];
};
export const getGetAdvisoryOrganizationMethodologiesQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisoryOrganizationMethodologiesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisoryOrganizationMethodologies(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisoryOrganizationMethodologies(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisoryOrganizationMethodologiesQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisoryOrganizationMethodologiesSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisoryOrganizationMethodologiesQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getAdvisoryOrganizationMethodologies(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisoryOrganizationMethodologiesSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetAdvisoryOrganizationMethodologiesSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getNotificationTriggers = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notification-triggers`,
        method: 'GET',
        signal
    });
};
export const getGetNotificationTriggersQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/notification-triggers`
    ];
};
export const getGetNotificationTriggersQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNotificationTriggersQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getNotificationTriggers(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetNotificationTriggers(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetNotificationTriggersQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetNotificationTriggersSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNotificationTriggersQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getNotificationTriggers(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetNotificationTriggersSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetNotificationTriggersSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdvisorNotifications = (advisoryOrganizationId, params, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorNotificationsQueryKey = (advisoryOrganizationId, params)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorNotificationsQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorNotificationsQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdvisorNotifications(advisoryOrganizationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorNotifications(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdvisorNotificationsQueryOptions(advisoryOrganizationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorNotificationsSuspenseQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorNotificationsQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getAdvisorNotifications(advisoryOrganizationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorNotificationsSuspense(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetAdvisorNotificationsSuspenseQueryOptions(advisoryOrganizationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postAdvisorNotification = (advisoryOrganizationId, postAdvisorNotificationBody, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAdvisorNotificationBody,
        signal
    });
};
export const getPostAdvisorNotificationMutationKey = ()=>[
        'postAdvisorNotification'
    ];
export const getPostAdvisorNotificationMutationOptions = (options)=>{
    const mutationKey = getPostAdvisorNotificationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, data } = props ?? {};
        return postAdvisorNotification(advisoryOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorNotification = (options, queryClient)=>{
    return useMutation(getPostAdvisorNotificationMutationOptions(options), queryClient);
};
export const getExportAdvisorNotifications = (advisoryOrganizationId, params, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportAdvisorNotificationsQueryKey = (advisoryOrganizationId, params)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportAdvisorNotificationsQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAdvisorNotificationsQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getExportAdvisorNotifications(advisoryOrganizationId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetExportAdvisorNotifications(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetExportAdvisorNotificationsQueryOptions(advisoryOrganizationId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportAdvisorNotificationsSuspenseQueryOptions = (advisoryOrganizationId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportAdvisorNotificationsQueryKey(advisoryOrganizationId, params);
    const queryFn = ({ signal })=>getExportAdvisorNotifications(advisoryOrganizationId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportAdvisorNotificationsSuspense(advisoryOrganizationId, params, options, queryClient) {
    const queryOptions = getGetExportAdvisorNotificationsSuspenseQueryOptions(advisoryOrganizationId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postArchiveAdvisorNotification = (advisoryOrganizationId, notificationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications/${notificationId}/archive`,
        method: 'POST',
        signal
    });
};
export const getPostArchiveAdvisorNotificationMutationKey = ()=>[
        'postArchiveAdvisorNotification'
    ];
export const getPostArchiveAdvisorNotificationMutationOptions = (options)=>{
    const mutationKey = getPostArchiveAdvisorNotificationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, notificationId } = props ?? {};
        return postArchiveAdvisorNotification(advisoryOrganizationId, notificationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostArchiveAdvisorNotification = (options, queryClient)=>{
    return useMutation(getPostArchiveAdvisorNotificationMutationOptions(options), queryClient);
};
export const postCopyAdvisorNotification = (advisoryOrganizationId, notificationId, postCopyAdvisorNotificationBody, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications/${notificationId}/copy`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postCopyAdvisorNotificationBody,
        signal
    });
};
export const getPostCopyAdvisorNotificationMutationKey = ()=>[
        'postCopyAdvisorNotification'
    ];
export const getPostCopyAdvisorNotificationMutationOptions = (options)=>{
    const mutationKey = getPostCopyAdvisorNotificationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, notificationId, data } = props ?? {};
        return postCopyAdvisorNotification(advisoryOrganizationId, notificationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCopyAdvisorNotification = (options, queryClient)=>{
    return useMutation(getPostCopyAdvisorNotificationMutationOptions(options), queryClient);
};
export const getAdvisorNotificationPlans = (advisoryOrganizationId, notificationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications/${notificationId}/plans`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorNotificationPlansQueryKey = (advisoryOrganizationId, notificationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications/${notificationId}/plans`
    ];
};
export const getGetAdvisorNotificationPlansQueryOptions = (advisoryOrganizationId, notificationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorNotificationPlansQueryKey(advisoryOrganizationId, notificationId);
    const queryFn = ({ signal })=>getAdvisorNotificationPlans(advisoryOrganizationId, notificationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined && notificationId !== null && notificationId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorNotificationPlans(advisoryOrganizationId, notificationId, options, queryClient) {
    const queryOptions = getGetAdvisorNotificationPlansQueryOptions(advisoryOrganizationId, notificationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorNotificationPlansSuspenseQueryOptions = (advisoryOrganizationId, notificationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorNotificationPlansQueryKey(advisoryOrganizationId, notificationId);
    const queryFn = ({ signal })=>getAdvisorNotificationPlans(advisoryOrganizationId, notificationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorNotificationPlansSuspense(advisoryOrganizationId, notificationId, options, queryClient) {
    const queryOptions = getGetAdvisorNotificationPlansSuspenseQueryOptions(advisoryOrganizationId, notificationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const updateAdvisorNotificationPlans = (advisoryOrganizationId, notificationId, updateAdvisorNotificationPlansBody, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/notifications/${notificationId}/plans`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateAdvisorNotificationPlansBody,
        signal
    });
};
export const getUpdateAdvisorNotificationPlansMutationKey = ()=>[
        'updateAdvisorNotificationPlans'
    ];
export const getUpdateAdvisorNotificationPlansMutationOptions = (options)=>{
    const mutationKey = getUpdateAdvisorNotificationPlansMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { advisoryOrganizationId, notificationId, data } = props ?? {};
        return updateAdvisorNotificationPlans(advisoryOrganizationId, notificationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useUpdateAdvisorNotificationPlans = (options, queryClient)=>{
    return useMutation(getUpdateAdvisorNotificationPlansMutationOptions(options), queryClient);
};
export const getPlansOfAdvisoryOrganization = (advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/advisory-organizations/${advisoryOrganizationId}/plans`,
        method: 'GET',
        signal
    });
};
export const getGetPlansOfAdvisoryOrganizationQueryKey = (advisoryOrganizationId)=>{
    return [
        `/api/v3/advisory-organizations/${advisoryOrganizationId}/plans`
    ];
};
export const getGetPlansOfAdvisoryOrganizationQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlansOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getPlansOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: advisoryOrganizationId !== null && advisoryOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetPlansOfAdvisoryOrganization(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetPlansOfAdvisoryOrganizationQueryOptions(advisoryOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlansOfAdvisoryOrganizationSuspenseQueryOptions = (advisoryOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlansOfAdvisoryOrganizationQueryKey(advisoryOrganizationId);
    const queryFn = ({ signal })=>getPlansOfAdvisoryOrganization(advisoryOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlansOfAdvisoryOrganizationSuspense(advisoryOrganizationId, options, queryClient) {
    const queryOptions = getGetPlansOfAdvisoryOrganizationSuspenseQueryOptions(advisoryOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAnnexusEligibleTdfs = (params, signal)=>{
    return client({
        url: `/api/v3/annexus/eligible-tdfs`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAnnexusEligibleTdfsQueryKey = (params)=>{
    return [
        `/api/v3/annexus/eligible-tdfs`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAnnexusEligibleTdfsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnexusEligibleTdfsQueryKey(params);
    const queryFn = ({ signal })=>getAnnexusEligibleTdfs(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAnnexusEligibleTdfs(params, options, queryClient) {
    const queryOptions = getGetAnnexusEligibleTdfsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAnnexusEligibleTdfsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnexusEligibleTdfsQueryKey(params);
    const queryFn = ({ signal })=>getAnnexusEligibleTdfs(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAnnexusEligibleTdfsSuspense(params, options, queryClient) {
    const queryOptions = getGetAnnexusEligibleTdfsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAnnuitizations = (params, signal)=>{
    return client({
        url: `/api/v3/annuitizations`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAnnuitizationsQueryKey = (params)=>{
    return [
        `/api/v3/annuitizations`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAnnuitizationsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuitizationsQueryKey(params);
    const queryFn = ({ signal })=>getAnnuitizations(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAnnuitizations(params, options, queryClient) {
    const queryOptions = getGetAnnuitizationsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAnnuitizationsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuitizationsQueryKey(params);
    const queryFn = ({ signal })=>getAnnuitizations(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAnnuitizationsSuspense(params, options, queryClient) {
    const queryOptions = getGetAnnuitizationsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchAnnuitizations = (patchAnnuitizationsBody, signal)=>{
    return client({
        url: `/api/v3/annuitizations`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchAnnuitizationsBody,
        signal
    });
};
export const getPatchAnnuitizationsMutationKey = ()=>[
        'patchAnnuitizations'
    ];
export const getPatchAnnuitizationsMutationOptions = (options)=>{
    const mutationKey = getPatchAnnuitizationsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchAnnuitizations(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchAnnuitizations = (options, queryClient)=>{
    return useMutation(getPatchAnnuitizationsMutationOptions(options), queryClient);
};
export const getAnnuityPolicyParticipants = (params, signal)=>{
    return client({
        url: `/api/v3/annuity/annuity-policy-participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAnnuityPolicyParticipantsQueryKey = (params)=>{
    return [
        `/api/v3/annuity/annuity-policy-participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAnnuityPolicyParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityPolicyParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getAnnuityPolicyParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAnnuityPolicyParticipants(params, options, queryClient) {
    const queryOptions = getGetAnnuityPolicyParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAnnuityPolicyParticipantsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAnnuityPolicyParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getAnnuityPolicyParticipants(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAnnuityPolicyParticipantsSuspense(params, options, queryClient) {
    const queryOptions = getGetAnnuityPolicyParticipantsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPacLifeCertificates = (params, signal)=>{
    return client({
        url: `/api/v3/annuity/pac-life-certificates`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPacLifeCertificatesQueryKey = (params)=>{
    return [
        `/api/v3/annuity/pac-life-certificates`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPacLifeCertificatesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPacLifeCertificatesQueryKey(params);
    const queryFn = ({ signal })=>getPacLifeCertificates(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetPacLifeCertificates(params, options, queryClient) {
    const queryOptions = getGetPacLifeCertificatesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPacLifeCertificatesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPacLifeCertificatesQueryKey(params);
    const queryFn = ({ signal })=>getPacLifeCertificates(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPacLifeCertificatesSuspense(params, options, queryClient) {
    const queryOptions = getGetPacLifeCertificatesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPacLifeQuote = (params, signal)=>{
    return client({
        url: `/api/v3/annuity/pac-life-quote`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPacLifeQuoteQueryKey = (params)=>{
    return [
        `/api/v3/annuity/pac-life-quote`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPacLifeQuoteQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPacLifeQuoteQueryKey(params);
    const queryFn = ({ signal })=>getPacLifeQuote(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetPacLifeQuote(params, options, queryClient) {
    const queryOptions = getGetPacLifeQuoteQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPacLifeQuoteSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPacLifeQuoteQueryKey(params);
    const queryFn = ({ signal })=>getPacLifeQuote(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPacLifeQuoteSuspense(params, options, queryClient) {
    const queryOptions = getGetPacLifeQuoteSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postApiKey = (postApiKeyBody, signal)=>{
    return client({
        url: `/api/v3/api-keys`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postApiKeyBody,
        signal
    });
};
export const getPostApiKeyMutationKey = ()=>[
        'postApiKey'
    ];
export const getPostApiKeyMutationOptions = (options)=>{
    const mutationKey = getPostApiKeyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postApiKey(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostApiKey = (options, queryClient)=>{
    return useMutation(getPostApiKeyMutationOptions(options), queryClient);
};
export const patchApiKey = (apiKeyId, patchApiKeyBody, signal)=>{
    return client({
        url: `/api/v3/api-keys/${apiKeyId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchApiKeyBody,
        signal
    });
};
export const getPatchApiKeyMutationKey = ()=>[
        'patchApiKey'
    ];
export const getPatchApiKeyMutationOptions = (options)=>{
    const mutationKey = getPatchApiKeyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { apiKeyId, data } = props ?? {};
        return patchApiKey(apiKeyId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchApiKey = (options, queryClient)=>{
    return useMutation(getPatchApiKeyMutationOptions(options), queryClient);
};
export const deleteParticipantAuth = (signal)=>{
    return client({
        url: `/api/v3/auth`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteParticipantAuthMutationKey = ()=>[
        'deleteParticipantAuth'
    ];
export const getDeleteParticipantAuthMutationOptions = (options)=>{
    const mutationKey = getDeleteParticipantAuthMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return deleteParticipantAuth();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteParticipantAuth = (options, queryClient)=>{
    return useMutation(getDeleteParticipantAuthMutationOptions(options), queryClient);
};
export const getParticipantAuth = (signal)=>{
    return client({
        url: `/api/v3/auth`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantAuthQueryKey = ()=>{
    return [
        `/api/v3/auth`
    ];
};
export const getGetParticipantAuthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAuthQueryKey();
    const queryFn = ({ signal })=>getParticipantAuth(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetParticipantAuth(options, queryClient) {
    const queryOptions = getGetParticipantAuthQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantAuthSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAuthQueryKey();
    const queryFn = ({ signal })=>getParticipantAuth(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantAuthSuspense(options, queryClient) {
    const queryOptions = getGetParticipantAuthSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAdminAuth = (signal)=>{
    return client({
        url: `/api/v3/auth/admin`,
        method: 'GET',
        signal
    });
};
export const getGetAdminAuthQueryKey = ()=>{
    return [
        `/api/v3/auth/admin`
    ];
};
export const getGetAdminAuthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAuthQueryKey();
    const queryFn = ({ signal })=>getAdminAuth(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAdminAuth(options, queryClient) {
    const queryOptions = getGetAdminAuthQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdminAuthSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdminAuthQueryKey();
    const queryFn = ({ signal })=>getAdminAuth(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdminAuthSuspense(options, queryClient) {
    const queryOptions = getGetAdminAuthSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAutoJobQueueStatuses = (signal)=>{
    return client({
        url: `/api/v3/auto-job-queues/statuses`,
        method: 'GET',
        signal
    });
};
export const getGetAutoJobQueueStatusesQueryKey = ()=>{
    return [
        `/api/v3/auto-job-queues/statuses`
    ];
};
export const getGetAutoJobQueueStatusesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAutoJobQueueStatusesQueryKey();
    const queryFn = ({ signal })=>getAutoJobQueueStatuses(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAutoJobQueueStatuses(options, queryClient) {
    const queryOptions = getGetAutoJobQueueStatusesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAutoJobQueueStatusesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAutoJobQueueStatusesQueryKey();
    const queryFn = ({ signal })=>getAutoJobQueueStatuses(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAutoJobQueueStatusesSuspense(options, queryClient) {
    const queryOptions = getGetAutoJobQueueStatusesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getAutoJobQueueTaskTypes = (signal)=>{
    return client({
        url: `/api/v3/auto-job-queues/task-types`,
        method: 'GET',
        signal
    });
};
export const getGetAutoJobQueueTaskTypesQueryKey = ()=>{
    return [
        `/api/v3/auto-job-queues/task-types`
    ];
};
export const getGetAutoJobQueueTaskTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAutoJobQueueTaskTypesQueryKey();
    const queryFn = ({ signal })=>getAutoJobQueueTaskTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetAutoJobQueueTaskTypes(options, queryClient) {
    const queryOptions = getGetAutoJobQueueTaskTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAutoJobQueueTaskTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAutoJobQueueTaskTypesQueryKey();
    const queryFn = ({ signal })=>getAutoJobQueueTaskTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAutoJobQueueTaskTypesSuspense(options, queryClient) {
    const queryOptions = getGetAutoJobQueueTaskTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postBeneficiary = (postBeneficiaryBody, signal)=>{
    return client({
        url: `/api/v3/beneficiaries`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postBeneficiaryBody,
        signal
    });
};
export const getPostBeneficiaryMutationKey = ()=>[
        'postBeneficiary'
    ];
export const getPostBeneficiaryMutationOptions = (options)=>{
    const mutationKey = getPostBeneficiaryMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postBeneficiary(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostBeneficiary = (options, queryClient)=>{
    return useMutation(getPostBeneficiaryMutationOptions(options), queryClient);
};
export const deleteBeneficiary = (beneficiaryId, signal)=>{
    return client({
        url: `/api/v3/beneficiaries/${beneficiaryId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteBeneficiaryMutationKey = ()=>[
        'deleteBeneficiary'
    ];
export const getDeleteBeneficiaryMutationOptions = (options)=>{
    const mutationKey = getDeleteBeneficiaryMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { beneficiaryId } = props ?? {};
        return deleteBeneficiary(beneficiaryId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteBeneficiary = (options, queryClient)=>{
    return useMutation(getDeleteBeneficiaryMutationOptions(options), queryClient);
};
export const patchBeneficiary = (beneficiaryId, patchBeneficiaryBody, signal)=>{
    return client({
        url: `/api/v3/beneficiaries/${beneficiaryId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchBeneficiaryBody,
        signal
    });
};
export const getPatchBeneficiaryMutationKey = ()=>[
        'patchBeneficiary'
    ];
export const getPatchBeneficiaryMutationOptions = (options)=>{
    const mutationKey = getPatchBeneficiaryMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { beneficiaryId, data } = props ?? {};
        return patchBeneficiary(beneficiaryId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchBeneficiary = (options, queryClient)=>{
    return useMutation(getPatchBeneficiaryMutationOptions(options), queryClient);
};
/**
 * Generates asset allocations for a participant’s risk profile across the submitted fund lineup, and returns the disclosure material that must accompany them.
 *
 * Every request identifies the provider by `managedAccountProviderId`. The provider's ADV / other information link, logo and disclosures are returned alongside the allocations so they can be presented together.
 *
 * **The provider must be configured with the iJoin AMA methodology.** A `managedAccountProviderId` that is unknown, that your API key is not entitled to, or that is configured with any other methodology all return a `404`.
 *
 * The model is taken from the provider's configuration, so there is no `modelKey` on this request.
 *
 * Each fund is identified by its `cusip`, and every returned allocation echoes the `cusip` of the matching submitted fund. Supply `allocations` to steer the result toward category-level targets. Each `category` is a Morningstar category name (`Large Blend`, `Intermediate Core Bond`), not a broad asset-class label, and each `allocation` is a decimal between `0` and `1` with the set summing to `1`. A category the engine cannot map, or one no submitted fund belongs to, is reported back in `messages`. When none of the submitted funds can be allocated (for example, unrecognized CUSIPs), the request returns a `422` carrying the `callId` to quote in any support request and a `messages` array explaining what could not be allocated.
 *
 * <div class="alert-info">
 *   <p><strong>Don't know the participant's risk profile?</strong> Call the <a href="#operation/getGoalProjection">Goal Projection</a> endpoint first and use the <code>riskProfile</code> from its response to select the <code>riskProfile</code> value here.</p>
 * </div>
 * @summary iJoin AMA
 */ export const postCalculateAma = (postAmaReqDto, signal)=>{
    return client({
        url: `/api/v3/calcs/ama`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postAmaReqDto,
        signal
    });
};
export const getPostCalculateAmaMutationKey = ()=>[
        'postCalculateAma'
    ];
export const getPostCalculateAmaMutationOptions = (options)=>{
    const mutationKey = getPostCalculateAmaMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCalculateAma(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
/**
 * @summary iJoin AMA
 */ export const usePostCalculateAma = (options, queryClient)=>{
    return useMutation(getPostCalculateAmaMutationOptions(options), queryClient);
};
/**
 * Performs baseline retirement goal calculations and shortfall analysis for plans using a Managed Account Provider (MAP).
 *
 * All inputs are passed as query parameters. `retirementData` in the response continues through the participant's full projected retirement horizon.
 * @summary Goal Projection
 */ export const getGoalProjection = (params, signal)=>{
    return client({
        url: `/api/v3/calcs/goal-projection`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetGoalProjectionQueryKey = (params)=>{
    return [
        `/api/v3/calcs/goal-projection`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetGoalProjectionQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGoalProjectionQueryKey(params);
    const queryFn = ({ signal })=>getGoalProjection(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
/**
 * @summary Goal Projection
 */ export function useGetGoalProjection(params, options, queryClient) {
    const queryOptions = getGetGoalProjectionQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetGoalProjectionSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGoalProjectionQueryKey(params);
    const queryFn = ({ signal })=>getGoalProjection(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
/**
 * @summary Goal Projection
 */ export function useGetGoalProjectionSuspense(params, options, queryClient) {
    const queryOptions = getGetGoalProjectionSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
/**
 * Generates asset allocations and fund selections for a participant's risk profile and chosen model via the LeafHouse engine.
 *
 * Each fund is identified by its `cusip`, and every returned allocation echoes the `cusip` of the matching submitted fund. When none of the submitted funds can be allocated (for example, unrecognized CUSIPs), the request returns a `422` carrying the `callId` to quote in any support request and a `messages` array explaining what could not be allocated.
 *
 * **`birthDate` is required**: the engine resolves its models by the participant's age, so the participant's date of birth must be supplied. Age also drives fund selection directly — `CPGTD1` allocates to the target-date fund matching the participant's projected retirement year, so the submitted lineup must include those funds.
 *
 * Supply `allocations` to steer the result toward category-level targets. Each `category` is a Morningstar category name (`Large Blend`, `Intermediate Core Bond`), not a broad asset-class label, and each `allocation` is a decimal between `0` and `1` with the set summing to `1`. A category the engine cannot map, or one no submitted fund belongs to, is reported back in `messages`.
 *
 * **`FKGOE1`** resolves its age profiles per submodel; the optional `submodel` (e.g. `EP1`, the default) is only used with this model key.
 *
 * <div class="alert-info">
 *   <p><strong>Don't know the participant's risk profile?</strong> Call the <a href="#operation/getGoalProjection">Goal Projection</a> endpoint first and use the <code>riskProfile</code> from its response to select the <code>riskProfile</code> value here.</p>
 * </div>
 * @summary LeafHouse
 */ export const postCalculateLeafHouse = (leafHouseReqDto, signal)=>{
    return client({
        url: `/api/v3/calcs/leafhouse`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: leafHouseReqDto,
        signal
    });
};
export const getPostCalculateLeafHouseMutationKey = ()=>[
        'postCalculateLeafHouse'
    ];
export const getPostCalculateLeafHouseMutationOptions = (options)=>{
    const mutationKey = getPostCalculateLeafHouseMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCalculateLeafHouse(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
/**
 * @summary LeafHouse
 */ export const usePostCalculateLeafHouse = (options, queryClient)=>{
    return useMutation(getPostCalculateLeafHouseMutationOptions(options), queryClient);
};
/**
 * Performs retirement projection and shortfall analysis for plans not using a Managed Account Provider.
 *
 * All inputs are passed as query parameters. `retirementData` in the response continues through the participant's full projected retirement horizon.
 * @summary Non-MAP Core Projections
 */ export const getNonMapCore = (params, signal)=>{
    return client({
        url: `/api/v3/calcs/non-map-core`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetNonMapCoreQueryKey = (params)=>{
    return [
        `/api/v3/calcs/non-map-core`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetNonMapCoreQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNonMapCoreQueryKey(params);
    const queryFn = ({ signal })=>getNonMapCore(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
/**
 * @summary Non-MAP Core Projections
 */ export function useGetNonMapCore(params, options, queryClient) {
    const queryOptions = getGetNonMapCoreQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetNonMapCoreSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNonMapCoreQueryKey(params);
    const queryFn = ({ signal })=>getNonMapCore(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
/**
 * @summary Non-MAP Core Projections
 */ export function useGetNonMapCoreSuspense(params, options, queryClient) {
    const queryOptions = getGetNonMapCoreSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postCalculateParticipantHealth = (participantHealthRequestDto, signal)=>{
    return client({
        url: `/api/v3/calcs/participant-health`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantHealthRequestDto,
        signal
    });
};
export const getPostCalculateParticipantHealthMutationKey = ()=>[
        'postCalculateParticipantHealth'
    ];
export const getPostCalculateParticipantHealthMutationOptions = (options)=>{
    const mutationKey = getPostCalculateParticipantHealthMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCalculateParticipantHealth(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCalculateParticipantHealth = (options, queryClient)=>{
    return useMutation(getPostCalculateParticipantHealthMutationOptions(options), queryClient);
};
/**
 * Produces optimized asset allocations and custom target-date tracks using PIMCO's Income-Guided Personalized Solutions (IGPS) methodology.
 *
 * **Deferral pairs**: provide exactly one of `preTaxDeferralDollars` or `preTaxDeferralPercent`, and exactly one of `rothDeferralDollars` or `rothDeferralPercent`. Sending both values of a pair, or neither, returns a `400` validation error.
 * @summary PIMCO IGPS
 */ export const postCalculatePimcoIgps = (pimcoIgpsReqDto, signal)=>{
    return client({
        url: `/api/v3/calcs/pimco-igps`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: pimcoIgpsReqDto,
        signal
    });
};
export const getPostCalculatePimcoIgpsMutationKey = ()=>[
        'postCalculatePimcoIgps'
    ];
export const getPostCalculatePimcoIgpsMutationOptions = (options)=>{
    const mutationKey = getPostCalculatePimcoIgpsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCalculatePimcoIgps(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
/**
 * @summary PIMCO IGPS
 */ export const usePostCalculatePimcoIgps = (options, queryClient)=>{
    return useMutation(getPostCalculatePimcoIgpsMutationOptions(options), queryClient);
};
export const postCalculatePlanHealth = (planHealthRequestDto, signal)=>{
    return client({
        url: `/api/v3/calcs/plan-health`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: planHealthRequestDto,
        signal
    });
};
export const getPostCalculatePlanHealthMutationKey = ()=>[
        'postCalculatePlanHealth'
    ];
export const getPostCalculatePlanHealthMutationOptions = (options)=>{
    const mutationKey = getPostCalculatePlanHealthMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCalculatePlanHealth(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCalculatePlanHealth = (options, queryClient)=>{
    return useMutation(getPostCalculatePlanHealthMutationOptions(options), queryClient);
};
/**
 * Calculates a personal rate of return (PRR) over a period using a money-weighted, annualized method that accounts for the timing and size of every cash flow.
 *
 * Supply `beginningBalance`, `endingBalance`, and the `cashFlows` that occurred between them, and the return is computed entirely from the values you pass. Each cash flow amount is **negative for a contribution** (money paid in) and **positive for a withdrawal** (money taken out). Omit `cashFlows` when there was no activity between the two balances.
 *
 * When `startDate` is omitted it defaults to the earliest cash flow; when `endDate` is omitted it defaults to today.
 * @summary Personal Rate of Return
 */ export const postCalculatePrr = (prrRequestDto, signal)=>{
    return client({
        url: `/api/v3/calcs/prr`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: prrRequestDto,
        signal
    });
};
export const getPostCalculatePrrMutationKey = ()=>[
        'postCalculatePrr'
    ];
export const getPostCalculatePrrMutationOptions = (options)=>{
    const mutationKey = getPostCalculatePrrMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCalculatePrr(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
/**
 * @summary Personal Rate of Return
 */ export const usePostCalculatePrr = (options, queryClient)=>{
    return useMutation(getPostCalculatePrrMutationOptions(options), queryClient);
};
export const postCampaignEmail = (campaignEmailBody, signal)=>{
    return client({
        url: `/api/v3/campaign-emails`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: campaignEmailBody,
        signal
    });
};
export const getPostCampaignEmailMutationKey = ()=>[
        'postCampaignEmail'
    ];
export const getPostCampaignEmailMutationOptions = (options)=>{
    const mutationKey = getPostCampaignEmailMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCampaignEmail(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCampaignEmail = (options, queryClient)=>{
    return useMutation(getPostCampaignEmailMutationOptions(options), queryClient);
};
export const deleteCampaignEmail = (campaignEmailId, signal)=>{
    return client({
        url: `/api/v3/campaign-emails/${campaignEmailId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteCampaignEmailMutationKey = ()=>[
        'deleteCampaignEmail'
    ];
export const getDeleteCampaignEmailMutationOptions = (options)=>{
    const mutationKey = getDeleteCampaignEmailMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignEmailId } = props ?? {};
        return deleteCampaignEmail(campaignEmailId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteCampaignEmail = (options, queryClient)=>{
    return useMutation(getDeleteCampaignEmailMutationOptions(options), queryClient);
};
export const patchCampaignEmail = (campaignEmailId, campaignEmailBody, signal)=>{
    return client({
        url: `/api/v3/campaign-emails/${campaignEmailId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: campaignEmailBody,
        signal
    });
};
export const getPatchCampaignEmailMutationKey = ()=>[
        'patchCampaignEmail'
    ];
export const getPatchCampaignEmailMutationOptions = (options)=>{
    const mutationKey = getPatchCampaignEmailMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { campaignEmailId, data } = props ?? {};
        return patchCampaignEmail(campaignEmailId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchCampaignEmail = (options, queryClient)=>{
    return useMutation(getPatchCampaignEmailMutationOptions(options), queryClient);
};
export const getConnectivity = (signal)=>{
    return client({
        url: `/api/v3/connectivity`,
        method: 'GET',
        signal
    });
};
export const getGetConnectivityQueryKey = ()=>{
    return [
        `/api/v3/connectivity`
    ];
};
export const getGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConnectivityQueryKey();
    const queryFn = ({ signal })=>getConnectivity(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetConnectivity(options, queryClient) {
    const queryOptions = getGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetConnectivitySuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConnectivityQueryKey();
    const queryFn = ({ signal })=>getConnectivity(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetConnectivitySuspense(options, queryClient) {
    const queryOptions = getGetConnectivitySuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getCustomModelPortfolio = (customModelPortfolioId, signal)=>{
    return client({
        url: `/api/v3/custom-model-portfolios/${customModelPortfolioId}`,
        method: 'GET',
        signal
    });
};
export const getGetCustomModelPortfolioQueryKey = (customModelPortfolioId)=>{
    return [
        `/api/v3/custom-model-portfolios/${customModelPortfolioId}`
    ];
};
export const getGetCustomModelPortfolioQueryOptions = (customModelPortfolioId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCustomModelPortfolioQueryKey(customModelPortfolioId);
    const queryFn = ({ signal })=>getCustomModelPortfolio(customModelPortfolioId, signal);
    return {
        queryKey,
        queryFn,
        enabled: customModelPortfolioId !== null && customModelPortfolioId !== undefined,
        ...queryOptions
    };
};
export function useGetCustomModelPortfolio(customModelPortfolioId, options, queryClient) {
    const queryOptions = getGetCustomModelPortfolioQueryOptions(customModelPortfolioId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetCustomModelPortfolioSuspenseQueryOptions = (customModelPortfolioId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCustomModelPortfolioQueryKey(customModelPortfolioId);
    const queryFn = ({ signal })=>getCustomModelPortfolio(customModelPortfolioId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetCustomModelPortfolioSuspense(customModelPortfolioId, options, queryClient) {
    const queryOptions = getGetCustomModelPortfolioSuspenseQueryOptions(customModelPortfolioId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postEmbedNonMapCoreCalc = (postEmbedNonMapCoreCalcBody, signal)=>{
    return client({
        url: `/api/v3/embed/calcs/non-map-core`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postEmbedNonMapCoreCalcBody,
        signal
    });
};
export const getPostEmbedNonMapCoreCalcMutationKey = ()=>[
        'postEmbedNonMapCoreCalc'
    ];
export const getPostEmbedNonMapCoreCalcMutationOptions = (options)=>{
    const mutationKey = getPostEmbedNonMapCoreCalcMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEmbedNonMapCoreCalc(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEmbedNonMapCoreCalc = (options, queryClient)=>{
    return useMutation(getPostEmbedNonMapCoreCalcMutationOptions(options), queryClient);
};
export const postEmbedSocialSecurityCalc = (postEmbedSocialSecurityCalcBody, signal)=>{
    return client({
        url: `/api/v3/embed/calcs/social-security`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postEmbedSocialSecurityCalcBody,
        signal
    });
};
export const getPostEmbedSocialSecurityCalcMutationKey = ()=>[
        'postEmbedSocialSecurityCalc'
    ];
export const getPostEmbedSocialSecurityCalcMutationOptions = (options)=>{
    const mutationKey = getPostEmbedSocialSecurityCalcMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEmbedSocialSecurityCalc(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEmbedSocialSecurityCalc = (options, queryClient)=>{
    return useMutation(getPostEmbedSocialSecurityCalcMutationOptions(options), queryClient);
};
export const postEmbedRefresh = (signal)=>{
    return client({
        url: `/api/v3/embed/refresh`,
        method: 'POST',
        signal
    });
};
export const getPostEmbedRefreshMutationKey = ()=>[
        'postEmbedRefresh'
    ];
export const getPostEmbedRefreshMutationOptions = (options)=>{
    const mutationKey = getPostEmbedRefreshMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postEmbedRefresh();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEmbedRefresh = (options, queryClient)=>{
    return useMutation(getPostEmbedRefreshMutationOptions(options), queryClient);
};
/**
 * Exchanges your API key and a widget payload for a short-lived embed token. Call this endpoint **from your backend only** and pass the returned `token` to the `<ijoin-embed>` element on your page; never expose your API key in client-side code.
 *
 * The `embedType` field determines the shape of `data` (see the schema below). Tokens expire after **1 hour**; the response `expiresAt` tells you when. Setting a fresh `token` attribute on the element updates the existing session without a full reload.
 * @summary Create Embed Token
 */ export const postEmbedToken = (postEmbedTokenBody, signal)=>{
    return client({
        url: `/api/v3/embed/token`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postEmbedTokenBody,
        signal
    });
};
export const getPostEmbedTokenMutationKey = ()=>[
        'postEmbedToken'
    ];
export const getPostEmbedTokenMutationOptions = (options)=>{
    const mutationKey = getPostEmbedTokenMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEmbedToken(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
/**
 * @summary Create Embed Token
 */ export const usePostEmbedToken = (options, queryClient)=>{
    return useMutation(getPostEmbedTokenMutationOptions(options), queryClient);
};
export const renderEmbed = (embedType, signal)=>{
    return client({
        url: `/api/v3/embed/${embedType}`,
        method: 'GET',
        signal
    });
};
export const getRenderEmbedQueryKey = (embedType)=>{
    return [
        `/api/v3/embed/${embedType}`
    ];
};
export const getRenderEmbedQueryOptions = (embedType, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getRenderEmbedQueryKey(embedType);
    const queryFn = ({ signal })=>renderEmbed(embedType, signal);
    return {
        queryKey,
        queryFn,
        enabled: embedType !== null && embedType !== undefined,
        ...queryOptions
    };
};
export function useRenderEmbed(embedType, options, queryClient) {
    const queryOptions = getRenderEmbedQueryOptions(embedType, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getRenderEmbedSuspenseQueryOptions = (embedType, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getRenderEmbedQueryKey(embedType);
    const queryFn = ({ signal })=>renderEmbed(embedType, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useRenderEmbedSuspense(embedType, options, queryClient) {
    const queryOptions = getRenderEmbedSuspenseQueryOptions(embedType, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getEnv = (signal)=>{
    return client({
        url: `/api/v3/env`,
        method: 'GET',
        signal
    });
};
export const getGetEnvQueryKey = ()=>{
    return [
        `/api/v3/env`
    ];
};
export const getGetEnvQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnvQueryKey();
    const queryFn = ({ signal })=>getEnv(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetEnv(options, queryClient) {
    const queryOptions = getGetEnvQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetEnvSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEnvQueryKey();
    const queryFn = ({ signal })=>getEnv(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetEnvSuspense(options, queryClient) {
    const queryOptions = getGetEnvSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getLatestEula = (signal)=>{
    return client({
        url: `/api/v3/eula`,
        method: 'GET',
        signal
    });
};
export const getGetLatestEulaQueryKey = ()=>{
    return [
        `/api/v3/eula`
    ];
};
export const getGetLatestEulaQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLatestEulaQueryKey();
    const queryFn = ({ signal })=>getLatestEula(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetLatestEula(options, queryClient) {
    const queryOptions = getGetLatestEulaQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetLatestEulaSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLatestEulaQueryKey();
    const queryFn = ({ signal })=>getLatestEula(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetLatestEulaSuspense(options, queryClient) {
    const queryOptions = getGetLatestEulaSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
/**
 * @deprecated
 * @summary prefer PATCH /api/v3/participant/:participantId/explore-details
 */ export const patchExploreParticipantDetails = (exploreParticipantDetailsId, patchExploreParticipantDetailsBody, signal)=>{
    return client({
        url: `/api/v3/explore-participant-details/${exploreParticipantDetailsId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchExploreParticipantDetailsBody,
        signal
    });
};
export const getPatchExploreParticipantDetailsMutationKey = ()=>[
        'patchExploreParticipantDetails'
    ];
export const getPatchExploreParticipantDetailsMutationOptions = (options)=>{
    const mutationKey = getPatchExploreParticipantDetailsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { exploreParticipantDetailsId, data } = props ?? {};
        return patchExploreParticipantDetails(exploreParticipantDetailsId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
/**
 * @deprecated
 * @summary prefer PATCH /api/v3/participant/:participantId/explore-details
 */ export const usePatchExploreParticipantDetails = (options, queryClient)=>{
    return useMutation(getPatchExploreParticipantDetailsMutationOptions(options), queryClient);
};
export const getFidelityAnnuityApplications = (signal)=>{
    return client({
        url: `/api/v3/fidelity/annuity-applications`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityAnnuityApplicationsQueryKey = ()=>{
    return [
        `/api/v3/fidelity/annuity-applications`
    ];
};
export const getGetFidelityAnnuityApplicationsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityAnnuityApplicationsQueryKey();
    const queryFn = ({ signal })=>getFidelityAnnuityApplications(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityAnnuityApplications(options, queryClient) {
    const queryOptions = getGetFidelityAnnuityApplicationsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityAnnuityApplicationsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityAnnuityApplicationsQueryKey();
    const queryFn = ({ signal })=>getFidelityAnnuityApplications(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityAnnuityApplicationsSuspense(options, queryClient) {
    const queryOptions = getGetFidelityAnnuityApplicationsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchFidelityAnnuityApplications = (patchFidelityAnnuityApplicationBody, signal)=>{
    return client({
        url: `/api/v3/fidelity/annuity-applications`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchFidelityAnnuityApplicationBody,
        signal
    });
};
export const getPatchFidelityAnnuityApplicationsMutationKey = ()=>[
        'patchFidelityAnnuityApplications'
    ];
export const getPatchFidelityAnnuityApplicationsMutationOptions = (options)=>{
    const mutationKey = getPatchFidelityAnnuityApplicationsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchFidelityAnnuityApplications(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchFidelityAnnuityApplications = (options, queryClient)=>{
    return useMutation(getPatchFidelityAnnuityApplicationsMutationOptions(options), queryClient);
};
export const postFidelityAnnuityApplications = (signal)=>{
    return client({
        url: `/api/v3/fidelity/annuity-applications`,
        method: 'POST',
        signal
    });
};
export const getPostFidelityAnnuityApplicationsMutationKey = ()=>[
        'postFidelityAnnuityApplications'
    ];
export const getPostFidelityAnnuityApplicationsMutationOptions = (options)=>{
    const mutationKey = getPostFidelityAnnuityApplicationsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postFidelityAnnuityApplications();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFidelityAnnuityApplications = (options, queryClient)=>{
    return useMutation(getPostFidelityAnnuityApplicationsMutationOptions(options), queryClient);
};
export const getFidelityAnnuityApplicationsCarrierContracts = (signal)=>{
    return client({
        url: `/api/v3/fidelity/annuity-applications/carrier-contracts`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityAnnuityApplicationsCarrierContractsQueryKey = ()=>{
    return [
        `/api/v3/fidelity/annuity-applications/carrier-contracts`
    ];
};
export const getGetFidelityAnnuityApplicationsCarrierContractsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityAnnuityApplicationsCarrierContractsQueryKey();
    const queryFn = ({ signal })=>getFidelityAnnuityApplicationsCarrierContracts(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityAnnuityApplicationsCarrierContracts(options, queryClient) {
    const queryOptions = getGetFidelityAnnuityApplicationsCarrierContractsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityAnnuityApplicationsCarrierContractsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityAnnuityApplicationsCarrierContractsQueryKey();
    const queryFn = ({ signal })=>getFidelityAnnuityApplicationsCarrierContracts(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityAnnuityApplicationsCarrierContractsSuspense(options, queryClient) {
    const queryOptions = getGetFidelityAnnuityApplicationsCarrierContractsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchFidelityAnnuityApplicationsCarrierContracts = (fidelityCarrierContractId, patchFidelityCarrierContractBody, signal)=>{
    return client({
        url: `/api/v3/fidelity/annuity-applications/carrier-contracts/${fidelityCarrierContractId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchFidelityCarrierContractBody,
        signal
    });
};
export const getPatchFidelityAnnuityApplicationsCarrierContractsMutationKey = ()=>[
        'patchFidelityAnnuityApplicationsCarrierContracts'
    ];
export const getPatchFidelityAnnuityApplicationsCarrierContractsMutationOptions = (options)=>{
    const mutationKey = getPatchFidelityAnnuityApplicationsCarrierContractsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { fidelityCarrierContractId, data } = props ?? {};
        return patchFidelityAnnuityApplicationsCarrierContracts(fidelityCarrierContractId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchFidelityAnnuityApplicationsCarrierContracts = (options, queryClient)=>{
    return useMutation(getPatchFidelityAnnuityApplicationsCarrierContractsMutationOptions(options), queryClient);
};
export const postFidelityAnnuityApplicationsSubmit = (signal)=>{
    return client({
        url: `/api/v3/fidelity/annuity-applications/submit`,
        method: 'POST',
        signal
    });
};
export const getPostFidelityAnnuityApplicationsSubmitMutationKey = ()=>[
        'postFidelityAnnuityApplicationsSubmit'
    ];
export const getPostFidelityAnnuityApplicationsSubmitMutationOptions = (options)=>{
    const mutationKey = getPostFidelityAnnuityApplicationsSubmitMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postFidelityAnnuityApplicationsSubmit();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFidelityAnnuityApplicationsSubmit = (options, queryClient)=>{
    return useMutation(getPostFidelityAnnuityApplicationsSubmitMutationOptions(options), queryClient);
};
export const getFidelityBalances = (signal)=>{
    return client({
        url: `/api/v3/fidelity/balances`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityBalancesQueryKey = ()=>{
    return [
        `/api/v3/fidelity/balances`
    ];
};
export const getGetFidelityBalancesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityBalancesQueryKey();
    const queryFn = ({ signal })=>getFidelityBalances(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityBalances(options, queryClient) {
    const queryOptions = getGetFidelityBalancesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityBalancesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityBalancesQueryKey();
    const queryFn = ({ signal })=>getFidelityBalances(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityBalancesSuspense(options, queryClient) {
    const queryOptions = getGetFidelityBalancesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFidelityCallback = (signal)=>{
    return client({
        url: `/api/v3/fidelity/callback`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityCallbackQueryKey = ()=>{
    return [
        `/api/v3/fidelity/callback`
    ];
};
export const getGetFidelityCallbackQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityCallbackQueryKey();
    const queryFn = ({ signal })=>getFidelityCallback(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityCallback(options, queryClient) {
    const queryOptions = getGetFidelityCallbackQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityCallbackSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityCallbackQueryKey();
    const queryFn = ({ signal })=>getFidelityCallback(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityCallbackSuspense(options, queryClient) {
    const queryOptions = getGetFidelityCallbackSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFidelityContacts = (signal)=>{
    return client({
        url: `/api/v3/fidelity/contacts`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityContactsQueryKey = ()=>{
    return [
        `/api/v3/fidelity/contacts`
    ];
};
export const getGetFidelityContactsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityContactsQueryKey();
    const queryFn = ({ signal })=>getFidelityContacts(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityContacts(options, queryClient) {
    const queryOptions = getGetFidelityContactsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityContactsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityContactsQueryKey();
    const queryFn = ({ signal })=>getFidelityContacts(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityContactsSuspense(options, queryClient) {
    const queryOptions = getGetFidelityContactsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFidelityContributions = (signal)=>{
    return client({
        url: `/api/v3/fidelity/contributions`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityContributionsQueryKey = ()=>{
    return [
        `/api/v3/fidelity/contributions`
    ];
};
export const getGetFidelityContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityContributionsQueryKey();
    const queryFn = ({ signal })=>getFidelityContributions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityContributions(options, queryClient) {
    const queryOptions = getGetFidelityContributionsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityContributionsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityContributionsQueryKey();
    const queryFn = ({ signal })=>getFidelityContributions(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityContributionsSuspense(options, queryClient) {
    const queryOptions = getGetFidelityContributionsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFidelityCustomers = (signal)=>{
    return client({
        url: `/api/v3/fidelity/customers`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityCustomersQueryKey = ()=>{
    return [
        `/api/v3/fidelity/customers`
    ];
};
export const getGetFidelityCustomersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityCustomersQueryKey();
    const queryFn = ({ signal })=>getFidelityCustomers(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityCustomers(options, queryClient) {
    const queryOptions = getGetFidelityCustomersQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityCustomersSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityCustomersQueryKey();
    const queryFn = ({ signal })=>getFidelityCustomers(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityCustomersSuspense(options, queryClient) {
    const queryOptions = getGetFidelityCustomersSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFidelityDeferrals = (signal)=>{
    return client({
        url: `/api/v3/fidelity/deferrals`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityDeferralsQueryKey = ()=>{
    return [
        `/api/v3/fidelity/deferrals`
    ];
};
export const getGetFidelityDeferralsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityDeferralsQueryKey();
    const queryFn = ({ signal })=>getFidelityDeferrals(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityDeferrals(options, queryClient) {
    const queryOptions = getGetFidelityDeferralsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityDeferralsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityDeferralsQueryKey();
    const queryFn = ({ signal })=>getFidelityDeferrals(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityDeferralsSuspense(options, queryClient) {
    const queryOptions = getGetFidelityDeferralsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFidelityLogin = (params, signal)=>{
    return client({
        url: `/api/v3/fidelity/login`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFidelityLoginQueryKey = (params)=>{
    return [
        `/api/v3/fidelity/login`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFidelityLoginQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityLoginQueryKey(params);
    const queryFn = ({ signal })=>getFidelityLogin(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityLogin(params, options, queryClient) {
    const queryOptions = getGetFidelityLoginQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityLoginSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityLoginQueryKey(params);
    const queryFn = ({ signal })=>getFidelityLogin(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityLoginSuspense(params, options, queryClient) {
    const queryOptions = getGetFidelityLoginSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFidelityParticipations = (signal)=>{
    return client({
        url: `/api/v3/fidelity/participations`,
        method: 'GET',
        signal
    });
};
export const getGetFidelityParticipationsQueryKey = ()=>{
    return [
        `/api/v3/fidelity/participations`
    ];
};
export const getGetFidelityParticipationsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityParticipationsQueryKey();
    const queryFn = ({ signal })=>getFidelityParticipations(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFidelityParticipations(options, queryClient) {
    const queryOptions = getGetFidelityParticipationsQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFidelityParticipationsSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFidelityParticipationsQueryKey();
    const queryFn = ({ signal })=>getFidelityParticipations(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFidelityParticipationsSuspense(options, queryClient) {
    const queryOptions = getGetFidelityParticipationsSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFinicityAccountTypes = (signal)=>{
    return client({
        url: `/api/v3/finicity/account-types`,
        method: 'GET',
        signal
    });
};
export const getGetFinicityAccountTypesQueryKey = ()=>{
    return [
        `/api/v3/finicity/account-types`
    ];
};
export const getGetFinicityAccountTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFinicityAccountTypesQueryKey();
    const queryFn = ({ signal })=>getFinicityAccountTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFinicityAccountTypes(options, queryClient) {
    const queryOptions = getGetFinicityAccountTypesQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFinicityAccountTypesSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFinicityAccountTypesQueryKey();
    const queryFn = ({ signal })=>getFinicityAccountTypes(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFinicityAccountTypesSuspense(options, queryClient) {
    const queryOptions = getGetFinicityAccountTypesSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postFinicityConnectParticipant = (experience, participantId, signal)=>{
    return client({
        url: `/api/v3/finicity/connect/${experience}/participants/${participantId}`,
        method: 'POST',
        signal
    });
};
export const getPostFinicityConnectParticipantMutationKey = ()=>[
        'postFinicityConnectParticipant'
    ];
export const getPostFinicityConnectParticipantMutationOptions = (options)=>{
    const mutationKey = getPostFinicityConnectParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { experience, participantId } = props ?? {};
        return postFinicityConnectParticipant(experience, participantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFinicityConnectParticipant = (options, queryClient)=>{
    return useMutation(getPostFinicityConnectParticipantMutationOptions(options), queryClient);
};
export const postFinicityRefreshParticipant = (participantId, signal)=>{
    return client({
        url: `/api/v3/finicity/refresh/participants/${participantId}`,
        method: 'POST',
        signal
    });
};
export const getPostFinicityRefreshParticipantMutationKey = ()=>[
        'postFinicityRefreshParticipant'
    ];
export const getPostFinicityRefreshParticipantMutationOptions = (options)=>{
    const mutationKey = getPostFinicityRefreshParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { participantId } = props ?? {};
        return postFinicityRefreshParticipant(participantId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFinicityRefreshParticipant = (options, queryClient)=>{
    return useMutation(getPostFinicityRefreshParticipantMutationOptions(options), queryClient);
};
export const postFrpCallback = (signal)=>{
    return client({
        url: `/api/v3/frp/callback`,
        method: 'GET',
        signal
    });
};
export const getPostFrpCallbackQueryKey = ()=>{
    return [
        `/api/v3/frp/callback`
    ];
};
export const getPostFrpCallbackQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPostFrpCallbackQueryKey();
    const queryFn = ({ signal })=>postFrpCallback(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function usePostFrpCallback(options, queryClient) {
    const queryOptions = getPostFrpCallbackQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPostFrpCallbackSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getPostFrpCallbackQueryKey();
    const queryFn = ({ signal })=>postFrpCallback(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function usePostFrpCallbackSuspense(options, queryClient) {
    const queryOptions = getPostFrpCallbackSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFrpLogin = (params, signal)=>{
    return client({
        url: `/api/v3/frp/login`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFrpLoginQueryKey = (params)=>{
    return [
        `/api/v3/frp/login`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFrpLoginQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFrpLoginQueryKey(params);
    const queryFn = ({ signal })=>getFrpLogin(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFrpLogin(params, options, queryClient) {
    const queryOptions = getGetFrpLoginQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFrpLoginSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFrpLoginQueryKey(params);
    const queryFn = ({ signal })=>getFrpLogin(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFrpLoginSuspense(params, options, queryClient) {
    const queryOptions = getGetFrpLoginSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getFunds = (params, signal)=>{
    return client({
        url: `/api/v3/funds`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFundsQueryKey = (params)=>{
    return [
        `/api/v3/funds`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFundsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFundsQueryKey(params);
    const queryFn = ({ signal })=>getFunds(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFunds(params, options, queryClient) {
    const queryOptions = getGetFundsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFundsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFundsQueryKey(params);
    const queryFn = ({ signal })=>getFunds(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFundsSuspense(params, options, queryClient) {
    const queryOptions = getGetFundsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
/**
 * A lightweight health check endpoint. It requires **no authentication** and no request body, and returns `200 OK` whenever the API service is available. A `200` response confirms the API service is reachable and serving requests.
 * @summary Health Check
 */ export const getHealth = (signal)=>{
    return client({
        url: `/api/v3/health`,
        method: 'GET',
        signal
    });
};
export const getGetHealthQueryKey = ()=>{
    return [
        `/api/v3/health`
    ];
};
export const getGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();
    const queryFn = ({ signal })=>getHealth(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
/**
 * @summary Health Check
 */ export function useGetHealth(options, queryClient) {
    const queryOptions = getGetHealthQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetHealthSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();
    const queryFn = ({ signal })=>getHealth(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
/**
 * @summary Health Check
 */ export function useGetHealthSuspense(options, queryClient) {
    const queryOptions = getGetHealthSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postIdAnalyzer = (postIdAnalyzerBody, signal)=>{
    return client({
        url: `/api/v3/id-analyzer`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postIdAnalyzerBody,
        signal
    });
};
export const getPostIdAnalyzerMutationKey = ()=>[
        'postIdAnalyzer'
    ];
export const getPostIdAnalyzerMutationOptions = (options)=>{
    const mutationKey = getPostIdAnalyzerMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postIdAnalyzer(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIdAnalyzer = (options, queryClient)=>{
    return useMutation(getPostIdAnalyzerMutationOptions(options), queryClient);
};
export const getInvestmentVehicle = (investmentVehicleId, signal)=>{
    return client({
        url: `/api/v3/investment-vehicles/${investmentVehicleId}`,
        method: 'GET',
        signal
    });
};
export const getGetInvestmentVehicleQueryKey = (investmentVehicleId)=>{
    return [
        `/api/v3/investment-vehicles/${investmentVehicleId}`
    ];
};
export const getGetInvestmentVehicleQueryOptions = (investmentVehicleId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleQueryKey(investmentVehicleId);
    const queryFn = ({ signal })=>getInvestmentVehicle(investmentVehicleId, signal);
    return {
        queryKey,
        queryFn,
        enabled: investmentVehicleId !== null && investmentVehicleId !== undefined,
        ...queryOptions
    };
};
export function useGetInvestmentVehicle(investmentVehicleId, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleQueryOptions(investmentVehicleId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetInvestmentVehicleSuspenseQueryOptions = (investmentVehicleId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleQueryKey(investmentVehicleId);
    const queryFn = ({ signal })=>getInvestmentVehicle(investmentVehicleId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetInvestmentVehicleSuspense(investmentVehicleId, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleSuspenseQueryOptions(investmentVehicleId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchInvestmentVehicle = (investmentVehicleId, patchInvestmentVehicleBody, signal)=>{
    return client({
        url: `/api/v3/investment-vehicles/${investmentVehicleId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchInvestmentVehicleBody,
        signal
    });
};
export const getPatchInvestmentVehicleMutationKey = ()=>[
        'patchInvestmentVehicle'
    ];
export const getPatchInvestmentVehicleMutationOptions = (options)=>{
    const mutationKey = getPatchInvestmentVehicleMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { investmentVehicleId, data } = props ?? {};
        return patchInvestmentVehicle(investmentVehicleId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchInvestmentVehicle = (options, queryClient)=>{
    return useMutation(getPatchInvestmentVehicleMutationOptions(options), queryClient);
};
export const getInvestmentVehicleAssets = (investmentVehicleId, signal)=>{
    return client({
        url: `/api/v3/investment-vehicles/${investmentVehicleId}/assets`,
        method: 'GET',
        signal
    });
};
export const getGetInvestmentVehicleAssetsQueryKey = (investmentVehicleId)=>{
    return [
        `/api/v3/investment-vehicles/${investmentVehicleId}/assets`
    ];
};
export const getGetInvestmentVehicleAssetsQueryOptions = (investmentVehicleId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleAssetsQueryKey(investmentVehicleId);
    const queryFn = ({ signal })=>getInvestmentVehicleAssets(investmentVehicleId, signal);
    return {
        queryKey,
        queryFn,
        enabled: investmentVehicleId !== null && investmentVehicleId !== undefined,
        ...queryOptions
    };
};
export function useGetInvestmentVehicleAssets(investmentVehicleId, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleAssetsQueryOptions(investmentVehicleId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetInvestmentVehicleAssetsSuspenseQueryOptions = (investmentVehicleId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleAssetsQueryKey(investmentVehicleId);
    const queryFn = ({ signal })=>getInvestmentVehicleAssets(investmentVehicleId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetInvestmentVehicleAssetsSuspense(investmentVehicleId, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleAssetsSuspenseQueryOptions(investmentVehicleId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getInvestmentVehicleManagedAccountFunds = (investmentVehicleId, params, signal)=>{
    return client({
        url: `/api/v3/investment-vehicles/${investmentVehicleId}/managed-account-funds`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetInvestmentVehicleManagedAccountFundsQueryKey = (investmentVehicleId, params)=>{
    return [
        `/api/v3/investment-vehicles/${investmentVehicleId}/managed-account-funds`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetInvestmentVehicleManagedAccountFundsQueryOptions = (investmentVehicleId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleManagedAccountFundsQueryKey(investmentVehicleId, params);
    const queryFn = ({ signal })=>getInvestmentVehicleManagedAccountFunds(investmentVehicleId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: investmentVehicleId !== null && investmentVehicleId !== undefined,
        ...queryOptions
    };
};
export function useGetInvestmentVehicleManagedAccountFunds(investmentVehicleId, params, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleManagedAccountFundsQueryOptions(investmentVehicleId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetInvestmentVehicleManagedAccountFundsSuspenseQueryOptions = (investmentVehicleId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleManagedAccountFundsQueryKey(investmentVehicleId, params);
    const queryFn = ({ signal })=>getInvestmentVehicleManagedAccountFunds(investmentVehicleId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetInvestmentVehicleManagedAccountFundsSuspense(investmentVehicleId, params, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleManagedAccountFundsSuspenseQueryOptions(investmentVehicleId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getInvestmentVehicleRtqPathCategories = (investmentVehicleId, params, signal)=>{
    return client({
        url: `/api/v3/investment-vehicles/${investmentVehicleId}/rtq-path-categories`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetInvestmentVehicleRtqPathCategoriesQueryKey = (investmentVehicleId, params)=>{
    return [
        `/api/v3/investment-vehicles/${investmentVehicleId}/rtq-path-categories`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetInvestmentVehicleRtqPathCategoriesQueryOptions = (investmentVehicleId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleRtqPathCategoriesQueryKey(investmentVehicleId, params);
    const queryFn = ({ signal })=>getInvestmentVehicleRtqPathCategories(investmentVehicleId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: investmentVehicleId !== null && investmentVehicleId !== undefined,
        ...queryOptions
    };
};
export function useGetInvestmentVehicleRtqPathCategories(investmentVehicleId, params, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleRtqPathCategoriesQueryOptions(investmentVehicleId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetInvestmentVehicleRtqPathCategoriesSuspenseQueryOptions = (investmentVehicleId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentVehicleRtqPathCategoriesQueryKey(investmentVehicleId, params);
    const queryFn = ({ signal })=>getInvestmentVehicleRtqPathCategories(investmentVehicleId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetInvestmentVehicleRtqPathCategoriesSuspense(investmentVehicleId, params, options, queryClient) {
    const queryOptions = getGetInvestmentVehicleRtqPathCategoriesSuspenseQueryOptions(investmentVehicleId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getIraCompanions = (params, signal)=>{
    return client({
        url: `/api/v3/ira-companions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetIraCompanionsQueryKey = (params)=>{
    return [
        `/api/v3/ira-companions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetIraCompanionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraCompanionsQueryKey(params);
    const queryFn = ({ signal })=>getIraCompanions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetIraCompanions(params, options, queryClient) {
    const queryOptions = getGetIraCompanionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIraCompanionsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraCompanionsQueryKey(params);
    const queryFn = ({ signal })=>getIraCompanions(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIraCompanionsSuspense(params, options, queryClient) {
    const queryOptions = getGetIraCompanionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postIraProspectPlanRef = (postIraProspectPlanRefBody, signal)=>{
    return client({
        url: `/api/v3/ira-prospect-plan-refs`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postIraProspectPlanRefBody,
        signal
    });
};
export const getPostIraProspectPlanRefMutationKey = ()=>[
        'postIraProspectPlanRef'
    ];
export const getPostIraProspectPlanRefMutationOptions = (options)=>{
    const mutationKey = getPostIraProspectPlanRefMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postIraProspectPlanRef(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIraProspectPlanRef = (options, queryClient)=>{
    return useMutation(getPostIraProspectPlanRefMutationOptions(options), queryClient);
};
export const getIraProspectPlanRef = (iraProspectPlanRefId, signal)=>{
    return client({
        url: `/api/v3/ira-prospect-plan-refs/${iraProspectPlanRefId}`,
        method: 'GET',
        signal
    });
};
export const getGetIraProspectPlanRefQueryKey = (iraProspectPlanRefId)=>{
    return [
        `/api/v3/ira-prospect-plan-refs/${iraProspectPlanRefId}`
    ];
};
export const getGetIraProspectPlanRefQueryOptions = (iraProspectPlanRefId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectPlanRefQueryKey(iraProspectPlanRefId);
    const queryFn = ({ signal })=>getIraProspectPlanRef(iraProspectPlanRefId, signal);
    return {
        queryKey,
        queryFn,
        enabled: iraProspectPlanRefId !== null && iraProspectPlanRefId !== undefined,
        ...queryOptions
    };
};
export function useGetIraProspectPlanRef(iraProspectPlanRefId, options, queryClient) {
    const queryOptions = getGetIraProspectPlanRefQueryOptions(iraProspectPlanRefId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIraProspectPlanRefSuspenseQueryOptions = (iraProspectPlanRefId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectPlanRefQueryKey(iraProspectPlanRefId);
    const queryFn = ({ signal })=>getIraProspectPlanRef(iraProspectPlanRefId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIraProspectPlanRefSuspense(iraProspectPlanRefId, options, queryClient) {
    const queryOptions = getGetIraProspectPlanRefSuspenseQueryOptions(iraProspectPlanRefId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchIraProspectPlanRef = (iraProspectPlanRefId, patchIraProspectPlanRefBody, signal)=>{
    return client({
        url: `/api/v3/ira-prospect-plan-refs/${iraProspectPlanRefId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchIraProspectPlanRefBody,
        signal
    });
};
export const getPatchIraProspectPlanRefMutationKey = ()=>[
        'patchIraProspectPlanRef'
    ];
export const getPatchIraProspectPlanRefMutationOptions = (options)=>{
    const mutationKey = getPatchIraProspectPlanRefMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { iraProspectPlanRefId, data } = props ?? {};
        return patchIraProspectPlanRef(iraProspectPlanRefId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchIraProspectPlanRef = (options, queryClient)=>{
    return useMutation(getPatchIraProspectPlanRefMutationOptions(options), queryClient);
};
export const getIraProspectApplicants = (params, signal)=>{
    return client({
        url: `/api/v3/ira-prospect/applications`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetIraProspectApplicantsQueryKey = (params)=>{
    return [
        `/api/v3/ira-prospect/applications`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetIraProspectApplicantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectApplicantsQueryKey(params);
    const queryFn = ({ signal })=>getIraProspectApplicants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetIraProspectApplicants(params, options, queryClient) {
    const queryOptions = getGetIraProspectApplicantsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIraProspectApplicantsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectApplicantsQueryKey(params);
    const queryFn = ({ signal })=>getIraProspectApplicants(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIraProspectApplicantsSuspense(params, options, queryClient) {
    const queryOptions = getGetIraProspectApplicantsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getIraProspect = (params, signal)=>{
    return client({
        url: `/api/v3/ira-prospects`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetIraProspectQueryKey = (params)=>{
    return [
        `/api/v3/ira-prospects`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetIraProspectQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectQueryKey(params);
    const queryFn = ({ signal })=>getIraProspect(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetIraProspect(params, options, queryClient) {
    const queryOptions = getGetIraProspectQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIraProspectSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectQueryKey(params);
    const queryFn = ({ signal })=>getIraProspect(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIraProspectSuspense(params, options, queryClient) {
    const queryOptions = getGetIraProspectSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getIraProspectDecisionAnalysisReport = (iraProspectId, signal)=>{
    return client({
        url: `/api/v3/ira-prospects/${iraProspectId}/decision-analysis-report`,
        method: 'GET',
        signal
    });
};
export const getGetIraProspectDecisionAnalysisReportQueryKey = (iraProspectId)=>{
    return [
        `/api/v3/ira-prospects/${iraProspectId}/decision-analysis-report`
    ];
};
export const getGetIraProspectDecisionAnalysisReportQueryOptions = (iraProspectId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectDecisionAnalysisReportQueryKey(iraProspectId);
    const queryFn = ({ signal })=>getIraProspectDecisionAnalysisReport(iraProspectId, signal);
    return {
        queryKey,
        queryFn,
        enabled: iraProspectId !== null && iraProspectId !== undefined,
        ...queryOptions
    };
};
export function useGetIraProspectDecisionAnalysisReport(iraProspectId, options, queryClient) {
    const queryOptions = getGetIraProspectDecisionAnalysisReportQueryOptions(iraProspectId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIraProspectDecisionAnalysisReportSuspenseQueryOptions = (iraProspectId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraProspectDecisionAnalysisReportQueryKey(iraProspectId);
    const queryFn = ({ signal })=>getIraProspectDecisionAnalysisReport(iraProspectId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIraProspectDecisionAnalysisReportSuspense(iraProspectId, options, queryClient) {
    const queryOptions = getGetIraProspectDecisionAnalysisReportSuspenseQueryOptions(iraProspectId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const createSubmission = (postIraTransactionSubmissionBody, signal)=>{
    return client({
        url: `/api/v3/ira-transactions/submission`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postIraTransactionSubmissionBody,
        signal
    });
};
export const getCreateSubmissionMutationKey = ()=>[
        'createSubmission'
    ];
export const getCreateSubmissionMutationOptions = (options)=>{
    const mutationKey = getCreateSubmissionMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return createSubmission(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useCreateSubmission = (options, queryClient)=>{
    return useMutation(getCreateSubmissionMutationOptions(options), queryClient);
};
export const getIraTransactionsByRecordkeeperOrganizationId = (recordkeeperOrganizationId, signal)=>{
    return client({
        url: `/api/v3/ira-transactions/${recordkeeperOrganizationId}`,
        method: 'GET',
        signal
    });
};
export const getGetIraTransactionsByRecordkeeperOrganizationIdQueryKey = (recordkeeperOrganizationId)=>{
    return [
        `/api/v3/ira-transactions/${recordkeeperOrganizationId}`
    ];
};
export const getGetIraTransactionsByRecordkeeperOrganizationIdQueryOptions = (recordkeeperOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraTransactionsByRecordkeeperOrganizationIdQueryKey(recordkeeperOrganizationId);
    const queryFn = ({ signal })=>getIraTransactionsByRecordkeeperOrganizationId(recordkeeperOrganizationId, signal);
    return {
        queryKey,
        queryFn,
        enabled: recordkeeperOrganizationId !== null && recordkeeperOrganizationId !== undefined,
        ...queryOptions
    };
};
export function useGetIraTransactionsByRecordkeeperOrganizationId(recordkeeperOrganizationId, options, queryClient) {
    const queryOptions = getGetIraTransactionsByRecordkeeperOrganizationIdQueryOptions(recordkeeperOrganizationId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIraTransactionsByRecordkeeperOrganizationIdSuspenseQueryOptions = (recordkeeperOrganizationId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIraTransactionsByRecordkeeperOrganizationIdQueryKey(recordkeeperOrganizationId);
    const queryFn = ({ signal })=>getIraTransactionsByRecordkeeperOrganizationId(recordkeeperOrganizationId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIraTransactionsByRecordkeeperOrganizationIdSuspense(recordkeeperOrganizationId, options, queryClient) {
    const queryOptions = getGetIraTransactionsByRecordkeeperOrganizationIdSuspenseQueryOptions(recordkeeperOrganizationId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const updateIraTransactionsStatuses = (recordkeeperOrganizationId, updateIraTransactionsStatusesBody, signal)=>{
    return client({
        url: `/api/v3/ira-transactions/${recordkeeperOrganizationId}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateIraTransactionsStatusesBody,
        signal
    });
};
export const getUpdateIraTransactionsStatusesMutationKey = ()=>[
        'updateIraTransactionsStatuses'
    ];
export const getUpdateIraTransactionsStatusesMutationOptions = (options)=>{
    const mutationKey = getUpdateIraTransactionsStatusesMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { recordkeeperOrganizationId, data } = props ?? {};
        return updateIraTransactionsStatuses(recordkeeperOrganizationId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useUpdateIraTransactionsStatuses = (options, queryClient)=>{
    return useMutation(getUpdateIraTransactionsStatusesMutationOptions(options), queryClient);
};
export const patchIve = (iveId, patchIveBody, signal)=>{
    return client({
        url: `/api/v3/ive/${iveId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchIveBody,
        signal
    });
};
export const getPatchIveMutationKey = ()=>[
        'patchIve'
    ];
export const getPatchIveMutationOptions = (options)=>{
    const mutationKey = getPatchIveMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { iveId, data } = props ?? {};
        return patchIve(iveId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchIve = (options, queryClient)=>{
    return useMutation(getPatchIveMutationOptions(options), queryClient);
};
export const getIveAllocations = (iveId, signal)=>{
    return client({
        url: `/api/v3/ive/${iveId}/allocations`,
        method: 'GET',
        signal
    });
};
export const getGetIveAllocationsQueryKey = (iveId)=>{
    return [
        `/api/v3/ive/${iveId}/allocations`
    ];
};
export const getGetIveAllocationsQueryOptions = (iveId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIveAllocationsQueryKey(iveId);
    const queryFn = ({ signal })=>getIveAllocations(iveId, signal);
    return {
        queryKey,
        queryFn,
        enabled: iveId !== null && iveId !== undefined,
        ...queryOptions
    };
};
export function useGetIveAllocations(iveId, options, queryClient) {
    const queryOptions = getGetIveAllocationsQueryOptions(iveId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIveAllocationsSuspenseQueryOptions = (iveId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIveAllocationsQueryKey(iveId);
    const queryFn = ({ signal })=>getIveAllocations(iveId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIveAllocationsSuspense(iveId, options, queryClient) {
    const queryOptions = getGetIveAllocationsSuspenseQueryOptions(iveId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchIveAllocations = (iveId, patchIveAllocationsBody, signal)=>{
    return client({
        url: `/api/v3/ive/${iveId}/allocations`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchIveAllocationsBody,
        signal
    });
};
export const getPatchIveAllocationsMutationKey = ()=>[
        'patchIveAllocations'
    ];
export const getPatchIveAllocationsMutationOptions = (options)=>{
    const mutationKey = getPatchIveAllocationsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { iveId, data } = props ?? {};
        return patchIveAllocations(iveId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchIveAllocations = (options, queryClient)=>{
    return useMutation(getPatchIveAllocationsMutationOptions(options), queryClient);
};
export const getIveBeneficiaries = (iveId, signal)=>{
    return client({
        url: `/api/v3/ive/${iveId}/beneficiaries`,
        method: 'GET',
        signal
    });
};
export const getGetIveBeneficiariesQueryKey = (iveId)=>{
    return [
        `/api/v3/ive/${iveId}/beneficiaries`
    ];
};
export const getGetIveBeneficiariesQueryOptions = (iveId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIveBeneficiariesQueryKey(iveId);
    const queryFn = ({ signal })=>getIveBeneficiaries(iveId, signal);
    return {
        queryKey,
        queryFn,
        enabled: iveId !== null && iveId !== undefined,
        ...queryOptions
    };
};
export function useGetIveBeneficiaries(iveId, options, queryClient) {
    const queryOptions = getGetIveBeneficiariesQueryOptions(iveId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIveBeneficiariesSuspenseQueryOptions = (iveId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIveBeneficiariesQueryKey(iveId);
    const queryFn = ({ signal })=>getIveBeneficiaries(iveId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIveBeneficiariesSuspense(iveId, options, queryClient) {
    const queryOptions = getGetIveBeneficiariesSuspenseQueryOptions(iveId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const searchManagedAccountFees = (params, signal)=>{
    return client({
        url: `/api/v3/managed-account-fees`,
        method: 'GET',
        params,
        signal
    });
};
export const getSearchManagedAccountFeesQueryKey = (params)=>{
    return [
        `/api/v3/managed-account-fees`,
        ...params ? [
            params
        ] : []
    ];
};
export const getSearchManagedAccountFeesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getSearchManagedAccountFeesQueryKey(params);
    const queryFn = ({ signal })=>searchManagedAccountFees(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useSearchManagedAccountFees(params, options, queryClient) {
    const queryOptions = getSearchManagedAccountFeesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getSearchManagedAccountFeesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getSearchManagedAccountFeesQueryKey(params);
    const queryFn = ({ signal })=>searchManagedAccountFees(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useSearchManagedAccountFeesSuspense(params, options, queryClient) {
    const queryOptions = getSearchManagedAccountFeesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getExportManagedAccountFees = (params, signal)=>{
    return client({
        url: `/api/v3/managed-account-fees/export`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetExportManagedAccountFeesQueryKey = (params)=>{
    return [
        `/api/v3/managed-account-fees/export`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetExportManagedAccountFeesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportManagedAccountFeesQueryKey(params);
    const queryFn = ({ signal })=>getExportManagedAccountFees(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetExportManagedAccountFees(params, options, queryClient) {
    const queryOptions = getGetExportManagedAccountFeesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetExportManagedAccountFeesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetExportManagedAccountFeesQueryKey(params);
    const queryFn = ({ signal })=>getExportManagedAccountFees(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetExportManagedAccountFeesSuspense(params, options, queryClient) {
    const queryOptions = getGetExportManagedAccountFeesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteManagedAccountFee = (managedAccountFeeId, deleteManagedAccountFeeBody, signal)=>{
    return client({
        url: `/api/v3/managed-account-fees/${managedAccountFeeId}`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deleteManagedAccountFeeBody,
        signal
    });
};
export const getDeleteManagedAccountFeeMutationKey = ()=>[
        'deleteManagedAccountFee'
    ];
export const getDeleteManagedAccountFeeMutationOptions = (options)=>{
    const mutationKey = getDeleteManagedAccountFeeMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountFeeId, data } = props ?? {};
        return deleteManagedAccountFee(managedAccountFeeId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountFee = (options, queryClient)=>{
    return useMutation(getDeleteManagedAccountFeeMutationOptions(options), queryClient);
};
export const deleteManagedAccountProviderById = (managedAccountProviderId, signal)=>{
    return client({
        url: `/api/v3/managed-account-providers/${managedAccountProviderId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteManagedAccountProviderByIdMutationKey = ()=>[
        'deleteManagedAccountProviderById'
    ];
export const getDeleteManagedAccountProviderByIdMutationOptions = (options)=>{
    const mutationKey = getDeleteManagedAccountProviderByIdMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountProviderId } = props ?? {};
        return deleteManagedAccountProviderById(managedAccountProviderId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountProviderById = (options, queryClient)=>{
    return useMutation(getDeleteManagedAccountProviderByIdMutationOptions(options), queryClient);
};
export const getManagedAccountProviderById = (managedAccountProviderId, signal)=>{
    return client({
        url: `/api/v3/managed-account-providers/${managedAccountProviderId}`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountProviderByIdQueryKey = (managedAccountProviderId)=>{
    return [
        `/api/v3/managed-account-providers/${managedAccountProviderId}`
    ];
};
export const getGetManagedAccountProviderByIdQueryOptions = (managedAccountProviderId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountProviderByIdQueryKey(managedAccountProviderId);
    const queryFn = ({ signal })=>getManagedAccountProviderById(managedAccountProviderId, signal);
    return {
        queryKey,
        queryFn,
        enabled: managedAccountProviderId !== null && managedAccountProviderId !== undefined,
        ...queryOptions
    };
};
export function useGetManagedAccountProviderById(managedAccountProviderId, options, queryClient) {
    const queryOptions = getGetManagedAccountProviderByIdQueryOptions(managedAccountProviderId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountProviderByIdSuspenseQueryOptions = (managedAccountProviderId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountProviderByIdQueryKey(managedAccountProviderId);
    const queryFn = ({ signal })=>getManagedAccountProviderById(managedAccountProviderId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountProviderByIdSuspense(managedAccountProviderId, options, queryClient) {
    const queryOptions = getGetManagedAccountProviderByIdSuspenseQueryOptions(managedAccountProviderId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchManagedAccountProviderById = (managedAccountProviderId, updateManagedAccountProviderBody, signal)=>{
    return client({
        url: `/api/v3/managed-account-providers/${managedAccountProviderId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateManagedAccountProviderBody,
        signal
    });
};
export const getPatchManagedAccountProviderByIdMutationKey = ()=>[
        'patchManagedAccountProviderById'
    ];
export const getPatchManagedAccountProviderByIdMutationOptions = (options)=>{
    const mutationKey = getPatchManagedAccountProviderByIdMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountProviderId, data } = props ?? {};
        return patchManagedAccountProviderById(managedAccountProviderId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchManagedAccountProviderById = (options, queryClient)=>{
    return useMutation(getPatchManagedAccountProviderByIdMutationOptions(options), queryClient);
};
export const getManagedAccountProviderPortfolios = (managedAccountProviderId, signal)=>{
    return client({
        url: `/api/v3/managed-account-providers/${managedAccountProviderId}/portfolios`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountProviderPortfoliosQueryKey = (managedAccountProviderId)=>{
    return [
        `/api/v3/managed-account-providers/${managedAccountProviderId}/portfolios`
    ];
};
export const getGetManagedAccountProviderPortfoliosQueryOptions = (managedAccountProviderId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountProviderPortfoliosQueryKey(managedAccountProviderId);
    const queryFn = ({ signal })=>getManagedAccountProviderPortfolios(managedAccountProviderId, signal);
    return {
        queryKey,
        queryFn,
        enabled: managedAccountProviderId !== null && managedAccountProviderId !== undefined,
        ...queryOptions
    };
};
export function useGetManagedAccountProviderPortfolios(managedAccountProviderId, options, queryClient) {
    const queryOptions = getGetManagedAccountProviderPortfoliosQueryOptions(managedAccountProviderId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountProviderPortfoliosSuspenseQueryOptions = (managedAccountProviderId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountProviderPortfoliosQueryKey(managedAccountProviderId);
    const queryFn = ({ signal })=>getManagedAccountProviderPortfolios(managedAccountProviderId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountProviderPortfoliosSuspense(managedAccountProviderId, options, queryClient) {
    const queryOptions = getGetManagedAccountProviderPortfoliosSuspenseQueryOptions(managedAccountProviderId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postManagedAccountProviderPortfolio = (managedAccountProviderId, createManagedAccountPortfolioBody, signal)=>{
    return client({
        url: `/api/v3/managed-account-providers/${managedAccountProviderId}/portfolios`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: createManagedAccountPortfolioBody,
        signal
    });
};
export const getPostManagedAccountProviderPortfolioMutationKey = ()=>[
        'postManagedAccountProviderPortfolio'
    ];
export const getPostManagedAccountProviderPortfolioMutationOptions = (options)=>{
    const mutationKey = getPostManagedAccountProviderPortfolioMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountProviderId, data } = props ?? {};
        return postManagedAccountProviderPortfolio(managedAccountProviderId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostManagedAccountProviderPortfolio = (options, queryClient)=>{
    return useMutation(getPostManagedAccountProviderPortfolioMutationOptions(options), queryClient);
};
export const deleteManagedAccountProviderPortfolio = (managedAccountProviderId, managedAccountPortfolioId, signal)=>{
    return client({
        url: `/api/v3/managed-account-providers/${managedAccountProviderId}/portfolios/${managedAccountPortfolioId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteManagedAccountProviderPortfolioMutationKey = ()=>[
        'deleteManagedAccountProviderPortfolio'
    ];
export const getDeleteManagedAccountProviderPortfolioMutationOptions = (options)=>{
    const mutationKey = getDeleteManagedAccountProviderPortfolioMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountProviderId, managedAccountPortfolioId } = props ?? {};
        return deleteManagedAccountProviderPortfolio(managedAccountProviderId, managedAccountPortfolioId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountProviderPortfolio = (options, queryClient)=>{
    return useMutation(getDeleteManagedAccountProviderPortfolioMutationOptions(options), queryClient);
};
export const patchManagedAccountProviderPortfolio = (managedAccountProviderId, managedAccountPortfolioId, updateManagedAccountPortfolioBody, signal)=>{
    return client({
        url: `/api/v3/managed-account-providers/${managedAccountProviderId}/portfolios/${managedAccountPortfolioId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updateManagedAccountPortfolioBody,
        signal
    });
};
export const getPatchManagedAccountProviderPortfolioMutationKey = ()=>[
        'patchManagedAccountProviderPortfolio'
    ];
export const getPatchManagedAccountProviderPortfolioMutationOptions = (options)=>{
    const mutationKey = getPatchManagedAccountProviderPortfolioMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountProviderId, managedAccountPortfolioId, data } = props ?? {};
        return patchManagedAccountProviderPortfolio(managedAccountProviderId, managedAccountPortfolioId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchManagedAccountProviderPortfolio = (options, queryClient)=>{
    return useMutation(getPatchManagedAccountProviderPortfolioMutationOptions(options), queryClient);
};
export const getManagedAccountParticipant = (params, signal)=>{
    return client({
        url: `/api/v3/managed-accounts-participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetManagedAccountParticipantQueryKey = (params)=>{
    return [
        `/api/v3/managed-accounts-participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetManagedAccountParticipantQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountParticipantQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccountParticipant(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetManagedAccountParticipant(params, options, queryClient) {
    const queryOptions = getGetManagedAccountParticipantQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountParticipantSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountParticipantQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccountParticipant(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountParticipantSuspense(params, options, queryClient) {
    const queryOptions = getGetManagedAccountParticipantSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const updateManagedAccountParticipant = (patchManagedAccountParticipantBody, signal)=>{
    return client({
        url: `/api/v3/managed-accounts-participants`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchManagedAccountParticipantBody,
        signal
    });
};
export const getUpdateManagedAccountParticipantMutationKey = ()=>[
        'updateManagedAccountParticipant'
    ];
export const getUpdateManagedAccountParticipantMutationOptions = (options)=>{
    const mutationKey = getUpdateManagedAccountParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return updateManagedAccountParticipant(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useUpdateManagedAccountParticipant = (options, queryClient)=>{
    return useMutation(getUpdateManagedAccountParticipantMutationOptions(options), queryClient);
};
export const getManagedAccountProvider = (params, signal)=>{
    return client({
        url: `/api/v3/managed-accounts-providers`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetManagedAccountProviderQueryKey = (params)=>{
    return [
        `/api/v3/managed-accounts-providers`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetManagedAccountProviderQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountProviderQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccountProvider(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetManagedAccountProvider(params, options, queryClient) {
    const queryOptions = getGetManagedAccountProviderQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountProviderSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountProviderQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccountProvider(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountProviderSuspense(params, options, queryClient) {
    const queryOptions = getGetManagedAccountProviderSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postManifestTransferIn = (postManifestTransferInBody, signal)=>{
    return client({
        url: `/api/v3/manifest/transfer-in`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postManifestTransferInBody,
        signal
    });
};
export const getPostManifestTransferInMutationKey = ()=>[
        'postManifestTransferIn'
    ];
export const getPostManifestTransferInMutationOptions = (options)=>{
    const mutationKey = getPostManifestTransferInMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postManifestTransferIn(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostManifestTransferIn = (options, queryClient)=>{
    return useMutation(getPostManifestTransferInMutationOptions(options), queryClient);
};
export const getManifestUserTransfers = (userId, signal)=>{
    return client({
        url: `/api/v3/manifest/users/${userId}/transfers`,
        method: 'GET',
        signal
    });
};
export const getGetManifestUserTransfersQueryKey = (userId)=>{
    return [
        `/api/v3/manifest/users/${userId}/transfers`
    ];
};
export const getGetManifestUserTransfersQueryOptions = (userId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManifestUserTransfersQueryKey(userId);
    const queryFn = ({ signal })=>getManifestUserTransfers(userId, signal);
    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions
    };
};
export function useGetManifestUserTransfers(userId, options, queryClient) {
    const queryOptions = getGetManifestUserTransfersQueryOptions(userId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManifestUserTransfersSuspenseQueryOptions = (userId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManifestUserTransfersQueryKey(userId);
    const queryFn = ({ signal })=>getManifestUserTransfers(userId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManifestUserTransfersSuspense(userId, options, queryClient) {
    const queryOptions = getGetManifestUserTransfersSuspenseQueryOptions(userId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getManagedAccountMethodologies = (params, signal)=>{
    return client({
        url: `/api/v3/map-methodologies`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetManagedAccountMethodologiesQueryKey = (params)=>{
    return [
        `/api/v3/map-methodologies`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetManagedAccountMethodologiesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologiesQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccountMethodologies(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetManagedAccountMethodologies(params, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologiesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountMethodologiesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologiesQueryKey(params);
    const queryFn = ({ signal })=>getManagedAccountMethodologies(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountMethodologiesSuspense(params, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologiesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postManagedAccountMethodology = (postManagedAccountMethodologyBody, signal)=>{
    return client({
        url: `/api/v3/map-methodologies`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postManagedAccountMethodologyBody,
        signal
    });
};
export const getPostManagedAccountMethodologyMutationKey = ()=>[
        'postManagedAccountMethodology'
    ];
export const getPostManagedAccountMethodologyMutationOptions = (options)=>{
    const mutationKey = getPostManagedAccountMethodologyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postManagedAccountMethodology(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostManagedAccountMethodology = (options, queryClient)=>{
    return useMutation(getPostManagedAccountMethodologyMutationOptions(options), queryClient);
};
export const deleteManagedAccountMethodologyById = (managedAccountMethodologyId, signal)=>{
    return client({
        url: `/api/v3/map-methodologies/${managedAccountMethodologyId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteManagedAccountMethodologyByIdMutationKey = ()=>[
        'deleteManagedAccountMethodologyById'
    ];
export const getDeleteManagedAccountMethodologyByIdMutationOptions = (options)=>{
    const mutationKey = getDeleteManagedAccountMethodologyByIdMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountMethodologyId } = props ?? {};
        return deleteManagedAccountMethodologyById(managedAccountMethodologyId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountMethodologyById = (options, queryClient)=>{
    return useMutation(getDeleteManagedAccountMethodologyByIdMutationOptions(options), queryClient);
};
export const getManagedAccountMethodologyById = (managedAccountMethodologyId, signal)=>{
    return client({
        url: `/api/v3/map-methodologies/${managedAccountMethodologyId}`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountMethodologyByIdQueryKey = (managedAccountMethodologyId)=>{
    return [
        `/api/v3/map-methodologies/${managedAccountMethodologyId}`
    ];
};
export const getGetManagedAccountMethodologyByIdQueryOptions = (managedAccountMethodologyId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologyByIdQueryKey(managedAccountMethodologyId);
    const queryFn = ({ signal })=>getManagedAccountMethodologyById(managedAccountMethodologyId, signal);
    return {
        queryKey,
        queryFn,
        enabled: managedAccountMethodologyId !== null && managedAccountMethodologyId !== undefined,
        ...queryOptions
    };
};
export function useGetManagedAccountMethodologyById(managedAccountMethodologyId, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologyByIdQueryOptions(managedAccountMethodologyId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountMethodologyByIdSuspenseQueryOptions = (managedAccountMethodologyId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologyByIdQueryKey(managedAccountMethodologyId);
    const queryFn = ({ signal })=>getManagedAccountMethodologyById(managedAccountMethodologyId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountMethodologyByIdSuspense(managedAccountMethodologyId, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologyByIdSuspenseQueryOptions(managedAccountMethodologyId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchManagedAccountMethodologyById = (managedAccountMethodologyId, patchManagedAccountMethodologyBody, signal)=>{
    return client({
        url: `/api/v3/map-methodologies/${managedAccountMethodologyId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchManagedAccountMethodologyBody,
        signal
    });
};
export const getPatchManagedAccountMethodologyByIdMutationKey = ()=>[
        'patchManagedAccountMethodologyById'
    ];
export const getPatchManagedAccountMethodologyByIdMutationOptions = (options)=>{
    const mutationKey = getPatchManagedAccountMethodologyByIdMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountMethodologyId, data } = props ?? {};
        return patchManagedAccountMethodologyById(managedAccountMethodologyId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchManagedAccountMethodologyById = (options, queryClient)=>{
    return useMutation(getPatchManagedAccountMethodologyByIdMutationOptions(options), queryClient);
};
export const getManagedAccountMethodologyAdvisoryOrganizations = (managedAccountMethodologyId, signal)=>{
    return client({
        url: `/api/v3/map-methodologies/${managedAccountMethodologyId}/advisory-organizations`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountMethodologyAdvisoryOrganizationsQueryKey = (managedAccountMethodologyId)=>{
    return [
        `/api/v3/map-methodologies/${managedAccountMethodologyId}/advisory-organizations`
    ];
};
export const getGetManagedAccountMethodologyAdvisoryOrganizationsQueryOptions = (managedAccountMethodologyId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologyAdvisoryOrganizationsQueryKey(managedAccountMethodologyId);
    const queryFn = ({ signal })=>getManagedAccountMethodologyAdvisoryOrganizations(managedAccountMethodologyId, signal);
    return {
        queryKey,
        queryFn,
        enabled: managedAccountMethodologyId !== null && managedAccountMethodologyId !== undefined,
        ...queryOptions
    };
};
export function useGetManagedAccountMethodologyAdvisoryOrganizations(managedAccountMethodologyId, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologyAdvisoryOrganizationsQueryOptions(managedAccountMethodologyId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountMethodologyAdvisoryOrganizationsSuspenseQueryOptions = (managedAccountMethodologyId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologyAdvisoryOrganizationsQueryKey(managedAccountMethodologyId);
    const queryFn = ({ signal })=>getManagedAccountMethodologyAdvisoryOrganizations(managedAccountMethodologyId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountMethodologyAdvisoryOrganizationsSuspense(managedAccountMethodologyId, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologyAdvisoryOrganizationsSuspenseQueryOptions(managedAccountMethodologyId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const deleteManagedAccountMethodologyAdvisoryOrganization = (managedAccountMethodologyId, advisoryOrganizationId, signal)=>{
    return client({
        url: `/api/v3/map-methodologies/${managedAccountMethodologyId}/advisory-organizations/${advisoryOrganizationId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteManagedAccountMethodologyAdvisoryOrganizationMutationKey = ()=>[
        'deleteManagedAccountMethodologyAdvisoryOrganization'
    ];
export const getDeleteManagedAccountMethodologyAdvisoryOrganizationMutationOptions = (options)=>{
    const mutationKey = getDeleteManagedAccountMethodologyAdvisoryOrganizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { managedAccountMethodologyId, advisoryOrganizationId } = props ?? {};
        return deleteManagedAccountMethodologyAdvisoryOrganization(managedAccountMethodologyId, advisoryOrganizationId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountMethodologyAdvisoryOrganization = (options, queryClient)=>{
    return useMutation(getDeleteManagedAccountMethodologyAdvisoryOrganizationMutationOptions(options), queryClient);
};
export const getManagedAccountMethodologyProviders = (managedAccountMethodologyId, params, signal)=>{
    return client({
        url: `/api/v3/map-methodologies/${managedAccountMethodologyId}/managed-account-providers`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetManagedAccountMethodologyProvidersQueryKey = (managedAccountMethodologyId, params)=>{
    return [
        `/api/v3/map-methodologies/${managedAccountMethodologyId}/managed-account-providers`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetManagedAccountMethodologyProvidersQueryOptions = (managedAccountMethodologyId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologyProvidersQueryKey(managedAccountMethodologyId, params);
    const queryFn = ({ signal })=>getManagedAccountMethodologyProviders(managedAccountMethodologyId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: managedAccountMethodologyId !== null && managedAccountMethodologyId !== undefined,
        ...queryOptions
    };
};
export function useGetManagedAccountMethodologyProviders(managedAccountMethodologyId, params, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologyProvidersQueryOptions(managedAccountMethodologyId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetManagedAccountMethodologyProvidersSuspenseQueryOptions = (managedAccountMethodologyId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountMethodologyProvidersQueryKey(managedAccountMethodologyId, params);
    const queryFn = ({ signal })=>getManagedAccountMethodologyProviders(managedAccountMethodologyId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetManagedAccountMethodologyProvidersSuspense(managedAccountMethodologyId, params, options, queryClient) {
    const queryOptions = getGetManagedAccountMethodologyProvidersSuspenseQueryOptions(managedAccountMethodologyId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getMapProviders = (params, signal)=>{
    return client({
        url: `/api/v3/map-providers`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetMapProvidersQueryKey = (params)=>{
    return [
        `/api/v3/map-providers`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetMapProvidersQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapProvidersQueryKey(params);
    const queryFn = ({ signal })=>getMapProviders(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetMapProviders(params, options, queryClient) {
    const queryOptions = getGetMapProvidersQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetMapProvidersSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMapProvidersQueryKey(params);
    const queryFn = ({ signal })=>getMapProviders(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetMapProvidersSuspense(params, options, queryClient) {
    const queryOptions = getGetMapProvidersSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
/**
 * Checks connectivity from the API service to its backing services (database and cache). Authenticate with your `X-API-Key` header. Returns `200 OK` with `status: "up"` when every backing service is reachable, and `503 Service Unavailable` with `status: "down"` when any is not. Use this endpoint to verify the health of iJoin services before or during an integration rollout.
 * @summary Service Health Check
 */ export const getMarketplaceHealth = (signal)=>{
    return client({
        url: `/api/v3/marketplace/health`,
        method: 'GET',
        signal
    });
};
export const getGetMarketplaceHealthQueryKey = ()=>{
    return [
        `/api/v3/marketplace/health`
    ];
};
export const getGetMarketplaceHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMarketplaceHealthQueryKey();
    const queryFn = ({ signal })=>getMarketplaceHealth(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
/**
 * @summary Service Health Check
 */ export function useGetMarketplaceHealth(options, queryClient) {
    const queryOptions = getGetMarketplaceHealthQueryOptions(options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetMarketplaceHealthSuspenseQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMarketplaceHealthQueryKey();
    const queryFn = ({ signal })=>getMarketplaceHealth(signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
/**
 * @summary Service Health Check
 */ export function useGetMarketplaceHealthSuspense(options, queryClient) {
    const queryOptions = getGetMarketplaceHealthSuspenseQueryOptions(options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postExternalMetricsMigration = (postExternalMetricsMigrationBody, signal)=>{
    return client({
        url: `/api/v3/metrics/external-migrations`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postExternalMetricsMigrationBody,
        signal
    });
};
export const getPostExternalMetricsMigrationMutationKey = ()=>[
        'postExternalMetricsMigration'
    ];
export const getPostExternalMetricsMigrationMutationOptions = (options)=>{
    const mutationKey = getPostExternalMetricsMigrationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postExternalMetricsMigration(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostExternalMetricsMigration = (options, queryClient)=>{
    return useMutation(getPostExternalMetricsMigrationMutationOptions(options), queryClient);
};
export const postComplete = (completeOnboardingBody, signal)=>{
    return client({
        url: `/api/v3/onboarding/complete`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: completeOnboardingBody,
        signal
    });
};
export const getPostCompleteMutationKey = ()=>[
        'postComplete'
    ];
export const getPostCompleteMutationOptions = (options)=>{
    const mutationKey = getPostCompleteMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postComplete(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostComplete = (options, queryClient)=>{
    return useMutation(getPostCompleteMutationOptions(options), queryClient);
};
export const postMfaGenerate = (completeOnboardingBody, signal)=>{
    return client({
        url: `/api/v3/onboarding/mfa/generate`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: completeOnboardingBody,
        signal
    });
};
export const getPostMfaGenerateMutationKey = ()=>[
        'postMfaGenerate'
    ];
export const getPostMfaGenerateMutationOptions = (options)=>{
    const mutationKey = getPostMfaGenerateMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postMfaGenerate(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMfaGenerate = (options, queryClient)=>{
    return useMutation(getPostMfaGenerateMutationOptions(options), queryClient);
};
export const patchMfaVerify = (onboardingVerifyMfaBody, signal)=>{
    return client({
        url: `/api/v3/onboarding/mfa/verify`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: onboardingVerifyMfaBody,
        signal
    });
};
export const getPatchMfaVerifyMutationKey = ()=>[
        'patchMfaVerify'
    ];
export const getPatchMfaVerifyMutationOptions = (options)=>{
    const mutationKey = getPatchMfaVerifyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchMfaVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchMfaVerify = (options, queryClient)=>{
    return useMutation(getPatchMfaVerifyMutationOptions(options), queryClient);
};
export const postSetPassword = (setPasswordBody, signal)=>{
    return client({
        url: `/api/v3/onboarding/set-password`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: setPasswordBody,
        signal
    });
};
export const getPostSetPasswordMutationKey = ()=>[
        'postSetPassword'
    ];
export const getPostSetPasswordMutationOptions = (options)=>{
    const mutationKey = getPostSetPasswordMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSetPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSetPassword = (options, queryClient)=>{
    return useMutation(getPostSetPasswordMutationOptions(options), queryClient);
};
export const getValidateToken = (params, signal)=>{
    return client({
        url: `/api/v3/onboarding/validate`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetValidateTokenQueryKey = (params)=>{
    return [
        `/api/v3/onboarding/validate`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetValidateTokenQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetValidateTokenQueryKey(params);
    const queryFn = ({ signal })=>getValidateToken(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetValidateToken(params, options, queryClient) {
    const queryOptions = getGetValidateTokenQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetValidateTokenSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetValidateTokenQueryKey(params);
    const queryFn = ({ signal })=>getValidateToken(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetValidateTokenSuspense(params, options, queryClient) {
    const queryOptions = getGetValidateTokenSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getOptOutStatuses = (params, signal)=>{
    return client({
        url: `/api/v3/opt-out-statuses`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetOptOutStatusesQueryKey = (params)=>{
    return [
        `/api/v3/opt-out-statuses`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetOptOutStatusesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutStatusesQueryKey(params);
    const queryFn = ({ signal })=>getOptOutStatuses(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetOptOutStatuses(params, options, queryClient) {
    const queryOptions = getGetOptOutStatusesQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetOptOutStatusesSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOptOutStatusesQueryKey(params);
    const queryFn = ({ signal })=>getOptOutStatuses(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetOptOutStatusesSuspense(params, options, queryClient) {
    const queryOptions = getGetOptOutStatusesSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchOptOutStatus = (optOutStatusId, patchOptOutStatusBody, signal)=>{
    return client({
        url: `/api/v3/opt-out-statuses/${optOutStatusId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchOptOutStatusBody,
        signal
    });
};
export const getPatchOptOutStatusMutationKey = ()=>[
        'patchOptOutStatus'
    ];
export const getPatchOptOutStatusMutationOptions = (options)=>{
    const mutationKey = getPatchOptOutStatusMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { optOutStatusId, data } = props ?? {};
        return patchOptOutStatus(optOutStatusId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchOptOutStatus = (options, queryClient)=>{
    return useMutation(getPatchOptOutStatusMutationOptions(options), queryClient);
};
export const postOutsideAccount = (postOutsideAccountReq, signal)=>{
    return client({
        url: `/api/v3/outside-accounts`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postOutsideAccountReq,
        signal
    });
};
export const getPostOutsideAccountMutationKey = ()=>[
        'postOutsideAccount'
    ];
export const getPostOutsideAccountMutationOptions = (options)=>{
    const mutationKey = getPostOutsideAccountMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postOutsideAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostOutsideAccount = (options, queryClient)=>{
    return useMutation(getPostOutsideAccountMutationOptions(options), queryClient);
};
export const deleteOutsideAccount = (id, signal)=>{
    return client({
        url: `/api/v3/outside-accounts/${id}`,
        method: 'DELETE',
        signal
    });
};
export const getDeleteOutsideAccountMutationKey = ()=>[
        'deleteOutsideAccount'
    ];
export const getDeleteOutsideAccountMutationOptions = (options)=>{
    const mutationKey = getDeleteOutsideAccountMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { id } = props ?? {};
        return deleteOutsideAccount(id);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteOutsideAccount = (options, queryClient)=>{
    return useMutation(getDeleteOutsideAccountMutationOptions(options), queryClient);
};
export const getOutsideAccountById = (id, signal)=>{
    return client({
        url: `/api/v3/outside-accounts/${id}`,
        method: 'GET',
        signal
    });
};
export const getGetOutsideAccountByIdQueryKey = (id)=>{
    return [
        `/api/v3/outside-accounts/${id}`
    ];
};
export const getGetOutsideAccountByIdQueryOptions = (id, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOutsideAccountByIdQueryKey(id);
    const queryFn = ({ signal })=>getOutsideAccountById(id, signal);
    return {
        queryKey,
        queryFn,
        enabled: id !== null && id !== undefined,
        ...queryOptions
    };
};
export function useGetOutsideAccountById(id, options, queryClient) {
    const queryOptions = getGetOutsideAccountByIdQueryOptions(id, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetOutsideAccountByIdSuspenseQueryOptions = (id, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOutsideAccountByIdQueryKey(id);
    const queryFn = ({ signal })=>getOutsideAccountById(id, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetOutsideAccountByIdSuspense(id, options, queryClient) {
    const queryOptions = getGetOutsideAccountByIdSuspenseQueryOptions(id, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchOutsideAccount = (id, patchOutsideAccountReq, signal)=>{
    return client({
        url: `/api/v3/outside-accounts/${id}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchOutsideAccountReq,
        signal
    });
};
export const getPatchOutsideAccountMutationKey = ()=>[
        'patchOutsideAccount'
    ];
export const getPatchOutsideAccountMutationOptions = (options)=>{
    const mutationKey = getPatchOutsideAccountMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { id, data } = props ?? {};
        return patchOutsideAccount(id, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchOutsideAccount = (options, queryClient)=>{
    return useMutation(getPatchOutsideAccountMutationOptions(options), queryClient);
};
export const postParticipantApp = (postParticipantAppBody, signal)=>{
    return client({
        url: `/api/v3/participant-apps`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postParticipantAppBody,
        signal
    });
};
export const getPostParticipantAppMutationKey = ()=>[
        'postParticipantApp'
    ];
export const getPostParticipantAppMutationOptions = (options)=>{
    const mutationKey = getPostParticipantAppMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantApp(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantApp = (options, queryClient)=>{
    return useMutation(getPostParticipantAppMutationOptions(options), queryClient);
};
export const submitIncomeActivationToCarrier = (submitIncomeActivationToCarrierBody, signal)=>{
    return client({
        url: `/api/v3/participant-apps/income-activation/submit-to-carrier`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: submitIncomeActivationToCarrierBody,
        signal
    });
};
export const getSubmitIncomeActivationToCarrierMutationKey = ()=>[
        'submitIncomeActivationToCarrier'
    ];
export const getSubmitIncomeActivationToCarrierMutationOptions = (options)=>{
    const mutationKey = getSubmitIncomeActivationToCarrierMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return submitIncomeActivationToCarrier(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useSubmitIncomeActivationToCarrier = (options, queryClient)=>{
    return useMutation(getSubmitIncomeActivationToCarrierMutationOptions(options), queryClient);
};
export const getParticipant = (participantId, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantQueryKey = (participantId)=>{
    return [
        `/api/v3/participant/${participantId}`
    ];
};
export const getGetParticipantQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipant(participantId, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipant(participantId, options, queryClient) {
    const queryOptions = getGetParticipantQueryOptions(participantId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantSuspenseQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipant(participantId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantSuspense(participantId, options, queryClient) {
    const queryOptions = getGetParticipantSuspenseQueryOptions(participantId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchParticipant = (participantId, patchParticipantBody, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchParticipantBody,
        params,
        signal
    });
};
export const getPatchParticipantMutationKey = ()=>[
        'patchParticipant'
    ];
export const getPatchParticipantMutationOptions = (options)=>{
    const mutationKey = getPatchParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { participantId, data, params } = props ?? {};
        return patchParticipant(participantId, data, params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipant = (options, queryClient)=>{
    return useMutation(getPatchParticipantMutationOptions(options), queryClient);
};
export const getParticipantAllocationsWithFunds = (participantId, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/allocations-with-funds`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantAllocationsWithFundsQueryKey = (participantId, params)=>{
    return [
        `/api/v3/participant/${participantId}/allocations-with-funds`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantAllocationsWithFundsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAllocationsWithFundsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantAllocationsWithFunds(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantAllocationsWithFunds(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantAllocationsWithFundsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantAllocationsWithFundsSuspenseQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAllocationsWithFundsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantAllocationsWithFunds(participantId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantAllocationsWithFundsSuspense(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantAllocationsWithFundsSuspenseQueryOptions(participantId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantAppByType = (participantId, appType, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/apps/${appType}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantAppByTypeQueryKey = (participantId, appType, params)=>{
    return [
        `/api/v3/participant/${participantId}/apps/${appType}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantAppByTypeQueryOptions = (participantId, appType, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAppByTypeQueryKey(participantId, appType, params);
    const queryFn = ({ signal })=>getParticipantAppByType(participantId, appType, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined && appType !== null && appType !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantAppByType(participantId, appType, params, options, queryClient) {
    const queryOptions = getGetParticipantAppByTypeQueryOptions(participantId, appType, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantAppByTypeSuspenseQueryOptions = (participantId, appType, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAppByTypeQueryKey(participantId, appType, params);
    const queryFn = ({ signal })=>getParticipantAppByType(participantId, appType, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantAppByTypeSuspense(participantId, appType, params, options, queryClient) {
    const queryOptions = getGetParticipantAppByTypeSuspenseQueryOptions(participantId, appType, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantExploreDetails = (participantId, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/explore-details`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantExploreDetailsQueryKey = (participantId)=>{
    return [
        `/api/v3/participant/${participantId}/explore-details`
    ];
};
export const getGetParticipantExploreDetailsQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantExploreDetailsQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipantExploreDetails(participantId, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantExploreDetails(participantId, options, queryClient) {
    const queryOptions = getGetParticipantExploreDetailsQueryOptions(participantId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantExploreDetailsSuspenseQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantExploreDetailsQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipantExploreDetails(participantId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantExploreDetailsSuspense(participantId, options, queryClient) {
    const queryOptions = getGetParticipantExploreDetailsSuspenseQueryOptions(participantId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchParticipantExploreDetails = (participantId, patchParticipantExploreDetailsBody, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/explore-details`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchParticipantExploreDetailsBody,
        signal
    });
};
export const getPatchParticipantExploreDetailsMutationKey = ()=>[
        'patchParticipantExploreDetails'
    ];
export const getPatchParticipantExploreDetailsMutationOptions = (options)=>{
    const mutationKey = getPatchParticipantExploreDetailsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { participantId, data } = props ?? {};
        return patchParticipantExploreDetails(participantId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantExploreDetails = (options, queryClient)=>{
    return useMutation(getPatchParticipantExploreDetailsMutationOptions(options), queryClient);
};
export const getParticipantFundBalances = (participantId, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/fund-balances`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantFundBalancesQueryKey = (participantId)=>{
    return [
        `/api/v3/participant/${participantId}/fund-balances`
    ];
};
export const getGetParticipantFundBalancesQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundBalancesQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipantFundBalances(participantId, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantFundBalances(participantId, options, queryClient) {
    const queryOptions = getGetParticipantFundBalancesQueryOptions(participantId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantFundBalancesSuspenseQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundBalancesQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipantFundBalances(participantId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantFundBalancesSuspense(participantId, options, queryClient) {
    const queryOptions = getGetParticipantFundBalancesSuspenseQueryOptions(participantId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantFundsWithAllocations = (participantId, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/funds-with-allocations`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantFundsWithAllocationsQueryKey = (participantId, params)=>{
    return [
        `/api/v3/participant/${participantId}/funds-with-allocations`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantFundsWithAllocationsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundsWithAllocationsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantFundsWithAllocations(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantFundsWithAllocations(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantFundsWithAllocationsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantFundsWithAllocationsSuspenseQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundsWithAllocationsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantFundsWithAllocations(participantId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantFundsWithAllocationsSuspense(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantFundsWithAllocationsSuspenseQueryOptions(participantId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantInvestmentVehicleAdvisorPaths = (participantId, investmentVehicleId, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/investment-vehicles/${investmentVehicleId}/investment-vehicle-advisor-paths`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantInvestmentVehicleAdvisorPathsQueryKey = (participantId, investmentVehicleId, params)=>{
    return [
        `/api/v3/participant/${participantId}/investment-vehicles/${investmentVehicleId}/investment-vehicle-advisor-paths`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantInvestmentVehicleAdvisorPathsQueryOptions = (participantId, investmentVehicleId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantInvestmentVehicleAdvisorPathsQueryKey(participantId, investmentVehicleId, params);
    const queryFn = ({ signal })=>getParticipantInvestmentVehicleAdvisorPaths(participantId, investmentVehicleId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined && investmentVehicleId !== null && investmentVehicleId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantInvestmentVehicleAdvisorPaths(participantId, investmentVehicleId, params, options, queryClient) {
    const queryOptions = getGetParticipantInvestmentVehicleAdvisorPathsQueryOptions(participantId, investmentVehicleId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantInvestmentVehicleAdvisorPathsSuspenseQueryOptions = (participantId, investmentVehicleId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantInvestmentVehicleAdvisorPathsQueryKey(participantId, investmentVehicleId, params);
    const queryFn = ({ signal })=>getParticipantInvestmentVehicleAdvisorPaths(participantId, investmentVehicleId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantInvestmentVehicleAdvisorPathsSuspense(participantId, investmentVehicleId, params, options, queryClient) {
    const queryOptions = getGetParticipantInvestmentVehicleAdvisorPathsSuspenseQueryOptions(participantId, investmentVehicleId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantOutsideAccounts = (participantId, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/outside-accounts`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantOutsideAccountsQueryKey = (participantId, params)=>{
    return [
        `/api/v3/participant/${participantId}/outside-accounts`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantOutsideAccountsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantOutsideAccountsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantOutsideAccounts(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantOutsideAccounts(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantOutsideAccountsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantOutsideAccountsSuspenseQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantOutsideAccountsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantOutsideAccounts(participantId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantOutsideAccountsSuspense(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantOutsideAccountsSuspenseQueryOptions(participantId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantPlanLogin = (participantId, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/plan-login`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantPlanLoginQueryKey = (participantId)=>{
    return [
        `/api/v3/participant/${participantId}/plan-login`
    ];
};
export const getGetParticipantPlanLoginQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlanLoginQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipantPlanLogin(participantId, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantPlanLogin(participantId, options, queryClient) {
    const queryOptions = getGetParticipantPlanLoginQueryOptions(participantId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantPlanLoginSuspenseQueryOptions = (participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlanLoginQueryKey(participantId);
    const queryFn = ({ signal })=>getParticipantPlanLogin(participantId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantPlanLoginSuspense(participantId, options, queryClient) {
    const queryOptions = getGetParticipantPlanLoginSuspenseQueryOptions(participantId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantPlans = (participantId, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantPlansQueryKey = (participantId, params)=>{
    return [
        `/api/v3/participant/${participantId}/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantPlansQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlansQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantPlans(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantPlans(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantPlansQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantPlansSuspenseQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlansQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantPlans(participantId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantPlansSuspense(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantPlansSuspenseQueryOptions(participantId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantPlanEnrollments = (participantId, planId, params, signal)=>{
    return client({
        url: `/api/v3/participant/${participantId}/plans/${planId}/enrollments`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantPlanEnrollmentsQueryKey = (participantId, planId, params)=>{
    return [
        `/api/v3/participant/${participantId}/plans/${planId}/enrollments`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantPlanEnrollmentsQueryOptions = (participantId, planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlanEnrollmentsQueryKey(participantId, planId, params);
    const queryFn = ({ signal })=>getParticipantPlanEnrollments(participantId, planId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined && planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantPlanEnrollments(participantId, planId, params, options, queryClient) {
    const queryOptions = getGetParticipantPlanEnrollmentsQueryOptions(participantId, planId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantPlanEnrollmentsSuspenseQueryOptions = (participantId, planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlanEnrollmentsQueryKey(participantId, planId, params);
    const queryFn = ({ signal })=>getParticipantPlanEnrollments(participantId, planId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantPlanEnrollmentsSuspense(participantId, planId, params, options, queryClient) {
    const queryOptions = getGetParticipantPlanEnrollmentsSuspenseQueryOptions(participantId, planId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantFunds = (participantId, params, signal)=>{
    return client({
        url: `/api/v3/participants/${participantId}/funds`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantFundsQueryKey = (participantId, params)=>{
    return [
        `/api/v3/participants/${participantId}/funds`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantFundsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantFunds(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantFunds(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantFundsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantFundsSuspenseQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantFunds(participantId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantFundsSuspense(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantFundsSuspenseQueryOptions(participantId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantCompetingFunds = (participantId, params, signal)=>{
    return client({
        url: `/api/v3/participants/${participantId}/funds/competing`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantCompetingFundsQueryKey = (participantId, params)=>{
    return [
        `/api/v3/participants/${participantId}/funds/competing`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantCompetingFundsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantCompetingFundsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantCompetingFunds(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantCompetingFunds(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantCompetingFundsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantCompetingFundsSuspenseQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantCompetingFundsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getParticipantCompetingFunds(participantId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantCompetingFundsSuspense(participantId, params, options, queryClient) {
    const queryOptions = getGetParticipantCompetingFundsSuspenseQueryOptions(participantId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantFund = (participantId, fundId, params, signal)=>{
    return client({
        url: `/api/v3/participants/${participantId}/funds/${fundId}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantFundQueryKey = (participantId, fundId, params)=>{
    return [
        `/api/v3/participants/${participantId}/funds/${fundId}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantFundQueryOptions = (participantId, fundId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundQueryKey(participantId, fundId, params);
    const queryFn = ({ signal })=>getParticipantFund(participantId, fundId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: participantId !== null && participantId !== undefined && fundId !== null && fundId !== undefined,
        ...queryOptions
    };
};
export function useGetParticipantFund(participantId, fundId, params, options, queryClient) {
    const queryOptions = getGetParticipantFundQueryOptions(participantId, fundId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantFundSuspenseQueryOptions = (participantId, fundId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundQueryKey(participantId, fundId, params);
    const queryFn = ({ signal })=>getParticipantFund(participantId, fundId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantFundSuspense(participantId, fundId, params, options, queryClient) {
    const queryOptions = getGetParticipantFundSuspenseQueryOptions(participantId, fundId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postParticipantSync = (postParticipantSyncReq, signal)=>{
    return client({
        url: `/api/v3/pcs/sync`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postParticipantSyncReq,
        signal
    });
};
export const getPostParticipantSyncMutationKey = ()=>[
        'postParticipantSync'
    ];
export const getPostParticipantSyncMutationOptions = (options)=>{
    const mutationKey = getPostParticipantSyncMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantSync(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantSync = (options, queryClient)=>{
    return useMutation(getPostParticipantSyncMutationOptions(options), queryClient);
};
export const postPlanEnrollmentOptOut = (planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/plan-enrollment-state/${planEnrollmentId}/opt-out`,
        method: 'POST',
        signal
    });
};
export const getPostPlanEnrollmentOptOutMutationKey = ()=>[
        'postPlanEnrollmentOptOut'
    ];
export const getPostPlanEnrollmentOptOutMutationOptions = (options)=>{
    const mutationKey = getPostPlanEnrollmentOptOutMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planEnrollmentId } = props ?? {};
        return postPlanEnrollmentOptOut(planEnrollmentId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEnrollmentOptOut = (options, queryClient)=>{
    return useMutation(getPostPlanEnrollmentOptOutMutationOptions(options), queryClient);
};
export const getPlanEnrollment = (planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEnrollmentQueryKey = (planEnrollmentId)=>{
    return [
        `/api/v3/plan-enrollments/${planEnrollmentId}`
    ];
};
export const getGetPlanEnrollmentQueryOptions = (planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEnrollmentQueryKey(planEnrollmentId);
    const queryFn = ({ signal })=>getPlanEnrollment(planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetPlanEnrollment(planEnrollmentId, options, queryClient) {
    const queryOptions = getGetPlanEnrollmentQueryOptions(planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanEnrollmentSuspenseQueryOptions = (planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEnrollmentQueryKey(planEnrollmentId);
    const queryFn = ({ signal })=>getPlanEnrollment(planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanEnrollmentSuspense(planEnrollmentId, options, queryClient) {
    const queryOptions = getGetPlanEnrollmentSuspenseQueryOptions(planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchPlanEnrollment = (planEnrollmentId, patchPlanEnrollmentBody, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchPlanEnrollmentBody,
        signal
    });
};
export const getPatchPlanEnrollmentMutationKey = ()=>[
        'patchPlanEnrollment'
    ];
export const getPatchPlanEnrollmentMutationOptions = (options)=>{
    const mutationKey = getPatchPlanEnrollmentMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planEnrollmentId, data } = props ?? {};
        return patchPlanEnrollment(planEnrollmentId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchPlanEnrollment = (options, queryClient)=>{
    return useMutation(getPatchPlanEnrollmentMutationOptions(options), queryClient);
};
export const postPlanEnrollmentAuthorization = (planEnrollmentId, postPlanEnrollmentAuthorizationBody, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/authorization`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanEnrollmentAuthorizationBody,
        signal
    });
};
export const getPostPlanEnrollmentAuthorizationMutationKey = ()=>[
        'postPlanEnrollmentAuthorization'
    ];
export const getPostPlanEnrollmentAuthorizationMutationOptions = (options)=>{
    const mutationKey = getPostPlanEnrollmentAuthorizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planEnrollmentId, data } = props ?? {};
        return postPlanEnrollmentAuthorization(planEnrollmentId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEnrollmentAuthorization = (options, queryClient)=>{
    return useMutation(getPostPlanEnrollmentAuthorizationMutationOptions(options), queryClient);
};
export const postPlanEnrollmentFinalization = (planEnrollmentId, params, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/finalization`,
        method: 'POST',
        params,
        signal
    });
};
export const getPostPlanEnrollmentFinalizationMutationKey = ()=>[
        'postPlanEnrollmentFinalization'
    ];
export const getPostPlanEnrollmentFinalizationMutationOptions = (options)=>{
    const mutationKey = getPostPlanEnrollmentFinalizationMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planEnrollmentId, params } = props ?? {};
        return postPlanEnrollmentFinalization(planEnrollmentId, params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEnrollmentFinalization = (options, queryClient)=>{
    return useMutation(getPostPlanEnrollmentFinalizationMutationOptions(options), queryClient);
};
export const getFullPlanEnrollment = (planEnrollmentId, params, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/full`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFullPlanEnrollmentQueryKey = (planEnrollmentId, params)=>{
    return [
        `/api/v3/plan-enrollments/${planEnrollmentId}/full`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFullPlanEnrollmentQueryOptions = (planEnrollmentId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFullPlanEnrollmentQueryKey(planEnrollmentId, params);
    const queryFn = ({ signal })=>getFullPlanEnrollment(planEnrollmentId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetFullPlanEnrollment(planEnrollmentId, params, options, queryClient) {
    const queryOptions = getGetFullPlanEnrollmentQueryOptions(planEnrollmentId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFullPlanEnrollmentSuspenseQueryOptions = (planEnrollmentId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFullPlanEnrollmentQueryKey(planEnrollmentId, params);
    const queryFn = ({ signal })=>getFullPlanEnrollment(planEnrollmentId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFullPlanEnrollmentSuspense(planEnrollmentId, params, options, queryClient) {
    const queryOptions = getGetFullPlanEnrollmentSuspenseQueryOptions(planEnrollmentId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPlanEnrollmentIve = (planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/ive`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEnrollmentIveQueryKey = (planEnrollmentId)=>{
    return [
        `/api/v3/plan-enrollments/${planEnrollmentId}/ive`
    ];
};
export const getGetPlanEnrollmentIveQueryOptions = (planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEnrollmentIveQueryKey(planEnrollmentId);
    const queryFn = ({ signal })=>getPlanEnrollmentIve(planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetPlanEnrollmentIve(planEnrollmentId, options, queryClient) {
    const queryOptions = getGetPlanEnrollmentIveQueryOptions(planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanEnrollmentIveSuspenseQueryOptions = (planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEnrollmentIveQueryKey(planEnrollmentId);
    const queryFn = ({ signal })=>getPlanEnrollmentIve(planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanEnrollmentIveSuspense(planEnrollmentId, options, queryClient) {
    const queryOptions = getGetPlanEnrollmentIveSuspenseQueryOptions(planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postMapDefault = (planEnrollmentId, postMapDefaultBody, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/map-default`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMapDefaultBody,
        signal
    });
};
export const getPostMapDefaultMutationKey = ()=>[
        'postMapDefault'
    ];
export const getPostMapDefaultMutationOptions = (options)=>{
    const mutationKey = getPostMapDefaultMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planEnrollmentId, data } = props ?? {};
        return postMapDefault(planEnrollmentId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMapDefault = (options, queryClient)=>{
    return useMutation(getPostMapDefaultMutationOptions(options), queryClient);
};
export const postMapOptOut = (planEnrollmentId, postMapOptOutBody, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/map-opt-out`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postMapOptOutBody,
        signal
    });
};
export const getPostMapOptOutMutationKey = ()=>[
        'postMapOptOut'
    ];
export const getPostMapOptOutMutationOptions = (options)=>{
    const mutationKey = getPostMapOptOutMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planEnrollmentId, data } = props ?? {};
        return postMapOptOut(planEnrollmentId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostMapOptOut = (options, queryClient)=>{
    return useMutation(getPostMapOptOutMutationOptions(options), queryClient);
};
export const getPlanEnrollmentSurvey = (planEnrollmentId, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/survey`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEnrollmentSurveyQueryKey = (planEnrollmentId)=>{
    return [
        `/api/v3/plan-enrollments/${planEnrollmentId}/survey`
    ];
};
export const getGetPlanEnrollmentSurveyQueryOptions = (planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEnrollmentSurveyQueryKey(planEnrollmentId);
    const queryFn = ({ signal })=>getPlanEnrollmentSurvey(planEnrollmentId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planEnrollmentId !== null && planEnrollmentId !== undefined,
        ...queryOptions
    };
};
export function useGetPlanEnrollmentSurvey(planEnrollmentId, options, queryClient) {
    const queryOptions = getGetPlanEnrollmentSurveyQueryOptions(planEnrollmentId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanEnrollmentSurveySuspenseQueryOptions = (planEnrollmentId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEnrollmentSurveyQueryKey(planEnrollmentId);
    const queryFn = ({ signal })=>getPlanEnrollmentSurvey(planEnrollmentId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanEnrollmentSurveySuspense(planEnrollmentId, options, queryClient) {
    const queryOptions = getGetPlanEnrollmentSurveySuspenseQueryOptions(planEnrollmentId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const updatePlanEnrollmentSurvey = (planEnrollmentId, updatePlanEnrollmentSurveyBody, signal)=>{
    return client({
        url: `/api/v3/plan-enrollments/${planEnrollmentId}/survey`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: updatePlanEnrollmentSurveyBody,
        signal
    });
};
export const getUpdatePlanEnrollmentSurveyMutationKey = ()=>[
        'updatePlanEnrollmentSurvey'
    ];
export const getUpdatePlanEnrollmentSurveyMutationOptions = (options)=>{
    const mutationKey = getUpdatePlanEnrollmentSurveyMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planEnrollmentId, data } = props ?? {};
        return updatePlanEnrollmentSurvey(planEnrollmentId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useUpdatePlanEnrollmentSurvey = (options, queryClient)=>{
    return useMutation(getUpdatePlanEnrollmentSurveyMutationOptions(options), queryClient);
};
export const deletePlan = (planId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}`,
        method: 'DELETE',
        signal
    });
};
export const getDeletePlanMutationKey = ()=>[
        'deletePlan'
    ];
export const getDeletePlanMutationOptions = (options)=>{
    const mutationKey = getDeletePlanMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return deletePlan(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePlan = (options, queryClient)=>{
    return useMutation(getDeletePlanMutationOptions(options), queryClient);
};
export const getPlan = (planId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}`,
        method: 'GET',
        signal
    });
};
export const getGetPlanQueryKey = (planId)=>{
    return [
        `/api/v3/plans/${planId}`
    ];
};
export const getGetPlanQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanQueryKey(planId);
    const queryFn = ({ signal })=>getPlan(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetPlan(planId, options, queryClient) {
    const queryOptions = getGetPlanQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanQueryKey(planId);
    const queryFn = ({ signal })=>getPlan(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanSuspense(planId, options, queryClient) {
    const queryOptions = getGetPlanSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchPlan = (planId, patchPlanBody, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchPlanBody,
        signal
    });
};
export const getPatchPlanMutationKey = ()=>[
        'patchPlan'
    ];
export const getPatchPlanMutationOptions = (options)=>{
    const mutationKey = getPatchPlanMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { planId, data } = props ?? {};
        return patchPlan(planId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchPlan = (options, queryClient)=>{
    return useMutation(getPatchPlanMutationOptions(options), queryClient);
};
export const getAdvisorsOfPlan = (planId, params, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}/advisors`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorsOfPlanQueryKey = (planId, params)=>{
    return [
        `/api/v3/plans/${planId}/advisors`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorsOfPlanQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorsOfPlanQueryKey(planId, params);
    const queryFn = ({ signal })=>getAdvisorsOfPlan(planId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetAdvisorsOfPlan(planId, params, options, queryClient) {
    const queryOptions = getGetAdvisorsOfPlanQueryOptions(planId, params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetAdvisorsOfPlanSuspenseQueryOptions = (planId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorsOfPlanQueryKey(planId, params);
    const queryFn = ({ signal })=>getAdvisorsOfPlan(planId, params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetAdvisorsOfPlanSuspense(planId, params, options, queryClient) {
    const queryOptions = getGetAdvisorsOfPlanSuspenseQueryOptions(planId, params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPrimaryAdvisorOfPlan = (planId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}/advisors/primary`,
        method: 'GET',
        signal
    });
};
export const getGetPrimaryAdvisorOfPlanQueryKey = (planId)=>{
    return [
        `/api/v3/plans/${planId}/advisors/primary`
    ];
};
export const getGetPrimaryAdvisorOfPlanQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPrimaryAdvisorOfPlanQueryKey(planId);
    const queryFn = ({ signal })=>getPrimaryAdvisorOfPlan(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetPrimaryAdvisorOfPlan(planId, options, queryClient) {
    const queryOptions = getGetPrimaryAdvisorOfPlanQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPrimaryAdvisorOfPlanSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPrimaryAdvisorOfPlanQueryKey(planId);
    const queryFn = ({ signal })=>getPrimaryAdvisorOfPlan(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPrimaryAdvisorOfPlanSuspense(planId, options, queryClient) {
    const queryOptions = getGetPrimaryAdvisorOfPlanSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPlanIntegration = (planId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}/integration`,
        method: 'GET',
        signal
    });
};
export const getGetPlanIntegrationQueryKey = (planId)=>{
    return [
        `/api/v3/plans/${planId}/integration`
    ];
};
export const getGetPlanIntegrationQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanIntegrationQueryKey(planId);
    const queryFn = ({ signal })=>getPlanIntegration(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetPlanIntegration(planId, options, queryClient) {
    const queryOptions = getGetPlanIntegrationQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanIntegrationSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanIntegrationQueryKey(planId);
    const queryFn = ({ signal })=>getPlanIntegration(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanIntegrationSuspense(planId, options, queryClient) {
    const queryOptions = getGetPlanIntegrationSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getMainInvestmentVehicleOfPlan = (planId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}/investment-vehicles/main`,
        method: 'GET',
        signal
    });
};
export const getGetMainInvestmentVehicleOfPlanQueryKey = (planId)=>{
    return [
        `/api/v3/plans/${planId}/investment-vehicles/main`
    ];
};
export const getGetMainInvestmentVehicleOfPlanQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMainInvestmentVehicleOfPlanQueryKey(planId);
    const queryFn = ({ signal })=>getMainInvestmentVehicleOfPlan(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetMainInvestmentVehicleOfPlan(planId, options, queryClient) {
    const queryOptions = getGetMainInvestmentVehicleOfPlanQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetMainInvestmentVehicleOfPlanSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMainInvestmentVehicleOfPlanQueryKey(planId);
    const queryFn = ({ signal })=>getMainInvestmentVehicleOfPlan(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetMainInvestmentVehicleOfPlanSuspense(planId, options, queryClient) {
    const queryOptions = getGetMainInvestmentVehicleOfPlanSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getPlanIraProspectPlanRef = (planId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}/ira-prospect-plan-ref`,
        method: 'GET',
        signal
    });
};
export const getGetPlanIraProspectPlanRefQueryKey = (planId)=>{
    return [
        `/api/v3/plans/${planId}/ira-prospect-plan-ref`
    ];
};
export const getGetPlanIraProspectPlanRefQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanIraProspectPlanRefQueryKey(planId);
    const queryFn = ({ signal })=>getPlanIraProspectPlanRef(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetPlanIraProspectPlanRef(planId, options, queryClient) {
    const queryOptions = getGetPlanIraProspectPlanRefQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetPlanIraProspectPlanRefSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanIraProspectPlanRefQueryKey(planId);
    const queryFn = ({ signal })=>getPlanIraProspectPlanRef(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetPlanIraProspectPlanRefSuspense(planId, options, queryClient) {
    const queryOptions = getGetPlanIraProspectPlanRefSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const impersonateParticipant = (planId, participantId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}/participants/${participantId}/impersonate`,
        method: 'GET',
        signal
    });
};
export const getImpersonateParticipantQueryKey = (planId, participantId)=>{
    return [
        `/api/v3/plans/${planId}/participants/${participantId}/impersonate`
    ];
};
export const getImpersonateParticipantQueryOptions = (planId, participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getImpersonateParticipantQueryKey(planId, participantId);
    const queryFn = ({ signal })=>impersonateParticipant(planId, participantId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined && participantId !== null && participantId !== undefined,
        ...queryOptions
    };
};
export function useImpersonateParticipant(planId, participantId, options, queryClient) {
    const queryOptions = getImpersonateParticipantQueryOptions(planId, participantId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getImpersonateParticipantSuspenseQueryOptions = (planId, participantId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getImpersonateParticipantQueryKey(planId, participantId);
    const queryFn = ({ signal })=>impersonateParticipant(planId, participantId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useImpersonateParticipantSuspense(planId, participantId, options, queryClient) {
    const queryOptions = getImpersonateParticipantSuspenseQueryOptions(planId, participantId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getRolloverPlanOfPlan = (planId, signal)=>{
    return client({
        url: `/api/v3/plans/${planId}/plan-rollover`,
        method: 'GET',
        signal
    });
};
export const getGetRolloverPlanOfPlanQueryKey = (planId)=>{
    return [
        `/api/v3/plans/${planId}/plan-rollover`
    ];
};
export const getGetRolloverPlanOfPlanQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRolloverPlanOfPlanQueryKey(planId);
    const queryFn = ({ signal })=>getRolloverPlanOfPlan(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: planId !== null && planId !== undefined,
        ...queryOptions
    };
};
export function useGetRolloverPlanOfPlan(planId, options, queryClient) {
    const queryOptions = getGetRolloverPlanOfPlanQueryOptions(planId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetRolloverPlanOfPlanSuspenseQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRolloverPlanOfPlanQueryKey(planId);
    const queryFn = ({ signal })=>getRolloverPlanOfPlan(planId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetRolloverPlanOfPlanSuspense(planId, options, queryClient) {
    const queryOptions = getGetRolloverPlanOfPlanSuspenseQueryOptions(planId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postReliusParticipantLiteSync = (reliusLiteSyncReq, signal)=>{
    return client({
        url: `/api/v3/relius/participant-lite-sync`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: reliusLiteSyncReq,
        signal
    });
};
export const getPostReliusParticipantLiteSyncMutationKey = ()=>[
        'postReliusParticipantLiteSync'
    ];
export const getPostReliusParticipantLiteSyncMutationOptions = (options)=>{
    const mutationKey = getPostReliusParticipantLiteSyncMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postReliusParticipantLiteSync(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostReliusParticipantLiteSync = (options, queryClient)=>{
    return useMutation(getPostReliusParticipantLiteSyncMutationOptions(options), queryClient);
};
export const getCreateReliusUserForIraAccountOpening = (params, signal)=>{
    return client({
        url: `/api/v3/relius/participant/ira-account-opening`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCreateReliusUserForIraAccountOpeningQueryKey = (params)=>{
    return [
        `/api/v3/relius/participant/ira-account-opening`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCreateReliusUserForIraAccountOpeningQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCreateReliusUserForIraAccountOpeningQueryKey(params);
    const queryFn = ({ signal })=>getCreateReliusUserForIraAccountOpening(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetCreateReliusUserForIraAccountOpening(params, options, queryClient) {
    const queryOptions = getGetCreateReliusUserForIraAccountOpeningQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetCreateReliusUserForIraAccountOpeningSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCreateReliusUserForIraAccountOpeningQueryKey(params);
    const queryFn = ({ signal })=>getCreateReliusUserForIraAccountOpening(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetCreateReliusUserForIraAccountOpeningSuspense(params, options, queryClient) {
    const queryOptions = getGetCreateReliusUserForIraAccountOpeningSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postPrpPdf = (postPrpPdfBody, signal)=>{
    return client({
        url: `/api/v3/reports/prp/pdf`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPrpPdfBody,
        signal
    });
};
export const getPostPrpPdfMutationKey = ()=>[
        'postPrpPdf'
    ];
export const getPostPrpPdfMutationOptions = (options)=>{
    const mutationKey = getPostPrpPdfMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPrpPdf(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPrpPdf = (options, queryClient)=>{
    return useMutation(getPostPrpPdfMutationOptions(options), queryClient);
};
export const postSuitabilityPdf = (renderSuitabilityReportReq, signal)=>{
    return client({
        url: `/api/v3/reports/suitability/pdf`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: renderSuitabilityReportReq,
        signal
    });
};
export const getPostSuitabilityPdfMutationKey = ()=>[
        'postSuitabilityPdf'
    ];
export const getPostSuitabilityPdfMutationOptions = (options)=>{
    const mutationKey = getPostSuitabilityPdfMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSuitabilityPdf(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSuitabilityPdf = (options, queryClient)=>{
    return useMutation(getPostSuitabilityPdfMutationOptions(options), queryClient);
};
export const getRtqSurvey = (rtqSurveyId, signal)=>{
    return client({
        url: `/api/v3/rtq-surveys/${rtqSurveyId}`,
        method: 'GET',
        signal
    });
};
export const getGetRtqSurveyQueryKey = (rtqSurveyId)=>{
    return [
        `/api/v3/rtq-surveys/${rtqSurveyId}`
    ];
};
export const getGetRtqSurveyQueryOptions = (rtqSurveyId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRtqSurveyQueryKey(rtqSurveyId);
    const queryFn = ({ signal })=>getRtqSurvey(rtqSurveyId, signal);
    return {
        queryKey,
        queryFn,
        enabled: rtqSurveyId !== null && rtqSurveyId !== undefined,
        ...queryOptions
    };
};
export function useGetRtqSurvey(rtqSurveyId, options, queryClient) {
    const queryOptions = getGetRtqSurveyQueryOptions(rtqSurveyId, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetRtqSurveySuspenseQueryOptions = (rtqSurveyId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRtqSurveyQueryKey(rtqSurveyId);
    const queryFn = ({ signal })=>getRtqSurvey(rtqSurveyId, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetRtqSurveySuspense(rtqSurveyId, options, queryClient) {
    const queryOptions = getGetRtqSurveySuspenseQueryOptions(rtqSurveyId, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const postPcsSsoCallback = (signal)=>{
    return client({
        url: `/api/v3/saml/login`,
        method: 'POST',
        signal
    });
};
export const getPostPcsSsoCallbackMutationKey = ()=>[
        'postPcsSsoCallback'
    ];
export const getPostPcsSsoCallbackMutationOptions = (options)=>{
    const mutationKey = getPostPcsSsoCallbackMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = ()=>{
        return postPcsSsoCallback();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPcsSsoCallback = (options, queryClient)=>{
    return useMutation(getPostPcsSsoCallbackMutationOptions(options), queryClient);
};
export const getFinancialTransactions = (params, signal)=>{
    return client({
        url: `/api/v3/spark/financial-transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFinancialTransactionsQueryKey = (params)=>{
    return [
        `/api/v3/spark/financial-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFinancialTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFinancialTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getFinancialTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetFinancialTransactions(params, options, queryClient) {
    const queryOptions = getGetFinancialTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetFinancialTransactionsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFinancialTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getFinancialTransactions(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetFinancialTransactionsSuspense(params, options, queryClient) {
    const queryOptions = getGetFinancialTransactionsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getIndicativeData = (params, signal)=>{
    return client({
        url: `/api/v3/spark/indicative-data`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetIndicativeDataQueryKey = (params)=>{
    return [
        `/api/v3/spark/indicative-data`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetIndicativeDataQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIndicativeDataQueryKey(params);
    const queryFn = ({ signal })=>getIndicativeData(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetIndicativeData(params, options, queryClient) {
    const queryOptions = getGetIndicativeDataQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetIndicativeDataSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetIndicativeDataQueryKey(params);
    const queryFn = ({ signal })=>getIndicativeData(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetIndicativeDataSuspense(params, options, queryClient) {
    const queryOptions = getGetIndicativeDataSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getParticipantFundBalance = (params, signal)=>{
    return client({
        url: `/api/v3/spark/participant-fund-balance`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantFundBalanceQueryKey = (params)=>{
    return [
        `/api/v3/spark/participant-fund-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantFundBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundBalanceQueryKey(params);
    const queryFn = ({ signal })=>getParticipantFundBalance(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetParticipantFundBalance(params, options, queryClient) {
    const queryOptions = getGetParticipantFundBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetParticipantFundBalanceSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFundBalanceQueryKey(params);
    const queryFn = ({ signal })=>getParticipantFundBalance(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetParticipantFundBalanceSuspense(params, options, queryClient) {
    const queryOptions = getGetParticipantFundBalanceSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getStaticOptions = (type, signal)=>{
    return client({
        url: `/api/v3/static-options/${type}`,
        method: 'GET',
        signal
    });
};
export const getGetStaticOptionsQueryKey = (type)=>{
    return [
        `/api/v3/static-options/${type}`
    ];
};
export const getGetStaticOptionsQueryOptions = (type, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStaticOptionsQueryKey(type);
    const queryFn = ({ signal })=>getStaticOptions(type, signal);
    return {
        queryKey,
        queryFn,
        enabled: type !== null && type !== undefined,
        ...queryOptions
    };
};
export function useGetStaticOptions(type, options, queryClient) {
    const queryOptions = getGetStaticOptionsQueryOptions(type, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetStaticOptionsSuspenseQueryOptions = (type, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStaticOptionsQueryKey(type);
    const queryFn = ({ signal })=>getStaticOptions(type, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetStaticOptionsSuspense(type, options, queryClient) {
    const queryOptions = getGetStaticOptionsSuspenseQueryOptions(type, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getTcgParticipantBankAccounts = (params, signal)=>{
    return client({
        url: `/api/v3/tcg/participant_banking`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetTcgParticipantBankAccountsQueryKey = (params)=>{
    return [
        `/api/v3/tcg/participant_banking`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetTcgParticipantBankAccountsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTcgParticipantBankAccountsQueryKey(params);
    const queryFn = ({ signal })=>getTcgParticipantBankAccounts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetTcgParticipantBankAccounts(params, options, queryClient) {
    const queryOptions = getGetTcgParticipantBankAccountsQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetTcgParticipantBankAccountsSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTcgParticipantBankAccountsQueryKey(params);
    const queryFn = ({ signal })=>getTcgParticipantBankAccounts(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetTcgParticipantBankAccountsSuspense(params, options, queryClient) {
    const queryOptions = getGetTcgParticipantBankAccountsSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchTcgParticipantBanking = (patchTcgPaticipantBankingBody, signal)=>{
    return client({
        url: `/api/v3/tcg/participant_banking`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchTcgPaticipantBankingBody,
        signal
    });
};
export const getPatchTcgParticipantBankingMutationKey = ()=>[
        'patchTcgParticipantBanking'
    ];
export const getPatchTcgParticipantBankingMutationOptions = (options)=>{
    const mutationKey = getPatchTcgParticipantBankingMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchTcgParticipantBanking(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchTcgParticipantBanking = (options, queryClient)=>{
    return useMutation(getPatchTcgParticipantBankingMutationOptions(options), queryClient);
};
export const postTcgParticipantBanking = (postTcgParticipantBankingBody, signal)=>{
    return client({
        url: `/api/v3/tcg/participant_banking`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postTcgParticipantBankingBody,
        signal
    });
};
export const getPostTcgParticipantBankingMutationKey = ()=>[
        'postTcgParticipantBanking'
    ];
export const getPostTcgParticipantBankingMutationOptions = (options)=>{
    const mutationKey = getPostTcgParticipantBankingMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postTcgParticipantBanking(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostTcgParticipantBanking = (options, queryClient)=>{
    return useMutation(getPostTcgParticipantBankingMutationOptions(options), queryClient);
};
export const getTcgParticipantFunding = (params, signal)=>{
    return client({
        url: `/api/v3/tcg/participant_banking_funding`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetTcgParticipantFundingQueryKey = (params)=>{
    return [
        `/api/v3/tcg/participant_banking_funding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetTcgParticipantFundingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTcgParticipantFundingQueryKey(params);
    const queryFn = ({ signal })=>getTcgParticipantFunding(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetTcgParticipantFunding(params, options, queryClient) {
    const queryOptions = getGetTcgParticipantFundingQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetTcgParticipantFundingSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTcgParticipantFundingQueryKey(params);
    const queryFn = ({ signal })=>getTcgParticipantFunding(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetTcgParticipantFundingSuspense(params, options, queryClient) {
    const queryOptions = getGetTcgParticipantFundingSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchTcgParticipantFunding = (patchTcgParticipantBankingFundingBody, signal)=>{
    return client({
        url: `/api/v3/tcg/participant_banking_funding`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchTcgParticipantBankingFundingBody,
        signal
    });
};
export const getPatchTcgParticipantFundingMutationKey = ()=>[
        'patchTcgParticipantFunding'
    ];
export const getPatchTcgParticipantFundingMutationOptions = (options)=>{
    const mutationKey = getPatchTcgParticipantFundingMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchTcgParticipantFunding(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchTcgParticipantFunding = (options, queryClient)=>{
    return useMutation(getPatchTcgParticipantFundingMutationOptions(options), queryClient);
};
export const postTcgParticipantFunding = (postTcgParticipantBankingFundingBody, signal)=>{
    return client({
        url: `/api/v3/tcg/participant_banking_funding`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postTcgParticipantBankingFundingBody,
        signal
    });
};
export const getPostTcgParticipantFundingMutationKey = ()=>[
        'postTcgParticipantFunding'
    ];
export const getPostTcgParticipantFundingMutationOptions = (options)=>{
    const mutationKey = getPostTcgParticipantFundingMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postTcgParticipantFunding(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostTcgParticipantFunding = (options, queryClient)=>{
    return useMutation(getPostTcgParticipantFundingMutationOptions(options), queryClient);
};
export const getTcgParticipant = (params, signal)=>{
    return client({
        url: `/api/v3/tcg/participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetTcgParticipantQueryKey = (params)=>{
    return [
        `/api/v3/tcg/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetTcgParticipantQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTcgParticipantQueryKey(params);
    const queryFn = ({ signal })=>getTcgParticipant(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetTcgParticipant(params, options, queryClient) {
    const queryOptions = getGetTcgParticipantQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetTcgParticipantSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTcgParticipantQueryKey(params);
    const queryFn = ({ signal })=>getTcgParticipant(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetTcgParticipantSuspense(params, options, queryClient) {
    const queryOptions = getGetTcgParticipantSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const patchTcgParticipant = (patchTcgParticipantBody, signal)=>{
    return client({
        url: `/api/v3/tcg/participants`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchTcgParticipantBody,
        signal
    });
};
export const getPatchTcgParticipantMutationKey = ()=>[
        'patchTcgParticipant'
    ];
export const getPatchTcgParticipantMutationOptions = (options)=>{
    const mutationKey = getPatchTcgParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchTcgParticipant(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchTcgParticipant = (options, queryClient)=>{
    return useMutation(getPatchTcgParticipantMutationOptions(options), queryClient);
};
export const postTcgParticipant = (postTcgParticipantBody, signal)=>{
    return client({
        url: `/api/v3/tcg/participants`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postTcgParticipantBody,
        signal
    });
};
export const getPostTcgParticipantMutationKey = ()=>[
        'postTcgParticipant'
    ];
export const getPostTcgParticipantMutationOptions = (options)=>{
    const mutationKey = getPostTcgParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postTcgParticipant(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostTcgParticipant = (options, queryClient)=>{
    return useMutation(getPostTcgParticipantMutationOptions(options), queryClient);
};
export const postWebhookSendgridEvents = (postWebhookSendgridEventsBody, signal)=>{
    return client({
        url: `/api/v3/webhook/sendgrid/events`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postWebhookSendgridEventsBody,
        signal
    });
};
export const getPostWebhookSendgridEventsMutationKey = ()=>[
        'postWebhookSendgridEvents'
    ];
export const getPostWebhookSendgridEventsMutationOptions = (options)=>{
    const mutationKey = getPostWebhookSendgridEventsMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postWebhookSendgridEvents(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostWebhookSendgridEvents = (options, queryClient)=>{
    return useMutation(getPostWebhookSendgridEventsMutationOptions(options), queryClient);
};
export const postDecisionAnalysisReport = (decisionAnalysisReportWebhookDto, signal)=>{
    return client({
        url: `/api/v3/webhooks/broadridge/decision-analysis-report`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: decisionAnalysisReportWebhookDto,
        signal
    });
};
export const getPostDecisionAnalysisReportMutationKey = ()=>[
        'postDecisionAnalysisReport'
    ];
export const getPostDecisionAnalysisReportMutationOptions = (options)=>{
    const mutationKey = getPostDecisionAnalysisReportMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postDecisionAnalysisReport(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostDecisionAnalysisReport = (options, queryClient)=>{
    return useMutation(getPostDecisionAnalysisReportMutationOptions(options), queryClient);
};
export const postIraClarityAckKyc = (iraClarityAckKycWebhookDto, signal)=>{
    return client({
        url: `/api/v3/webhooks/ira-clarity/account-opening`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: iraClarityAckKycWebhookDto,
        signal
    });
};
export const getPostIraClarityAckKycMutationKey = ()=>[
        'postIraClarityAckKyc'
    ];
export const getPostIraClarityAckKycMutationOptions = (options)=>{
    const mutationKey = getPostIraClarityAckKycMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postIraClarityAckKyc(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIraClarityAckKyc = (options, queryClient)=>{
    return useMutation(getPostIraClarityAckKycMutationOptions(options), queryClient);
};
export const postProspectParticipant = (iraProspectParticipantWebhookReq, signal)=>{
    return client({
        url: `/api/v3/webhooks/ira-prospect-participants`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: iraProspectParticipantWebhookReq,
        signal
    });
};
export const getPostProspectParticipantMutationKey = ()=>[
        'postProspectParticipant'
    ];
export const getPostProspectParticipantMutationOptions = (options)=>{
    const mutationKey = getPostProspectParticipantMutationKey();
    const { mutation: mutationOptions } = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : {
        ...options,
        mutation: {
            ...options.mutation,
            mutationKey
        }
    } : {
        mutation: {
            mutationKey
        }
    };
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postProspectParticipant(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostProspectParticipant = (options, queryClient)=>{
    return useMutation(getPostProspectParticipantMutationOptions(options), queryClient);
};
export const getWhitelabel = (params, signal)=>{
    return client({
        url: `/api/v3/whitelabels`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetWhitelabelQueryKey = (params)=>{
    return [
        `/api/v3/whitelabels`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetWhitelabelQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWhitelabelQueryKey(params);
    const queryFn = ({ signal })=>getWhitelabel(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export function useGetWhitelabel(params, options, queryClient) {
    const queryOptions = getGetWhitelabelQueryOptions(params, options);
    const query = useQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}
export const getGetWhitelabelSuspenseQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWhitelabelQueryKey(params);
    const queryFn = ({ signal })=>getWhitelabel(params, signal);
    return queryOptionsBuilder({
        queryKey,
        ...queryOptions,
        queryFn: queryOptions?.queryFn ?? queryFn
    });
};
export function useGetWhitelabelSuspense(params, options, queryClient) {
    const queryOptions = getGetWhitelabelSuspenseQueryOptions(params, options);
    const query = useSuspenseQuery(queryOptions, queryClient);
    return withQueryKey(query, queryOptions.queryKey);
}

//# sourceMappingURL=index.js.map